export const MIXPANEL_DEVICE_USER_LINK = {
  api: {
    production: {
      '$device:19926191f7c14c4-094ea66dcafbc2-b457459-6ac5c-19926191f7d14c5':
        'e499f736-343b-4321-8bc2-b180cd5fd7ba',
      '$device:19925fc38fd4f6-0a46196572565f-b457459-5c094-19925fc38fe4f6':
        '5a399852-69a9-4374-8676-d821b5ec543c',
      '$device:1983a3fcadd38d-0c96b6699fd5228-540a4669-505c8-1983a3fcadd38d':
        'fc8d6e73-1d20-4956-9708-cc4d6d80e878',
      '$device:198370414e1cea-0f9a5abf449c67-b457458-3cd4d-198370414e1cea':
        '3eef4183-8fbf-40ff-9c12-ebcae0da7b6d',

      '$device:19925b8acab320-0ab6193ed8d4df-b457459-58d14-19925b8acab321':
        'b15986b8-0e9c-4a70-af16-6c919c1cb250',
      '$device:19925bccc40301-0cc5a13b290a2a8-284e012c-505c8-19925bccc40301':
        '2d3c0087-fb73-4920-a4b3-5d7265e3f0d6',
      '$device:19925ad3692b00-02de017ef9efb8-b457459-48481-19925ad3692b01':
        '861cd85b-6e09-4193-b935-3e516c0d2b48',
      '$device:199216c853f1d0-00c60537747fc4-27604a30-2c600-199216c853f1d0':
        '524c491c-b0e7-4ad1-b3a7-c7b74b953418',
      '$device:19907a00fe17c3-063f0cc6af2e9c-b457459-4e000-19907a00fe27c3':
        'f570a06a-3ee5-4db3-9b6a-41c6e2186a31',
      '$device:199258a8de53eb-01b1050ff9992f-b457459-4e000-199258a8de53eb':
        '3349ba79-0d6a-4bc0-b032-0d92da72fd60',
      '$device:1992581ec7c348-0ce9ba59884d7d8-7379356f-5a900-1992581ec7c348':
        '210e039c-9020-4069-9bb8-3b800ca3d175',
      '$device:199257f39a913c0-036211b177b105-b457459-4e000-199257f39aa13c0':
        '41cfc45a-60a0-4b69-a759-bd455b24e818',
      '$device:199256c2cdc436-0359c4f92f5e248-7379356f-36240-199256c2cdc436':
        'f8c94de2-8af7-47ea-80a9-7e1c50d3e21a',
      '$device:1992558b045169-05d87b243c0f0e-7379356f-66b20-1992558b045169':
        'ed3b1cb9-ba3e-48ba-85a0-46059872369d',
      '$device:19925520424398-0fcfcd175c3cef8-b457459-65400-19925520424398':
        'afe05fb0-b42e-49bf-a42f-ed38924916df',
      '$device:1992538c0d7857-03125b04e0ffc48-b457350-46d70-1992538c0d7858':
        '640469dc-471a-4f0c-956c-5aeed1317419',
      '$device:199252aaae222b-0448d7dee2a519-16525636-384000-199252aaae222b':
        '0554e18f-3d01-4898-8187-10eea29a61dd',
      '$device:1992524da513e8-0456e71c687844-b457459-50456-1992524da513e9':
        '14ea7d0f-e6ed-43f2-b4f7-6b78db678ac6',
      '$device:1992505059b2a9-0d644dc989b5df-7f773460-36240-1992505059b2a9':
        'df6ab655-4a49-48a0-9f1f-fb6fb7efc4cb',
      '$device:19924edfd135e6-0584d8b61e6447-134a153d-50456-19924edfd135e6':
        'bcf2163e-a843-4e46-b3e4-cbda074300ce',
      '$device:19924c414411d9-0f9e5814b4b0f1-7379356f-51bf4-19924c414411d9':
        '62cdc0a0-1962-4a56-960c-2cfe4b5a9745',
      '$device:19924b764433d8-02a5725e7ae5488-b457350-65400-19924b764443d9':
        'd1e61b9d-9314-4686-8a37-cd4eb3561f25',
      '$device:19924b1ec694900-0c43f36aee032e8-27604933-51bf4-19924b1ec694900':
        'b182ea56-3670-4bd4-bdb7-c9de8858a746',
      '$device:199246158c41a8-0fdd7f060f2cc-2a4e022c-61d78-199246158c41a8':
        '85ff9c87-8090-48b2-97fb-898e19f7ee58',
      '$device:19924561015747-0b11f98ab55d23-b457459-4e000-19924561016748':
        '01906032-16b2-4efe-9edb-8f1447eacecc',
      '$device:19924296abe1081-053cec8c6ef59f8-b457459-3bbaa-19924296ac01083':
        '67ad7f4a-b918-462e-b799-ee7db17fcd5e',
      '$device:19923b9c2622a6-00f1b1f97e700e-3862654b-5a900-19923b9c2622a6':
        '23065b6f-659f-497a-a0c9-3f6aa722ee2b',
      '$device:19923960fff8e0-0fd4a272e1b895-b457459-7f684-19923960fff8e0':
        'a76df1de-8a95-4830-89f2-8a17894ec52c',
      '$device:199235a91341233-06954eb008af99-b457459-4e000-199235a91341233':
        '7b99ac10-2118-4bdb-b0c1-e6e4b97046cd',
      '$device:19922bbca3028e-028c5f1f376f6-550e4263-5a900-19922bbca3028e':
        '33d921a5-8c7d-4981-bb80-e6b8d50db17e',
      '$device:199228b519e3c3-032bfcff096e738-b457459-48ef2-199228b519f3c3':
        '7751b37c-2c08-4f8a-b2a0-1c20aa14f286',
      '$device:1992256530836e-0f2e31ae3cb5d1-b457451-4e000-1992256530836e':
        '5d1d2bc9-cbab-4b69-9833-17312e56c99a',

      '$device:1992243777d249-06854520518967-7079356f-5a900-1992243777d24a':
        '1ad9c238-98fc-4a70-90a3-35fc17b5d197',
      '$device:19922222a6d3ef-088b826bf466f2-707c306f-2c600-19922222a6d3ef':
        'e1c61dba-8302-468c-ab29-e452bf37f9bf',
      '$device:19921f9090a367-0117ff3c716f588-5a004160-51bf4-19921f9090a367':
        '6cf0b656-91ee-4aaa-926c-a64106b5d847',
      '$device:19921b5d4e7273-0af270b0af4ffe-59064163-505c8-19921b5d4e7273':
        '8c7c286c-2d77-4b67-9b45-9428c6642030',
      '$device:199219c5c94514-067c5354d7de248-b457459-50580-199219c5c94514':
        'c6a8fe5b-1a46-4a8a-b0cb-9fe57ff5dc7c',
      '$device:19921917ddf380-01ec1997379cfe-2a4e022c-5a900-19921917ddf380':
        'cd50958b-20e4-40dd-889e-89a806cc8e61',
      '$device:199218fa051579-02844da9c174df8-7379356f-5a900-199218fa05157a':
        '9baa8739-5647-48be-9cf9-26a5d76d89ba',
      '$device:1992170632a5c7-08d53f6e3f90858-53054967-55c74-1992170632a5c7':
        '867f0fab-b6e5-4dd3-a215-ce850d82aad9',
      '$device:199216a08fa764-02cb61ccf504cb-b457459-4d400-199216a08fa765':
        '7ffb443e-a760-4e54-8b08-a897e77ddf01',
      '$device:199214137eb4b9-088be697cd8f1b-27604933-61d78-199214137eb4b9':
        '5d2f1f9b-aee2-4a67-a266-88527f931ad0',
      '$device:1991c966567394-071a73e8860ec9-7379356f-36240-1991c966567395':
        '04b33929-a3c4-4532-b650-f0f082e86751',
      '$device:1991b22e3ef26c-020c063678bf85-7f643058-61d78-1991b22e3ef26c':
        'eb664fff-9b24-4ed3-84f9-aebfdf592883',
      '$device:1992125894b147-02c8d9173b5a278-2a4e022c-505c8-1992125894b147':
        '698ccc74-751b-4bc2-b5be-6cf928aa0760',
      '$device:198e18e5e69250-009041be9bf8c18-27604a30-36240-198e18e5e69250':
        'e516078d-b87c-4091-acba-1c35311ac04f',
      '$device:19920fb0d7c323-0667b15d1dc1b68-570e4263-505c8-19920fb0d7c323':
        'f9d530d0-ea9b-4601-8557-48781ac9afd3',
      '$device:19920e591e074b-0a6d26700e5c-69157d6c-4e000-19920e591e074c':
        '5d1f595a-a2c2-4e62-98ec-c3aba0216878',
      '$device:19920cc6aa31f8-004fd0fbcad87f-7379356f-60c28-19920cc6aa31f8':
        '13eac84a-792f-46de-9bfa-fc7a26bdf91b',
      '$device:19920c9fdae365-0b6e354a0c88968-7379356f-2c600-19920c9fdae365':
        'fc71e214-91c9-41fc-96e1-992705c13cc3',
      '$device:19920c0010e283-0dd49beecf522f8-246e4935-5a900-19920c0010e283':
        'f81bd94c-ca13-4de3-b385-2945fead411b',
      '$device:198e1c9162737e-0eb0f135519d84-b457459-448e0-198e1c9162737e':
        '9a76f9f0-efd4-4b96-9bd4-0eb7fc1063b7',
      '$device:19920a358a7515-01e68c59ae4a3a8-b457459-5c094-19920a358a8516':
        '85f738cc-d8ab-441c-973c-8602e5eb7cfd',
      '$device:1992093e4d01132-031b04eafac8bf8-2a4e022c-51bf4-1992093e4d01132':
        '36939816-ed3b-47dc-8408-b07cae128e32',
      '$device:19920562357457-057223a22cf951-b457459-65400-19920562357457':
        'b4649987-d9b0-488c-aae8-27456d686879',
      '$device:19906e1cc4139d-0ef0b36d81873f8-50266b2b-65400-19906e1cc4139d':
        '402b20fc-ebd6-42a5-a11b-16b89a757911',
      '$device:19920366e2b3d4-0caa08e0d005f78-27604933-61d78-19920366e2b3d4':
        '85e735eb-b9fe-4046-8ccb-d384a1d681fb',
      '$device:1992009a52322c-03cfeff4ea39478-284e012c-55c74-1992009a52322c':
        '51641646-3561-4ee9-917c-abe8cbfdf0f5',
      '$device:19920097880477-0bd22d5b9d20678-570e4263-51bf4-19920097880477':
        'aecc26fd-b0f6-41a5-8c9f-699d20595f83',
      '$device:1991ffaedbc348-00fb9a252039d5-2a4e022c-36240-1991ffaedbc348':
        '4315f5fb-dbb3-43a5-b143-1085d197bca4',
      '$device:1991fd7e8f86de-058a8f9797e178-75173e01-5cbd8-1991fd7e8f96de':
        'ac947855-f97b-4cac-8ef8-45b1b423f3d6',
      '$device:1991fcd65b7314-00b329b7b895908-7379356f-505c8-1991fcd65b7314':
        '1ac8ad91-a164-4c90-a30c-ae5ac4ba0038',
      '$device:1991fc0192e637-094468a9e58bee-7b653c58-4a574-1991fc0192e637':
        '4e25fbb3-f4ae-4071-95e9-e5231cfcec72',
      '$device:1991d4e26da3b2-0a091aae99b73e-7379356f-61d78-1991d4e26da3b3':
        'd44b181e-eb9e-457d-a57c-e0ddfb79a54e',
      '$device:1991f8ce12c280-062edc6a875c138-7379356f-505c8-1991f8ce12c280':
        '589db28a-5105-49e4-ada8-d061b0c45eaa',
      '$device:1990079ea241204-0b7b77c40ccae38-b457459-48000-1990079ea251205':
        'faf31dd8-8c2f-432f-aa09-26148db94dc3',
      '$device:1991f711b322f0-07ca3ca2e18ee38-7379356f-505c8-1991f711b322f0':
        '75e885cd-7d06-45bd-b1a8-debfc9cd6cf7',
      '$device:1991e6654dc203-05a879d76a51958-7379356f-61d78-1991e6654dc203':
        'f075679c-e8f2-4182-ac6c-f351c30cce45',
      '$device:1991ec90db9ac7-0275de69c4c273-b457459-46500-1991ec90dbaac8':
        '13db37e2-fc1f-43f6-89ac-25e42de4f9ae',
      '$device:1991e88e3ef4ba-06c7d5e9a7bba9-b457459-4e000-1991e88e3ef4ba':
        '39a70563-954d-4b34-be1a-b4baaf163e87',
      '$device:1991e553c61778-09b79ba353b7a88-b457459-5c094-1991e553c62779':
        'b1d23460-8221-4e5d-9105-72ae5306dce6',
      '$device:1991dad5f56672-05d21b135926998-b457459-5cbd8-1991dad5f56672':
        'ac646755-414b-46d4-91da-2247a3e9d06e',
      '$device:1991da1ff5b2dcb-0b38ea352e81ef8-550e4263-505c8-1991da1ff5b2dcb':
        'e2cbe09d-840a-499f-b490-72fa7be110a4',
      '$device:1991d9f5c5a1e6-00232dcbfc6468-b457459-46938-1991d9f5c5a1e6':
        'ce388a8d-7b66-4f0b-a15e-bcdb42109d21',
      '$device:1991d9bbff12bc-0f9013d17c6b4b-59004468-61d78-1991d9bbff12bc':
        'a83f27f9-0c4f-4b80-ac0a-0cc704855c2b',
      '$device:1991d9b31c81fa-07fa4c3edb0e168-550e4263-55c74-1991d9b31c81fa':
        '76b9e10d-8f37-4f66-82ed-a26c5c914a56',
      '$device:1991d5b18691815-00fc981fff4646-b457459-38f40-1991d5b18691815':
        '9040f9b1-0fc6-41aa-9db6-102e71d9b75a',
      '$device:1991d4e26da3b2-0a091aae99b73e-7379356f-61d78-1991d4e26da3b3':
        'd44b181e-eb9e-457d-a57c-e0ddfb79a54e',
      '$device:1991d3d576ddb9-070e366ea174c28-7379356f-36240-1991d3d576ddb9':
        '3b453cc6-c3fe-40e1-b1fc-b182a68dd5ac',
      '$device:1991d3f3b45794-0417242c33de88-b457459-5cbd8-1991d3f3b45794':
        'b73f9c58-57f5-47cd-8eff-e833efb7b74c',

      '$device:1991cb547083e0-09c7a77180a3f-27604a30-60c28-1991cb547083e0':
        '5280e769-68c8-4e0c-a3f7-05c78dda7628',
      '$device:198ffac4f9840f-023f822d3ee11b8-b457350-65400-198ffac4f9940f':
        '264f9cea-20c8-43eb-9db6-233cc94a968a',
      '$device:1991c76d1e728ea-0cf5c74369e9f-f407878-5a900-1991c76d1e728eb':
        '159b5afb-ec43-4f9d-ae72-0072b8a49855',
      '$device:1991c72c1ba330-0b96522a366b638-560e4263-61d78-1991c72c1ba330':
        '48787905-d4df-48e2-9bd1-acb18b3253d4',
      '$device:1991c599a12308-0d2541475be2b78-7379356f-505c8-1991c599a12308':
        '8ca7c108-843a-4a94-835a-91bc2becc338',
      '$device:1991c4f931e556-0461f261375f258-550e4263-505c8-1991c4f931e557':
        '2a21d32f-9b26-451a-ba72-4312a52195c1',
      '$device:1991c43243b4a7-0ca7e6efca4a5f-7379356f-51bf4-1991c43243b4a7':
        'be259b5f-74e2-4b5a-bcea-e6b828fdb713',
      '$device:1991c2ca54f2a7-0ae4418dadd7f38-75115149-4a640-1991c2ca54f2a7':
        'f1e03bf3-cd57-44b3-ac1e-08ea4512a4c0',
      '$device:198debae8346d0-058fcfe9e023788-b457459-431e0-198debae8346d0':
        '0505e1ad-4bed-4b61-90e5-2d9fcdabdaf4',
      '$device:1991b18adeb150-00ba3c88fa04458-2a4e022c-61d78-1991b18adeb150':
        '83a02ba3-7d1c-4601-b46f-3a1bd88c3684',
      '$device:1991c10897e58c-031b6648db61bc-b457350-65400-1991c10897e58c':
        '1a3dd262-9d79-4af7-bab1-437bc938bacc',
      '$device:1991bfa0152266-094be41f3737a98-21403019-61d78-1991bfa0152266':
        '3e0887e6-7299-4052-a050-f873384c6c89',
      '$device:1991bf660fd24f-0d9812d257ff0b-69157d6c-4e000-1991bf660fd24f':
        '3eca842e-3720-47eb-9589-023640718e9a',
      '$device:1991bbe86db307-0ca85d8f392a05-27604a30-5a900-1991bbe86db307':
        '643913f2-414c-4370-8ef5-dffc6cf609d7',
      '$device:1991bab8654444-0124072cbd6674-7379356f-3d10d-1991bab8654444':
        '3420e9b2-4122-43a3-a901-9ba4f134ecb5',
      '$device:1991b9e5781140-00c32802d7fcee-5e03406e-51bf4-1991b9e5782140':
        'a474e257-9869-424e-83c1-bb8528443c2e',
      '$device:1991b98e88c28b-0b131af5f9c87a-27604a30-4a574-1991b98e88c28b':
        '440dd2df-4962-4958-b53b-ea35b238a908',
      '$device:1991b9a34eb4d3-0951ad4c37b708-b457459-4d09d-1991b9a34eb4d3':
        '2a142e63-3fcb-4ebb-9471-56e8dd16291c',
      '$device:1991b8b6910368-04ccd1bee1d59b-b457459-65400-1991b8b6910368':
        '5f7b9440-af20-45a6-8c15-8f1ae73d7452',
      '$device:19917b36ea1254-0d087825819f4a8-550e4263-61d78-19917b36ea1254':
        '27c2b87b-262d-4622-bea9-3fbc241a9eaf',
      '$device:1991a6dc0dc1e9-09a8512a4d6ce7-7379356f-36240-1991a6dc0dc1e9':
        '91f6eae0-3319-4c70-8168-ede0230b7e03',
      '$device:1991aee3c913ad-0353ace9e3e0818-f407878-505c8-1991aee3c913ad':
        '3e005753-879b-49ea-8932-9c8333061f29',
      '$device:1991ac80236f4-0752ba9af8eb2e8-550e4263-61d78-1991ac80236f4':
        '011b2d6c-182a-4da1-a77f-1bdc52af8f0f',
      '$device:1991ab1dd57696-0b8ce32dd8ff91-c437b78-51bf4-1991ab1dd57696':
        '38ca03c0-5749-4934-be7d-08ce7878041e',
      '$device:1991a95700f433-0f6bd561ac55728-7379356f-505c8-1991a95700f433':
        '23fb4db6-9926-4c42-899f-14fc4c84d444',
      '$device:1991a43401ca4c-0314bde052ab2b8-b457459-5c094-1991a43401da4c':
        '566756d5-a3a8-4e30-943d-853265c6149d',
      '$device:1991a3450fc141-00ca8ac26866fd-550e4263-5a900-1991a3450fc141':
        '7da3bb96-8b87-41fd-88bb-d134ca55b813',
      '$device:19919c999f2274-03edfc11688d4a8-7379356f-505c8-19919c999f2274':
        'e92c0fbd-8f04-4dc2-b32e-f506a16e9f66',
      '$device:19918e25310775-073dd7b34cb3bc8-7f643058-505c8-19918e25310775':
        '3ea3bcf0-ce9a-4d17-9bac-2501de64e7f7',
      '$device:19918e070686ed-0d740102b27ae-b457350-5768c-19918e070686ed':
        'c74a7a99-66f7-465f-a9f4-7f1c42a11511',
      '$device:199183b8167698-08c2d6abbdedb78-7379356f-505c8-199183b8167698':
        'e68d9ef5-0d35-4bbd-8e88-d27f2cf50000',

      '$device:19917f12edb438-0454078de309fd-7379356f-61d78-19917f12edb438':
        'b2f09fbb-0448-4372-9aba-6259cbc41f4a',
      '$device:19917ece76c7a4-0db4a1652d27128-b457459-4166c-19917ece76d7a4':
        '78d4b354-faf6-4272-bd47-3dd3cbcb19cc',
      '$device:19917d62d4d3c6-01a1c65d4ac748-69157d6c-46500-19917d62d4d3c6':
        'b9f61230-07da-4dcd-8636-c259c5c2c502',
      '$device:19917cae0e16c2-0315dee058fdf88-27604933-505c8-19917cae0e16c2':
        '12672e91-dea8-40d8-a618-a1f124a7cd81',
      '$device:19917b36ea1254-0d087825819f4a8-550e4263-61d78-19917b36ea1254':
        '27c2b87b-262d-4622-bea9-3fbc241a9eaf',
      '$device:19917b20f3b217-0dae744fe5ff3b8-7a623957-36240-19917b20f3b217':
        'dd42398c-f18c-458d-bbba-98dfdeedbc51',
      '$device:19917aead4f1a9-0e367c538173348-7379356f-36240-19917aead4f1a9':
        '22b8c834-a2e9-4ff6-b2bf-32f58c4d2ede',
      '$device:19917aead4f1a9-0e367c538173348-7379356f-36240-19917aead4f1a9':
        'c99c12d9-c83b-43d6-a9ae-48d518f15742',
      '$device:19917a60f47276-0b9591750389f58-b457350-448e0-19917a60f47276':
        'b4332a58-dd13-420e-a514-7c35466ab975',
      '$device:199179113e9205-0f6e124de8dfdc-2a4e022c-61d78-199179113e9205':
        '4ad9f242-91cf-468c-895c-92cd14a06b0b',
      '$device:1990b0b8ef27dd-09b0b4eb6f735d8-7f643058-4a574-1990b0b8ef27dd':
        '913c3bc9-2107-4dc4-b1b4-51cbdca10228',
      '$device:19917876f2d30f-0f4fcec701eb26-50777824-505c8-19917876f2d310':
        '45e31e10-8e3d-49a3-a624-ef56c16fd05a',
      '$device:1991786e2c9121-0945ba9ed5244a8-560e4563-61d78-1991786e2c9121':
        '8cfb31af-f624-4ba5-aa4d-e5691622653a',
      '$device:1991780d23433b-09fa9212e08fa4-7379356f-55c74-1991780d23433b':
        '017b51d0-a90a-4050-822c-99524f71f0eb',
      '$device:199176795ca696-032b9a27c273e4-4a68191d-46d70-199176795cb697':
        'cb94c318-87df-424e-8062-e8905cf2cd5a',
      '$device:199176e901b2ae-09103a8c7631ef8-b457350-5c094-199176e901c2af':
        '543d319e-cc50-42b3-af4c-4bbf0467afd8',
      '$device:1991740c827190c-039f2dd21890b4-4e0f0628-46d70-1991740c828190d':
        'd3ad0772-93a8-44b0-b7be-53b7167cc776',
      '$device:19916f77012870-05dfff785f64968-b457459-5c3cc-19916f77012871':
        '71b87233-8f5a-4df7-b26b-80e18903695a',
      '$device:19916f6ddfa6acf-0ef5300086c5c48-b457459-5cbd8-19916f6ddfa6ad0':
        '0c021e40-71a8-4077-ad2b-1e833f281204',
      '$device:19916c30ab92ad-0da2c3909ba9bb8-7f643558-505c8-19916c30ab92ad':
        '48278e59-addc-413b-8f90-3d639dbf0d24',
      '$device:19916742688756-0c5b991eb58127-b457459-50456-19916742688756':
        'ca80d61f-9a89-4d8d-95d6-37230369c231',
      '$device:199162001e0378-083fa03740dd5b-27604933-505c8-199162001e0378':
        'df7b3de1-1039-4606-9949-45fef667a525',
      '$device:19915986e23253-037de65c6eaffd-26614f35-36240-19915986e23253':
        '342b2980-7f6b-4e0b-84b3-5357ce56d415',
      '$device:1991574cf4a56a-069df398b6198c8-b457459-448e0-1991574cf4a56a':
        '157d6c9e-207b-4f01-9aaa-79b788dbb209',
      '$device:199153a5cf530e-09c84350be580a-7379356f-5a900-199153a5cf530e':
        '43232f6a-bd1d-4664-95b0-68e17428f739',
      '$device:199140110c53b2-0d69ef5be915e4-b457459-4e000-199140110c63b2':
        '217de8cc-e0cf-4044-9a5f-90ebde32fd28',

      '$device:19913d83fa9c81-067786af1c008e-b457459-7929f-19913d83fa9c81':
        '5a58bdef-6486-46e3-9971-c4c02ae5a776',
      '$device:19912d41cea1b6-00de0cf6716bc-7379356f-60c28-19912d41cea1b6':
        '0659eeeb-8c82-4f91-8bf7-36176710015e',
      '$device:19912b6800d2f4-0e3923624c1bb98-b457459-4e4c1-19912b6800d2f4':
        '0f6d9b8d-57ed-4e79-8faa-9eee5e6dfb8d',
      '$device:1991273ba48d6a-08493847e0a25c-b457451-5c3cc-1991273ba48d6a':
        '6dbd175d-5a4e-4062-a3e5-7893b6fda1b6',
      '$device:199125b1ef031f-0e53de6c67b262-69157d6c-46938-199125b1ef131f':
        '4c39767b-bdba-4d1c-87b1-e33dcaa34dd7',
      '$device:199122a69d0989-092fd3150ba979-b457459-4e000-199122a69d198a':
        'f36e8cfc-8d55-4488-8bf0-b5b52dd9f144',
      '$device:1991216441e54a-0c86c55cc22733-b457459-448e0-1991216441e54a':
        '26b6055e-8fb7-4c1c-81cd-ef0b7e413ddf',
      '$device:19911f980283da-04e80ca528221-7379356f-2c600-19911f980283da':
        '0b4a215c-e674-4a9e-abb5-c4422d330517',
      '$device:19911d081f41d2a-02a92f925c06648-707b376f-5a900-19911d081f41d2a':
        'e5b36d44-f209-487b-b5e7-5170f69de800',
      '$device:19911b5756356d-031f82be4ea07e8-b457459-46d70-19911b5756456d':
        'a2d7619b-f363-4727-af31-18ed8572d984',
      '$device:19911baad8b301-03c55ac5e77f738-3477f77-505c8-19911baad8b302':
        '6ea238eb-6e3b-4ede-9d26-346f11f98858',
      '$device:199117675a730c-034f6399254ab18-550e4263-505c8-199117675a730c':
        'b4a9d2b5-001e-4772-8b93-8f1d4764d97f',
      '$device:19911683229725-00ead7937fd885-b457459-51a6b-1991168322a726':
        'a5fa1408-a681-4214-9534-caa75bc19919',
      '$device:199115941d6362-0ad18be35cadc-b457459-4e000-199115941d6362':
        '3c8258c9-e57c-4bbd-9893-29116d9d7b36',
      '$device:1991152d7f9373-06d2454038c39-b457459-4e000-1991152d7f9373':
        'fef799b4-34be-47c7-8718-88ff9a64288f',
      '$device:1991144b5cb717-0759056f5a1f738-b457459-448e0-1991144b5cb717':
        '50bf6cc7-f91d-4419-ac56-10d3530706cc',
      '$device:1990e739c5a30f-052d1dcd62f2a88-7f793560-3d10d-1990e739c5a30f':
        'fc3ef0c6-04a1-448b-be0d-7e9451c85968',

      '$device:1990e563d2829b-0ab57d7a56c145-2b53067b-66b20-1990e563d2929b':
        '2098f864-01a8-438f-a95a-7f0412ff41cb',
      '$device:1990de492cfa0b-07d3a58b214b3b8-52054a67-5a900-1990de492cfa0b':
        '2fc843db-64f1-44c2-916f-7a9565db0ea1',
      '$device:1990dd84b3620a-020650fb52f4858-7379356f-51bf4-1990dd84b3620b':
        'c607393b-698a-4238-9805-555dc8ae1ac9',

      '$device:1990cdcac1f49f-0eb7b9293690ab-b457459-36380-1990cdcac1f49f':
        'd4431ae9-bed8-4e76-9041-cf9a7dfbec61',
      '$device:1990cf45f784ac-05ed78f7c22ab9-b457459-65400-1990cf45f784ac':
        '05cb0030-6989-42e0-84f1-6170d98e2b06',
      '$device:1990ccf9d713bd-0e2eff2c8b37258-7379356f-61d78-1990ccf9d713bd':
        '9b02bd7d-46a7-46a2-ad90-4ce607098138',
      '$device:1990ccd631829d-01f4735b3e72aa8-5d054c64-61d78-1990ccd631829d':
        '38711e10-ae2b-45a0-9967-c0ec7179293c',
      '$device:1990cab109ccab-0980a67cf8dda78-b457459-4e000-1990cab109ccab':
        '19cc30c1-f257-4041-8527-d6e6f44fd214',
      '$device:1990c9c6509471-0a953167e45ddb8-27604a30-4a574-1990c9c650a471':
        'e459f6a4-b676-4c17-8b5a-876d841dcbad',
      '$device:1990c9647cd48a-06967f7a61bb61-7379356f-5a900-1990c9647cd48a':
        '17f04f11-9c49-4e18-bb8c-888b5d9fccee',
      '$device:1990c717ce42e6a-09a25c97b199258-7e58071c-431e0-1990c717ce42e6a':
        '60201cb6-fa18-40a7-86da-d04a2d29b0b9',
      '$device:1990c6d7fde348-0476cb9107d57a-51054a67-61d78-1990c6d7fde348':
        'a5f689d5-48ed-4eff-9c60-5d43a969c88c',
      '$device:1990c6aadc4104d-0dccc0fa45d6188-b457459-50580-1990c6aadc4104d':
        'ad390d98-c216-4c8b-ae7b-45fb2d1b8efd',
      '$device:1990c3cb9d32e7-01bda8c12d8cc7-7379356f-505c8-1990c3cb9d42e7':
        '47580154-a21f-4529-b4e1-b92d0a6f8515',
      '$device:1990059d3f72b8-01243b216c7df98-b457459-448e0-1990059d3f72b8':
        '3f5089a3-29e0-4dbc-8b09-3247f022baa4',
      '$device:1990c2630e4419-03b2ff9662ef87-69157d6c-4e000-1990c2630e441a':
        'a8a248e6-eb7e-426a-977e-7daac68d771c',
      '$device:1990b6e5ab73a1-0875151b75edac8-50747c24-60c28-1990b6e5ab73a1':
        'a2fc3ce0-6220-44f8-a2eb-f300f254b794',
      '$device:1990b48b62f25a-0401c3a40b0aba8-7f643058-61d78-1990b48b62f25a':
        '6fc7f97a-dee9-4596-b168-e6158f6181b0',
      '$device:1990b35eb9521e-083c61877e266-7379356f-505c8-1990b35eb9521e':
        '40198161-0fb3-4728-8622-38481be40d2e',
      '$device:1990b2f744959a-07070b00d203f9-b457451-4d09d-1990b2f744959a':
        'a781c03b-cd05-49ed-8c92-a475aa13700c',
      '$device:1990af81672445-0888904847b5c9-b457459-4e000-1990af81673445':
        'f1b54059-faa9-42df-81c3-6684acfe86ef',
      '$device:1990a3aa9434a3-0472d948e99bd9-7379356f-55c74-1990a3aa9434a3':
        'd27abe2a-fa63-4f0a-b71b-9dab3bb560d7',
      '$device:1990939454423a-001f70c93a5bf-7379356f-51bf4-1990939454423a':
        '622545c3-c635-4cd6-8d9f-1f8b9e507573',
      '$device:1990909ca481bd-0af936e70b8b0b8-7379356f-61d78-1990909ca481bd':
        'e07fe675-866f-462c-9f3a-847f8dbe86be',
      '$device:19908accc67189-0ca61610c0a97b8-27604a30-60c28-19908accc67189':
        '45289d6a-b2d5-4299-b276-851ede3e97a5',
      '$device:19907c9769b396-0d0d238dd65354-7f793560-2c600-19907c9769b396':
        '02fad245-abd5-4f27-86c7-75858b95fe3b',
      '$device:19907a8a6544f6-08e7e0652ab9e8-7f643058-51bf4-19907a8a6544f6':
        '72170344-9dc0-4466-9564-e11a8f59edbe',
      '$device:19907a00fe17c3-063f0cc6af2e9c-b457459-4e000-19907a00fe27c3':
        'f570a06a-3ee5-4db3-9b6a-41c6e2186a31',
      '$device:199079d5f36421-04d9d5063d9f3e8-7379356f-51bf4-199079d5f3642':
        '37ca20a3-369a-4023-9c90-838236a5129b',
      '$device:19907520d9a875-0923b9658d0c05-b457459-59b90-19907520d9b876':
        '63c085b8-170f-4670-a63d-b89f9517b0d0',

      '$device:199073496d51c2-0ca6fe6c9888728-53054967-51bf4-199073496d51c2':
        '33635972-bc15-4b18-9246-74f14e6f144f',
      '$device:1990706b30582b-081626c575ce278-b457459-5c094-1990706b30782c':
        '3d1da4a7-d635-4e6f-9c52-34ea1dcd17f4',
      '$device:19906f257f7194-0b0feae5bce7038-b457459-448e0-19906f257f7194':
        '2264b239-44a0-4aba-9d7f-c39e69ae3da7',
      '$device:19906e4663b281-084e485d21cf79-7379356f-5a900-19906e4663b281':
        '0dc9db08-bdb6-4ab5-921c-2f976758ddc8',
      '$device:19906d7c80b293-0645a163e1c493-7379356f-4a574-19906d7c80b293':
        'ea9d80b8-c941-41ce-b8a1-1fa8f06e6df5',
      '$device:19906d40ea926d-09036a87f4afb3-7f7a3660-5a900-19906d40ea926d':
        'ac9e76b9-d930-42df-b7a5-904208a2936c',
      '$device:199069cfa1b26f-051f02c3fe1e6-b457459-36380-199069cfa1b26f':
        '514f8fd0-0d2d-4adc-ab88-a7621514eb9a',
      '$device:19906b93193496-0b062f50ee1f79-27604a30-4a574-19906b93193496':
        'ddd8a28a-8531-41b4-8714-f08a622e5a09',
      '$device:19906acc00f38e-0d0ece11215b55-7f643058-505c8-19906acc00f38e':
        '290a6a1f-d26a-4c33-9bed-288413619cc7',
      '$device:19906abbbdb89e-037ac741614d0e-27604a30-5a900-19906abbbdb89e':
        '84cff570-2699-4463-b72b-0d2c7380dcc5',
      '$device:19900b8b315429-01a1dbbd71c9088-b457459-5cf10-19900b8b315429':
        'b6b1b28f-6ed2-4b58-b040-8218cbba721e',
      '$device:199065dd75c16c4-0dad2e6000218a8-7379356f-505c8-199065dd75c16c5':
        '9ab1b82c-ef88-4c89-8f1f-74271e176590',
      '$device:199064d40bf385-000ff20aedce8e-27604a30-2c600-199064d40bf385':
        'e055ebb0-8db2-43bb-8a98-3ac6c486f3ba',
      '$device:1990644eb2f1dd-0d4411fcaa92de-7079356f-5a900-1990644eb2f1dd':
        '624d0b4d-45cb-420b-80d8-3240a295d521',
      '$device:19906459a4f5ca-07d43de06884b2-b457350-46938-19906459a4f5cb':
        'd434d9b6-698c-472b-aa92-57908646e9ea',
      '$device:199063dc82495a-0c3cc949512f7f-7379356f-66b20-199063dc82495a':
        '19bb0a4f-c9c4-40c3-ae5d-cf887ece2c71',
      '$device:19905f47208158-0ac869488af792-7379356f-2c600-19905f47208158':
        '861ae0e1-c2bb-4ac5-bcd5-9ad38cdbae1f',
      '$device:1990594ba7f1ec-0df5c46362ce218-27604a30-51bf4-1990594ba7f1ec':
        '718e7a1e-75b6-4e36-a798-c138f35f15aa',
      '$device:1990587bd81a84-095f96ba97b563-b457459-41922-1990587bd81a84':
        '1ace618e-a2a0-4d89-ab7a-edbafa3f77bf',
      '$device:1990518f573898-07584dcc03ad15-b457459-50456-1990518f575899':
        'aedde733-1789-4bef-a5e5-52d916c55f7d',
      '$device:19904dbf557610-094e20d118c0e78-51054f67-4a574-19904dbf557610':
        '3657d605-98b0-4927-940e-3a435dc6b401',
      '$device:19904c85a25262-0308551225aba-b457459-52265-19904c85a25262':
        'a6194a21-35d8-452d-adbd-c80029304012',
      '$device:19903f4d61c4d6-050e1bc72c5d0c-27604933-5a900-19903f4d61c4d6':
        'b3e2df52-5949-4fee-91de-4f5bca5e0947',
      '$device:19903bd7bab3bd-05e76f4cec0fc4-b457459-46938-19903bd7bac3bd':
        'e46e577d-5131-47b2-8921-3e92f74c3ef3',
      '$device:19903a79a0745d-001ba0e6ce257-b457451-4e000-19903a79a0745d':
        '93869f91-3767-4812-9678-35b5aeb54273',

      '$device:1990259cc424c5-085716129ed70b8-b457459-5c094-1990259cc424c5':
        'da3db54d-1c86-41f2-be09-3fb78c2b0e06',
      '$device:199030953d9346-0c2717d1024b408-51054a67-5a900-199030953d9347':
        '9412c1e3-9a09-4240-b503-3adef5f81de8',
      '$device:19902b222b1363-0784b6168ffd1c8-27604933-5a900-19902b222b1363':
        '31d10fdd-fe78-4101-9651-b55ad89473a1',
      '$device:19902a078202a2-0b3e284518e3bb-b457459-36380-19902a078202a2':
        '3814ccfe-e0dc-43c9-a87f-97c7ec821e44',
      '$device:199027e2b7e1d3-07e865093257e58-7379356f-51bf4-199027e2b7e1d3':
        '9180aac7-40f0-4045-944e-b3be524804c2',
      '$device:199026fed4935e-095a2d69b12b718-b457459-4d580-199026fed4935e':
        'ba9a9c79-7efc-40fb-9865-ca010244f3c1',
      '$device:199026de9b210f-0adf95b70fe9608-7d643058-60c28-199026de9b210f':
        '323a3731-aa1b-4a62-bf77-53fcdcf5d4fd',
      '$device:199026994564cc-088e1e3adc7e09-b457459-41922-199026994574cd':
        '2ef372ff-c92e-4531-8040-0de93947bf42',
      '$device:199026b5810233-04c953e029ff97-7379356f-4a574-199026b5810233':
        '77bef1b5-8a4b-4a82-8393-625c66e31d17',
      '$device:199024727db309-019bf941aa880c-53054967-36240-199024727db309':
        '3c600e7c-8a66-49ca-a565-73063d36e2a6',
      '$device:1990237ae9519d-06f0c7db8b991c8-7c643058-4a574-1990237ae9519d':
        'db80e6ff-9a35-4646-ad5e-2b602302cb01',
      '$device:199022750a5270-096c083648578e8-74623a5d-51bf4-199022750a5270':
        '0f5622ab-7490-49b5-9744-3e2dedd6b730',
      '$device:19902111c874c2-06fc98623d5d1b-b457459-5c094-19902111c874c3':
        '3922a32b-ff82-4729-afa0-d13c823e3eab',
      '$device:199020b8d89741-06fa44a9f309378-b457459-84492-199020b8d8a742':
        'f87dedf3-5475-4379-9d10-19fc30019905',
      '$device:19901f758ba83b-0bfd239e2bf15e-7379356f-55c74-19901f758ba83b':
        '9be4e1be-3679-417d-af9f-388aa3938311',
      '$device:19901e293c6438-0b45628026d08d8-b457459-4d400-19901e293c6438':
        'e8740cab-ce77-4341-bf91-0d0093d6197c',
      '$device:19901c1ff911c8-037400c26e3223-7f643058-61d78-19901c1ff911c8':
        'f292131b-0fa6-4fdd-b433-684fccb551c5',
      '$device:19901b5ba28153-0c68b7dc66f8fa8-51054a67-51bf4-19901b5ba28153':
        '4bf53a6d-ec83-4f71-ae81-7ad33c1bfc98',
      '$device:19901aea63f1ee-0e36a72e7eefaa-7f643058-55c74-19901aea63f1ee':
        'd4548377-5c15-4df2-a7ea-337b43adadf9',
      '$device:1990158cce3f5f-0f3ec744e550468-26614f35-66b20-1990158cce3f5f':
        'a86af8e8-c71a-4b38-b250-1e1fe0eb938c',
      '$device:19901a603c4571-014ab512c79bd1-7379356f-61d78-19901a603c4571':
        '00e776cd-87e4-49af-9dad-359666213e27',
      '$device:19901a2b728259b-0caece859b346c-b457459-50580-19901a2b728259b':
        '5a374f66-1e44-47b2-ba5a-3cf0cfec8dc3',
      '$device:199016dd0d433c-0a0cc60100acda-7379356f-51bf4-199016dd0d433c':
        'b7201f90-ead5-4aef-9adb-1a9e53920537',
      '$device:199015826cb65a-0b5e44600215ef8-b457459-50100-199015826cc65a':
        'b094a151-5967-4e35-9853-001784d83f05',
      '$device:199015421805bf-0cbef986869c818-7379356f-3d10d-199015421805bf':
        '7841d7d4-9e5d-447b-914d-d4144685aa5b',
      '$device:199012aeb7536f-0601648a03976-256e4f35-36240-199012aeb7636f':
        '52bcd1b1-b37a-4945-9b98-c30dc9093000',
      '$device:1990121bc953d2-0ee80e4943a5f8-27604a30-2c600-1990121bc953d2':
        '7b3f0499-d05b-485b-8fef-2b966c3e072e',
      '$device:19900dbb378227-088d36c54b1b97-c427a78-3d10d-19900dbb378227':
        '867b1619-62c3-40b0-a06b-f450c9edf7ab',
      '$device:19900daed7a42a-00077518175a028-5d0c416f-3d10d-19900daed7a42b':
        'c548fb08-40fd-4359-b8e3-e7cf0f4f3ad1',
      '$device:199009dce1c5cc-0f3fff33574bc38-7f643058-505c8-199009dce1d5cc':
        '4b95c3aa-eec2-4c41-8998-2ab73a5f534f',
      '$device:1990095cbf836c-06289f830fe16-b457459-4e000-1990095cbf836d':
        '79c1d3ce-408c-4223-9035-9d38ca0e7d26',
      '$device:1990085620a3ea-0fa1689c388764-7379356f-505c8-1990085620a3ea':
        'ec88bcba-d533-4c7b-a094-99bc8819b06c',
      '$device:198ffb7b27ab20-03accef0a127a6-b457459-4166c-198ffb7b27ab20':
        'a634fd13-956a-49c4-9751-6d4013290c6c',
      '$device:199006e7382487-02b64b9686247d8-b457459-4e000-199006e7382487':
        '30374f70-7a59-4e18-8dc7-25c039e9c4df',
      '$device:19861e8109e12e8-0d9949d9ce6ad3-69157d6c-2b0c0-19861e8109e12e8':
        'c0eee390-88fe-4a15-9a91-2134299b0351',
      '$device:198a564c22e534-0fb1520ef49ded8-b457459-4e000-198a564c22e534':
        'df774b0a-3f25-42ec-b764-4a84adabcb92',
      '$device:199003c30f14b8-02e963f0bb94a6-b457558-5cf10-199003c30f14b8':
        '610b9ba9-d43b-4a53-ba9d-a7e7034d9f9d',
      '$device:198fff54bac477-0f7a4fb47ca09e8-b457459-6d280-198fff54bad478':
        '76281113-703d-4608-8f3c-4bf565c69f5c',
      '$device:198fff420004a9-07f41e1238ada48-b457459-4d973-198fff420004a9':
        'c89a06f9-f0e7-43c5-9900-bf8731b3555a',
      '$device:198ffeb90e02c4-08e7827ca8d999-7d643358-36240-198ffeb90e02c4':
        'f511ab5b-f38d-4204-a923-8fe3d8807873',
      '$device:198ffd27dfe480-04fb16993f92918-f407878-4a574-198ffd27dfe480':
        'b73418c0-5bd7-45e0-b111-b3a865666fcb',
      '$device:198ff7f210b315-07eada1780d217-7f643058-51bf4-198ff7f210b315':
        '0e55db15-7a67-45ea-8ee6-04c04cb60364',
      '$device:198ff5a0b68211-0e24f151bee846-27604a30-505c8-198ff5a0b68211':
        '398cb230-e439-48a0-af51-6baf390635d8',
      '$device:198ff4613328b6-0f33f37f5ce55e8-b457456-50456-198ff4613328b7':
        'a7199f07-eb61-4b44-ae53-fadb7719a3d6',
      '$device:198ff2a166e560-098340c6ee7a0f8-27604a30-5a900-198ff2a166e560':
        'efdbd559-3350-45ff-9467-beacb5b16cf2',
      '$device:198fef4b721499-0d1ddf1f18203f-7f6f3c55-51bf4-198fef4b721499':
        'a6c2e505-1c58-4777-97ed-eae0888f9b5c',
      '$device:198fec3b5cb1f1-09e599acc75cd3-7379356f-505c8-198fec3b5cb1f1':
        '0ffcd49a-bbcc-4314-bcaa-de70d4962558',
      '$device:198febf47652da-0ef75bde5372a88-b457459-4e000-198febf47652da':
        '706d9d9a-403e-4209-918c-201aa3db56a0',
      '$device:198feaa097e21c-0fb82285a7f8148-7f643058-4a574-198feaa097e21c':
        'f1bd449a-d0c6-4f62-a4f4-166210cfef6d',
      '$device:198fea8b52d245-01bfb8f45e4f28-560e4361-505c8-198fea8b52d245':
        '8172a101-9f1a-48e7-99dc-384014150fba',
      '$device:198fe872bd548e-0c2e4bfb5fd3cc-b457459-5cf10-198fe872bd548e':
        '36fe24be-32d8-42c1-a221-ec07383d8cc3',
      '$device:198fd9dbab6b79-0130defe51479d8-b457459-46500-198fd9dbab7b79':
        '462367f6-85bc-4d06-a54c-a5379ddae5f6',
      '$device:198fdaebec7551-042a30667b6c1a8-b457459-5c094-198fdaebec7551':
        'eca9e7eb-7f2d-4ab1-bba3-1ea249ba4754',
      '$device:198fd9dbab6b79-0130defe51479d8-b457459-46500-198fd9dbab7b79':
        '83e04f24-8b39-416d-ae77-faf255fb04b8',
      '$device:198fd764af23f6-0a7b988b38fab38-c437b78-55c74-198fd764af23f6':
        '22c45c60-1ef6-43f2-b182-1486665ad57a',
      '$device:198fbb651bf2a9-072043aa75e3068-7379356f-5a900-198fbb651bf2a9':
        '93e79fda-6b9a-4327-ab1c-00ebd6f4ff03',
      '$device:198fb4eb7a4265-0cd98eeaa514218-7379356f-505c8-198fb4eb7a4265':
        '383b0086-a5bf-4230-8488-2e5721ac1a58',
      '$device:198fb44e05d42b-08711041822c55-246e4935-51bf4-198fb44e05d42b':
        '36492e5f-2ef3-4e9c-897c-f9b14b7eba14',
      '$device:198fb0075fd8dd-0ec6e925dc07788-b457459-424f0-198fb0075fd8dd':
        '1bd5ad9e-c521-4062-8463-ac24dc4246dc',
      '$device:198fadbed6c330-03958adc3e3da5-b457459-40e00-198fadbed6c330':
        '1a45a842-1362-4649-8a01-6b676d0eac5c',
      '$device:198fabcc5fb4a2-074bf0351740ef8-b457459-448e0-198fabcc5fb4a2':
        'b9c599d9-1110-4fe0-9847-3e0a8d943365',
      '$device:198fa1b98cc2c4-0644f5b32356398-7094c2c-5cf10-198fa1b98cd2c5':
        'f2b10d9d-5652-46ae-9fb6-7ab37a9b2e8d',
      '$device:198f986fb0521b-0dc7e13185c055-b457459-431e0-198f986fb0521b':
        '5b7234cc-9321-4046-8fba-82d7480491c2',
      '$device:198f951b0d835c-0244a4f8f91404-27604a30-5a900-198f951b0d835c':
        '5d523cbe-e6e9-4eee-ba86-b12a7eeb6172',
      '$device:198f94871f121da-0c8d251c25785f-53054967-3d10d-198f94871f221da':
        '2d7fdde8-127e-4f2c-b7fd-5724f864cfe5',

      '$device:198f8a793ed516-07f266c2cea48a8-7379356f-505c8-198f8a793ed516':
        '84b07bb4-129c-4290-93a1-942691d9c567',
      '$device:198f8932f6df42-071c7b0abd969f8-b457459-46938-198f8932f6df43':
        '0616da12-f929-4ec1-8db9-2ad77ff70e11',
      '$device:198f887508129a-0cb61c0ad640998-2a4c092d-505c8-198f887508129a':
        'a2a214e4-6643-4889-81a1-000e4a9a7744',
      '$device:198f871216a869-0a67821452728e8-b457459-59b90-198f871216b869':
        '904c3472-24a4-42ff-98ea-0174f0d3ca87',
      '$device:198f82f8d42d02-0e72dfc6a3d7988-7379356f-61d78-198f82f8d42d02':
        'b80a7997-9287-4eb8-83e8-ede80fb73ee2',
      '$device:198f81d1d5a2c6-0d65ad5c87dd76-52054a67-505c8-198f81d1d5a2c6':
        '5da3f529-ac66-48ad-953e-9b8a6b5b28cf',
      '$device:198f805d1fc323-0fb6e39363d36f-7d643058-66b20-198f805d1fc323':
        '335eeae9-4ca2-4881-90f6-29c9b7ee133d',
      '$device:198f765565116c-00f7e6355cbf14-7379356f-2c600-198f765565116c':
        'c606f703-651c-424b-ac4b-cda6a66b020f',
      '$device:198ec74bd1b51f-0cad2c05a8aa3a-b457459-5cf10-198ec74bd1b51f':
        'd0315efd-d9bf-479c-a0d3-2eff559c3728',
      '$device:198f7e59dd8361-0d2742e9ad7f818-b457459-5cf10-198f7e59dd8361':
        '5d2f8bc2-c270-4f6d-b1b3-e53d0949eddc',
      '$device:198f7de549fa69-02cbdfce4d25c48-b457459-7c35d-198f7de54a0a6a':
        '3c56b0c7-f8b4-494b-891e-d9f13138b060',
      '$device:198e5198767404-07751c393b0db4-69157d6c-50580-198e5198767404':
        'f4c30d1b-12c8-4061-a886-e3567f4edd8d',
      '$device:198f7c7447a83d-062f065caa62088-b457459-37a00-198f7c7447b83e':
        '281be484-db5b-4e47-bc54-b52216831bd4',
      '$device:198f7b68c5f160-0d9f3febdcec358-367b1434-ec3b0-198f7b68c5f160':
        'da01de27-051d-4a48-a4f6-da493a9c1ac0',
      '$device:198f77aca1a1afc-0fb13303200cb4-b457650-5c094-198f77aca1a1afd':
        '2e13a2c5-9da7-4b07-ad4f-c10eea0afbfb',
      '$device:198f76ad41e26d-0f95a46220a8bc-7079356f-5a900-198f76ad41e26d':
        '15444d0b-57d6-43f2-88e7-278685273af6',
      '$device:198f7437e9a312-0d6b9a2f501faa8-7f643058-505c8-198f7437e9a312':
        '3581c0d0-bd2c-4b51-8ded-96409c7cb640',
      '$device:198f735cc0b2a6-0a8a5e632185c1-7079356f-5a900-198f735cc0b2a6':
        '85453449-07df-4bd9-86a8-a769f889c681',
      '$device:198f7240b7d658-0fac988d5b4e858-b457459-37a00-198f7240b7e659':
        '771324b3-2cf4-4c8a-8a15-fd14c7db2d9b',
      '$device:198f71398ed34e-018f72a36c153b-7a632e15-36240-198f71398ed34e':
        '5fd5808f-b8fa-446e-b957-c5c5105cf267',
      '$device:198f707303d1327-0857bd005bd28-69157d6c-46500-198f707303d1327':
        'bde4565d-4f22-41fa-9852-c3e71e584782',
      '$device:198f6f430d125f-0a885c4802d691-7662395d-66b20-198f6f430d125f':
        '61c41f18-274c-4679-aaf1-54a5719cb5f6',
      '$device:198f6e8fc968b1-0ee49cd557d9378-b457459-5492f-198f6e8fc988b2':
        'ea5b2e8b-1c61-498a-9648-beb423478632',
      '$device:198f68cdf61391-04d599c25f768a8-27604a30-60c28-198f68cdf61391':
        'bb1f593e-9ac6-4fe8-879d-625064b377fd',
      '$device:198f658811c23d-08c94e56849cf3-7379356f-60c28-198f658811c23d':
        'f16851f4-f42e-4278-9d50-9ce36c901170',
      '$device:198f63189bc2a1-06803e9ff74ec68-51054a67-61d78-198f63189bc2a1':
        '2d911b69-7194-4510-9fc7-89b04bb7eb9b',
      '$device:198f626fe2a758-0938686bf56d65-7379356f-505c8-198f626fe2a758':
        '7f3e749f-b2ef-4f84-a3f4-501d423b69c4',
      '$device:198f618e620479-0a7b4b9cc064c1-7d643358-5a900-198f618e620479':
        '6c6730d3-d860-4923-8cff-3aa1f057b8fa',
      '$device:198f5ea716eb10-0150c19530ed868-b457459-4d580-198f5ea716eb10':
        '7647e0a5-b233-4776-8c9d-a709adf9aa6e',
      '$device:198f58fd2f96ff-0fb4af39ec81118-b457459-46500-198f58fd2f9700':
        'c859e8cb-53e6-49f6-9986-647840e45b2c',
      '$device:198f4c77fdd3ce-016dd1db3ac2308-b457459-5e598-198f4c77fdd3ce':
        '61e06e52-8430-4c19-aebe-06e585edcc9a',
      '$device:198f5059f16354-00a7d0daf7bf16-69157d6c-4e000-198f5059f16354':
        'c275c2aa-b54b-40c1-a764-56c5cb5650f8',
      '$device:198f4ee5d39548-0bc56b2f2377848-27604a30-36240-198f4ee5d39548':
        'ca03ae3a-6931-4200-8c34-2518391fe9e4',
      '$device:198f4d6951e326-0da80ca028f29a-b457459-4e000-198f4d6951e326':
        '9ac78275-fc62-47c3-98e6-e05401579d6f',
      '$device:198f46e9a6f487-00af52c4809eaf-b457459-5c094-198f46e9a6f487':
        'd2cd1058-2c9d-43d3-bcc4-2abc72461b0c',
      '$device:198f401897f139-02ad115842066a8-7379356f-505c8-198f401897f139':
        'e43cb73c-d36f-4089-938c-1b8ae70d5094',
      '$device:198f3a7c2292bb-03a43b7a7945e18-7379356f-505c8-198f3a7c2292bb':
        '94a40285-24a9-4172-8f3d-a9c9c8b2313d',
      '$device:198f395c432d60-032bf159093a338-b457459-5e598-198f395c433d61':
        'dac0ddd3-353d-46ad-ae89-37fc79cac07e',
      '$device:198d83b799674f-049da72907f6d58-b457459-6ba3c-198d83b7997750':
        '71563ddd-a50b-4259-8641-c30ada687818',
      '$device:198f356e70033c-012f32e19005a2-b457459-448e0-198f356e70033d':
        '41fd9f5b-185e-4520-8a30-e78030bd10dd',
      '$device:198f351d06e24c-087aa286144c78-27604933-505c8-198f351d06f24c':
        '9306a270-c3fd-48ed-9613-b96f10e12b59',
      '$device:198f32957d4301-015a7f0b82a3cb-7379356f-505c8-198f32957d4301':
        '81dc88f0-f2dc-442c-a653-1ab96aeacd80',
      '$device:198f32931eeba4-0ea04c12741cfc-b457459-33680-198f32931eeba4':
        'ca184775-dd50-489c-a33b-c016bea13488',
      '$device:198f3258f1f4d7-089d6be3bf8ad-b457458-4e000-198f3258f1f4d7':
        'f8f91c15-ed67-41aa-bfb2-2618b18ade13',
      '$device:198f30839925e0-072bd0a23eb8df8-b457459-50456-198f30839925e0':
        'b74f7c7f-738b-4f86-b539-43ba4cc71d65',
      '$device:198f2911da232b-017a3a5ec86fe6-7379356f-55c74-198f2911da232b':
        'd6a3ee09-3164-4f92-b50b-822c5277eed0',
      '$device:198de808158319-0b4ef2eaefdccf8-7379356f-51bf4-198de808158319':
        '1207f9c1-5b07-4dcd-91ce-dd322822bdd1',
      '$device:198ef069f86338-0c7bcc111d67608-7d643358-60c28-198ef069f86338':
        'ae596eeb-8a60-419d-8169-64b539cf98b1',
      '$device:198eef54daa16a-010a6aea28acb3-27604a30-4a574-198eef54daa16a':
        'd4c3c3e7-2e94-4335-97d5-867d3bedaf81',

      '$device:198ee97ed39332-03cf374e3a04fe8-7379356f-5a900-198ee97ed39332':
        'f1286b16-906c-4d6e-a350-486ab20a8bd1',
      '$device:198ee799112393-03c7c2f8e942c78-b457459-37a00-198ee799112394':
        'c21079ed-d1e3-4524-ba2e-300d076a211a',
      '$device:198ce5a745028a-02359a97015dfc8-7079356f-61d78-198ce5a745028b':
        '774fd894-1abc-421d-bb65-0830c8cff596',
      '$device:198ee22f49669e-06ae83144c35ac-b457459-4e000-198ee22f49669e':
        '16f0f6db-89b8-4c9c-bb43-6abe6650843f',
      '$device:198ee1fce27238-09a115b43e6f11-27604a30-5a900-198ee1fce27238':
        '723fccde-d8d3-4cca-9421-1774a4ca27b0',
      '$device:198ee1b3cd51d0-075b258c3e6fe28-7079356f-5a900-198ee1b3cd51d0':
        '78f5d3b3-ab64-44c5-a992-4c4811ba2a66',
      '$device:198ede0a1222d9-033fc63528123d-7379356f-505c8-198ede0a1222d9':
        '758a9b82-3526-497a-9d51-31306dee5335',
      '$device:198eddccbdd4ec-0b9e332dd4a37e-69157d6c-40b00-198eddccbdd4ed':
        '4dc84be0-b6ec-4375-a3d4-517ddf834f40',
      '$device:198eda0ee552b2-06ed38f16585598-7379356f-4a574-198eda0ee552b2':
        '4596ad60-69da-4e3e-8553-c1621d12404e',
      '$device:198ed5a8f043aa-0b65b92d5657218-7379356f-5a900-198ed5a8f043aa':
        'bdd87dcd-bb60-4654-bc8e-d6b9dac04588',
      '$device:198eceb03ee192-076ba2d1b997da-5c412e-55c74-198eceb03ee192':
        '3c2f3231-fff5-4516-ad12-41cb3579fef6',
      '$device:198ecbf916526b-0ffafdf5ace2e9-27604a30-5a900-198ecbf916526b':
        '4423fac1-3a61-4787-94eb-7ea1e6385ab3',
      '$device:198ecaebb9f2c0-09f023bf5b9cd48-7379356f-5a900-198ecaebb9f2c0':
        '705aca2d-8153-4d01-ac74-3bf5e0b3cb44',
      '$device:198ecaf3a6d32c-039f7d4887e543-7379356f-51bf4-198ecaf3a6d32c':
        'f076e172-dae5-44f0-a4c8-f76e6b865525',
      '$device:198ec9d50be4c5-0f98b4307cf686-27604a30-505c8-198ec9d50be4c5':
        '03324b7b-1d5d-49aa-ad9b-154b233f9896',
      '$device:198ec941fc026e-0fd2c4c440e8fc-7379356f-505c8-198ec941fc026e':
        '5a5d477d-5f85-4498-8fcb-ed52ea3be015',
      '$device:198ec9617eb3d9-0f801d36ab6d3d-7379356f-3d10d-198ec9617eb3d9':
        '14ba13a5-29f8-40e4-97a9-d56f0a8306ba',
      '$device:198ec655d11aaf-0d80730a070c748-b457459-4e000-198ec655d11aaf':
        'c04cbcd3-5b8a-43a7-bf58-cfbac54b5ec0',
      '$device:198ec37a555179-094ee3717d6679-27604a30-61d78-198ec37a556179':
        '89050cdc-749f-4ced-ab13-49aeb3de6058',
      '$device:198ec12bb9e455-06691c3e0f3156-7379356f-505c8-198ec12bb9e455':
        'e2f9861d-ef26-4d78-86b3-cd0164f81e20',
      '$device:198ec114f3b29a-0cae96359ab1df-7f643058-61d78-198ec114f3b29a':
        'a97a49f4-782c-45fe-abb8-28644b09044f',
      '$device:198ebd0ad5f5ac-06919a075d222d8-b457459-37a00-198ebd0ad605ac':
        '062da44d-a041-4a8f-abe1-9f4fd3e63d80',
      '$device:198ebdcad8c3e7-02058d6c7d27cb-b457459-97560-198ebdcad8c3e7':
        'be2a1d6d-05aa-4190-95fb-7dd4f4486b8d',
      '$device:198ebc01943570-0dde7eb5850e0b8-27604933-505c8-198ebc01944570':
        'b2c6681d-bac6-4958-965c-0e39e27de44b',
      '$device:198e5014bcb875-071907093ac34c-b457459-6ac5c-198e5014bcc876':
        '8b62d937-e3a1-4a9d-90f2-5af1db9afab7',
      '$device:198eba52639315-00434ab4c1dce7-b457459-5cbd8-198eba52639315':
        '8d42b9d5-b637-42cf-94ee-95ba5d5f2b04',
      '$device:198eb7432c03ab-0fd9bbcc86a611-27604a30-5a900-198eb7432c03ab':
        'd1959a9b-7b47-4d57-a252-b2995442caf3',
      '$device:198eaf72731267-091c23260cdef18-7379356f-5a900-198eaf72731267':
        'c251fb1a-f9ae-4937-adfb-a1630e2337de',
      '$device:198eadd7cf7360-0a80e881d48fe7-b457459-4d400-198eadd7cf7361':
        'cb034a27-4d32-4030-81bb-f163378ed781',
      '$device:198ea54c8adbd7-006f0f1e7fa414-27604933-5a900-198ea54c8adbd7':
        '6208d813-aa67-4e76-9c05-91eb7ff968f5',
      '$device:198e87d2c4b325-028847467c6ac4-7f643058-61d78-198e87d2c4b326':
        '32bd45a6-b3ba-4deb-8389-69f14e0bc8cc',

      '$device:198e845c21c768-0740c63d3a41af8-b457459-5cbd8-198e845c21c768':
        '204c9940-bf20-4d7a-82a2-661f509d3348',
      '$device:198e82334b2508-0157136bdd90fa-246e4935-505c8-198e82334b2508':
        '384e42c6-1d21-4039-8bbe-2a6c307ce0ee',
      '$device:198e7f400256d5-08ead24b491fcc8-7c643258-5a900-198e7f400266d5':
        '537423f6-fccd-4152-b2a6-f35ada2c94f7',
      '$device:198e7d2686f1413-01dd063ffee1d7-b457459-4d09d-198e7d2686f1414':
        '3e904b97-492e-4482-a05e-40096e8e1ac3',
      '$device:198e7bbf1854e8-0e2894464bb484-69157d6c-448e0-198e7bbf1874ea':
        'fa23a3c1-ed65-4993-ab99-f52a9d5fba76',
      '$device:198e7a46ca6187-0250b5488c50658-2a4c092d-505c8-198e7a46ca6187':
        '59a2f3e9-1a31-4503-99f7-b57a0860d876',
      '$device:198e794bd452e0-02481a305e18748-7f7a3660-5a900-198e794bd452e0':
        'a84e982f-62cd-4bc8-8d76-a19e60592d7e',
      '$device:198e708f80bb9f-048e06f0dee76-b457459-43ee4-198e708f80cba0':
        '6a60c576-a2ca-477d-9ecd-ceebf421dd63',
      '$device:198e57d5ad9280-03c2e46d40ebce-69157d6c-4e000-198e57d5ad9280':
        '73e8602b-4c12-4714-a9f7-91c4192fdd1e',
      '$device:198e4ea73f5591-0aeb0d1bea44c88-27604a30-505c8-198e4ea73f5591':
        '8740de5e-384f-4b7b-9f50-6814ffc530d6',
      '$device:198da80bdf9228-0eab391ae0c1a68-b457459-448e0-198da80bdf9229':
        '0b66d99a-ba28-4e5a-8b6c-095260e3a2bf',

      '$device:198e46c5e6827e-0cc451fe7bdad18-7c643058-51bf4-198e46c5e6827e':
        'f0c230b0-ad95-4afe-bd50-74217a90d3e2',
      '$device:198e45a5e7832e-0e1bcad6b8d4098-7379356f-5a900-198e45a5e7832e':
        '244357e8-a882-4693-9a53-ed3ad4c30f68',
      '$device:198e3513cf335d-0a4ef4e87f4cc78-27604a30-66b20-198e3513cf335d':
        '772134d2-e7f2-47d0-b3a4-1ef608854ced',
      '$device:198e31729524e5-009d19037404a8-b457459-4e000-198e31729524e5':
        '57d1608b-eda4-4eec-a4e2-94aee9f9b55b',
      '$device:198e306479a514-0adc43f38db6d08-b457459-3cd4d-198e306479a514':
        '66d0736a-0194-445a-8a5d-f13eab826fcd',
      '$device:198e2c165f7a4c-05b2498ee78172-16201105-36240-198e2c165f8a4c':
        'd295b490-1a60-491e-9ba8-92197ff381cf',
      '$device:198e294a41a3d3-0d28844f5188d2-7f7a3660-5a900-198e294a41a3d3':
        '1e65e2e5-cb87-4fa0-8d0d-cfe51c079ac1',
      '$device:198e2665685b3f-0ec9a9567055d08-7f643058-505c8-198e2665685b3f':
        '490951d2-893c-4bf0-a7ce-9fcf71e5eb54',
      '$device:198e22698b13d1-074d728d99055c-5c03436e-51bf4-198e22698b13d1':
        'ea3910c8-45d7-40ac-a178-31a301a3affb',
      '$device:198e222e8b34bc-09259bb93004428-b457459-67c80-198e222e8b64be':
        'ce4b9243-3c13-4fca-bd7d-97ad30a4ae88',
      '$device:198e1f74f6a409-053014573dde3f-b457459-4e000-198e1f74f6a409':
        'e7cadd56-2bfd-45c8-8240-cedd03d9c23c',
      '$device:198e1f65108e56-0a89e82bd0ac4f8-b457459-37a00-198e1f65108e56':
        'c14bfb3a-645f-4464-ac5d-265011d7a106',
      '$device:198e1c3231b263-0d80e75c2f1999-27604a30-5a900-198e1c3231b263':
        'd93472d9-0de4-4907-895f-855b9e60e798',
      '$device:198e189d46b3aa-038ba20fa787d18-7379356f-5a900-198e189d46b3aa':
        'be5e6084-73c9-4508-a5ab-fee0c4592c7a',
      '$device:198e05a1766208-042f04d0a1af158-7079356f-51bf4-198e05a1766208':
        '7b14bb04-7a1d-4a5c-81c3-fe700a54ceee',
      '$device:198e00275a73df-02e1c42b21775e8-b457459-4e000-198e00275a73df':
        'fbd3ac2d-e797-4454-a12e-621508f3dcd8',
      '$device:198dfb1bc22284-058b4855b2ab798-b457459-459c0-198dfb1bc23284':
        '399b58ed-f805-47f1-b52b-5695c13bb29e',
      '$device:198df97bc2546d-025f9a38e344b4-b457459-4e000-198df97bc2546d':
        '8505945a-3334-432e-a0f4-436870e2236f',
      '$device:198df7a9cab272-03320d005300fe-27604a30-5a900-198df7a9cab273':
        '59d3a553-1035-4ae1-886b-7f98c15ce94b',

      '$device:198defe3bf22be-01ae70e301a635-7364365b-61d78-198defe3bf22be':
        '89958f52-b0af-4115-9475-6cfc18bdc836',
      '$device:198dee257494f6-082043e12387e08-3407877-5a900-198dee2574a4f6':
        'bbff16df-7047-4628-b3c4-f3c2dcad26e2',
      '$device:198de73c0182e8-04c84a2359c5e2-27604a30-5a900-198de73c0182e8':
        'cfe0bcaa-ddd5-4e8e-91a4-a6d971feb2de',
      '$device:198de5f6e7a33c-073031746aaa848-7379356f-505c8-198de5f6e7b33c':
        '986ff055-02ca-453b-8443-f178e177fa02',
      '$device:198de159845ed1-0f321b63330d8e8-b457459-50580-198de159845ed1':
        'cc22a5c3-ad5d-4915-bbbe-a004c55da60f',
      '$device:198ddfd1d2e35e-01490e29e3b8eb-b457459-5c3cc-198ddfd1d2e35e':
        '3522a217-7c6c-4748-aafa-2b13eabdc4f4',
      '$device:198de072d4a1cc9-04bf26e9681adc-b457459-6ba3c-198de072d4a1cc9':
        'fb2d3c15-8409-428d-8a42-8eda79e0e49b',
      '$device:198ddd4986547e-0a2bf1eefacc23-b457459-4e000-198ddd4986547e':
        'c23f7d13-fcc6-44d1-aad0-53c1282a0dbe',
      '$device:198ddc0230f2b8-0250220bb0c821-7379356f-5a900-198ddc0230f2b8':
        '2a6b9dd5-3d83-422a-9e4f-24a1ab3a37eb',
      '$device:198dda1523999b-066cbb14fd95bd8-b457459-4b1b0-198dda1523b99d':
        '49c7352a-56d7-4613-be05-8dd8d2b108b9',
      '$device:198dd9290ba44e-0d09e4542cd6288-27604a30-5a900-198dd9290ba44e':
        'add793e1-a1eb-45b7-a8a2-569434d5f959',
      '$device:198dd9da116447-0b44f1b94d029e8-27604a30-3d10d-198dd9da116447':
        'f805cb06-eac0-4dfa-8d40-e066aa366fd2',
      '$device:198dd91c826446-04084b3d22b4638-7379356f-2c600-198dd91c826446':
        '60795e18-8da5-47f3-9d28-7b11278739c6',
      '$device:198dd90582e1e2-02331c936795d1-7379356f-5a900-198dd90582e1e2':
        '42d17c81-f4a0-4643-9917-07248165e104',
      '$device:198dd8e60521c1-099fde2e345938-d462462-4a574-198dd8e60521c2':
        'a901301d-d7ed-442e-99b5-722d88c21b51',
      '$device:198dd766177132-0d3f020b6a5afe8-7379356f-5a900-198dd766177132':
        'eae9d896-6e38-4a74-a058-28b3c4de3ef2',
      '$device:198b49ba5c573d-0eba65d4bfe6518-27604a30-61d78-198b49ba5c573d':
        'a5e9ce05-bb43-4e71-be41-2aaaf8a13572',
      '$device:198dd6cbc1c66e-09803b5739c2018-7f6f3c55-505c8-198dd6cbc1c66e':
        '21f38997-759a-41a9-a9c8-c65dfed04506',
      '$device:198dd351688432-0b0d166da8a066-27604933-5a900-198dd351688432':
        '656327e1-9e33-4dfb-a073-39fcd0ca5e00',
      '$device:198dd18022d26c-0563788c0c011a8-7d643058-51bf4-198dd18022d26c':
        '8ab3a3b2-981d-4940-98c9-90783a99f838',
      '$device:198dd0ae16d482-05404c4630c73c8-7379356f-505c8-198dd0ae16d482':
        '08c9ae22-02b6-487b-83e7-10a83c172443',
      '$device:198dccd510b1b4-0dca743c6f95e3-7079356f-4a574-198dccd510b1b4':
        '7ed7e3a5-d372-4fbe-ae3c-d9d2abbfb35d',
      '$device:198dcc3ea8b35a-0348e156e6f177-5d03406e-5a900-198dcc3ea8b35a':
        '9f6250b6-b9c4-4892-9c9d-9bba46b2c4bd',
      '$device:198db23e07b46b-0a91d51eeb7fe78-b457459-4166c-198db23e07b46b':
        '635d8409-3de7-4943-b43b-4eb3a35c0751',
      '$device:198db507f1160c-051014b72e7463-b457459-3cd4d-198db507f1360e':
        '2fbc6d2e-e928-493f-b376-c1ace574651f',
      '$device:198db3d0225390-0c723d28c38be4-b457458-65400-198db3d0225390':
        'a18f410c-a5cd-4ac4-9708-a4646a3024e9',
      '$device:198daa2a937154-0a2f30c859256-7c643058-505c8-198daa2a937154':
        'b2f73d76-a34c-4987-b60c-236c0d2c0363',
      '$device:198da7c4150428-0c571694d40ab7-b457459-67c80-198da7c4150428':
        'ce4b9243-3c13-4fca-bd7d-97ad30a4ae88',
      '$device:198da4c705948a-05a56ec916cc13-b457459-4e000-198da4c705948b':
        '9f9c668c-aa58-403c-b002-a8c6f6b8fec5',

      '$device:198d9c3d6af334-0d46f7829206e18-296e4a30-505c8-198d9c3d6af334':
        'ce3c3234-90d8-42d1-a059-b2a4f4a448cc',
      '$device:198d9ac1cc25b7-06f277fa1201ba-771a5b55-fa000-198d9ac1cc25b8':
        '97282bc0-4be7-4cde-9a36-e4bbd09c76a0',
      '$device:198d9aa0fc0747-0486f4fd46abff8-7079356f-2c600-198d9aa0fc0747':
        '6e5ecfd5-fd0e-429a-9c76-804c590257ed',
      '$device:198d9780fa62cc-043b90234fb4318-27604a30-505c8-198d9780fa62cc':
        '59904761-7514-419f-b9af-ebc1edb4bad1',
      '$device:198d92a0ae57bf-0616541da6f2348-b457459-5cbd8-198d92a0ae57c0':
        '358d2fba-9694-4d46-ba47-fac0c5d1f2de',
      '$device:198d919b7a0625-08ec2e4d2aa5378-b457459-55188-198d919b7a1625':
        '42222f48-b315-4163-90ca-f504a7a77f0a',
      '$device:198d8fa6de6609-0412062aa19d868-27604a30-5a900-198d8fa6de6609':
        '49645414-60f8-4cab-a18e-06a6f00ed2ab',
      '$device:198d8e6cec347c-0cac2f001f995d-27604933-5a900-198d8e6cec347c':
        'f27e214d-7212-4274-a014-8113fc5504ca',
      '$device:198d8dfc1e1503-02281ef1908d0e-b457459-7fc33-198d8dfc1e1503':
        'c2161de5-0731-4f2d-970d-cf891c1e4c28',
      '$device:198d88ded836b7-042f9325cdade78-27604a30-55c74-198d88ded836b7':
        'badbfe89-5fba-4ebd-98e9-36ddff38ad9e',
      '$device:198d88ded836b7-042f9325cdade78-27604a30-55c74-198d88ded836b7':
        'cec15481-6a40-449a-81c6-a9e2acc691c7',
      '$device:198d860ed36376-07f53fedb70ecf8-b457459-4e000-198d860ed36376':
        '542be732-5735-4f39-ba1c-85800f4916e0',
      '$device:198d84caf32750-08748ef51b0e7d-69157d6c-4e000-198d84caf33751':
        'f8c8a88b-782e-4df4-851c-24c948f3c8d0',
      '$device:198d82394742da-047a06cea950b3-7379356f-5a900-198d82394752db':
        '915be2ef-f5b3-4b8b-89a8-db1058e2e6d0',
      '$device:198d819bc6a5e5-0775b500066756-b457459-6ac5c-198d819bc6a5e6':
        '20ef5f4b-28dc-4e44-adfc-2d0817a55124',
      '$device:198d81593984a0-0bc879150fe4a58-b457459-5c094-198d81593994a0':
        'ade765d2-809c-48e0-b180-16ccaa4a4c67',
      '$device:198d7f094c32ba-09928df0f83fee-b457459-5c094-198d7f094c32ba':
        '296df32f-b48b-4fd2-b93c-553d589a241f',
      '$device:198d7b927514b4-09be1ec378ac198-27604a30-505c8-198d7b927514b4':
        '54a77ea1-e50b-498a-90ae-ca71f35a4d01',
      '$device:198d7a105b78aa-0991c5d77067-27604a30-3d10d-198d7a105b78aa':
        '08c46330-1521-4245-808a-3f795cd8ce9e',
      '$device:198d70db18f4c1-04cdc9f7b895ee8-7c643058-5a900-198d70db18f4c1':
        'ee65f46d-d4dc-4bb1-af0d-3a3a9a31f3a3',
      '$device:198d6d97734313-0e9a3bcddd249b8-27604a30-505c8-198d6d97734313':
        '1c38dcbb-cca6-4cb6-974b-33e2ca616389',
      '$device:198d6721c83394-0df4887d126d91-b457459-65308-198d6721c83395':
        'f05a4e17-3df0-4fb0-8f1b-0a0cf78fc45e',
      '$device:198d6536569447-0eaeb34257da94-7379356f-505c8-198d6536569447':
        '2c03bd09-ef0b-4d42-b6c8-75441155ee7e',
      '$device:198d6444cb7541-0470a26263bbf6-b457459-4166c-198d6444cb7541':
        'b65a7ba3-6e26-44d4-877f-faa88fdc5a4a',
      '$device:198d600550b1ab1-09827958410f7b8-b457458-5c094-198d600550b1ab2':
        '4352e04a-a327-40b6-8e75-236af9a3be07',
      '$device:198d5ce842a17d3-0b059d82f2441-26011151-1fa400-198d5ce842a17d3':
        '7277d68c-323c-41d0-b99b-a5ef9bd5fcd4',
      '$device:198d57c65cd354-051c7d2e1ccbd48-b457459-4e000-198d57c65ce354':
        'b992adb3-d399-43e4-964e-100e9b70c98c',

      '$device:198d4775794369-0927b6dab2e697-7079356f-505c8-198d4775794369':
        'fb37b67a-7f4b-40bc-8f99-304b51b625a7',
      '$device:198d441f579261-083f14fb57e7f38-27604a30-60c28-198d441f579261':
        '338e135a-b5b1-4d80-9036-bbbf25373552',
      '$device:198d424a09f150d-0c34c8e516eed7-4457373-4a640-198d424a0a0150e':
        'dfcef249-79d9-4a29-b5c5-ea1a6a3c7cfe',
      '$device:198d43815965d1-0c9f207e9f3c7d8-b457459-5cbd8-198d43815965d1':
        'f7ebe523-f656-4867-8d65-0103652d0579',
      '$device:198d3d00ab9102-005f0e03a423a1-27604933-505c8-198d3d00ab9102':
        '7ac12fdc-2ff0-480c-811c-25a1eeae8836',
      '$device:198d3a8c53c288-00276950b618da8-27604933-5a900-198d3a8c53c288':
        'efba4c4b-08b9-4242-9e0c-634e76f8cdbf',
      '$device:198d380d8b0272-0c210d5716d7f1-7f773460-5a900-198d380d8b0272':
        '0d968bce-8a75-4b07-a6b8-f9c12e938c02',
      '$device:198d360752b4f8-08f2bc0ac6edc3-b457459-4e000-198d360752c4f8':
        '3b85f5bd-107c-4ae4-baf7-db63975d5b4e',
      '$device:198d35950926dd-065b6b2236cebb-69157d6c-50580-198d35950926de':
        '1a3c86db-dbb1-4979-8a6d-8b3023e60de7',
      '$device:198d349f4cf620-07788bafd5418f-b457459-382c0-198d349f4cf620':
        'b3dd3b87-7d9e-4c65-aaf4-616e21721a24',
      '$device:198d2ff30d6400-07e4bd81ebfad1-b457459-4e000-198d2ff30d7400':
        '1cf332e1-53c5-4fd6-921b-923f9fa4bed8',
      '$device:198d2c321322c2-0678566ffbb82f-b457459-4e000-198d2c321322c2':
        '5a624a09-7cf4-42d1-a92e-811bbfb4c97d',
      '$device:198d2c47414401-0bb034d04f59c5-b457459-55140-198d2c47415401':
        '3a0a01d5-e965-4e9e-8cad-f6c719b925e8',
      '$device:198d2b8c77f6b6-02ed9760ace2ca8-b457459-50456-198d2b8c7806b7':
        'f81c85dc-ec60-4fb1-bb8c-96c35b241999',
      '$device:198d0c710e43ad-0753fdf5051584-7c643058-61d78-198d0c710e43ad':
        'c1dc5457-50a6-41a8-bba2-ddf1e9863b8c',
      '$device:198d081bf761171-044d6ed1fbc0de8-b457459-5360d-198d081bf771172':
        'd102c080-6d98-42d2-ac95-5c456bdba5f4',
      '$device:198d060290637b-0c9158660ffc738-b457459-37a00-198d060290637c':
        'c4320f65-ebd2-4260-ac66-6d912020e0d6',
      '$device:198cf73164a55b-0d7503f60f32498-b457459-4e000-198cf73164b55b':
        '80526477-d7f4-4545-85b1-e98bb6168627',
      '$device:198cf4a865b622-0579336b8a790a8-7079356f-5a900-198cf4a865b622':
        '42109d52-d2db-49fe-a8a5-08b36a745b3c',

      '$device:198cf424e5111cd-0a9549b029be278-b457459-48000-198cf424e5211ce':
        'd8497cbf-cebe-4146-8da7-bdcd9e4105a8',
      '$device:198cd74ac8314c4-0596631de21f69-b457458-37a00-198cd74ac8414c4':
        '861408b8-59fb-499e-bc1f-9efc1cc05087',
      '$device:198cd43a602844-0f0268fd567cc8-27604a30-3d10d-198cd43a602844':
        'e7ab91a7-67ca-4b82-8257-e52c9a5622af',
      'device:198cd425915275-0e028d086b80de8-27604a30-5a900-198cd425915275':
        '3fea22f2-50bb-451f-a97e-d4b709e0667f',
      '$device:198cd05c53a4f2-04301dab6515cc-7079356f-505c8-198cd05c53a4f2':
        '26cfd92c-491c-480c-9a12-14d949d8cdf9',
      '$device:198ccdd5964888-0487519a73c8f1-7079356f-505c8-198ccdd5964888':
        '0cf6c666-d362-40d8-8ce9-25f90291680e',
      '$device:198caf71c5e498-0ff264f39fe408-b457459-5c094-198caf71c5e498':
        'f273706c-0114-4f34-a15e-b5964f3007c3',
      '$device:198cc0e22d54b4-054c5795f1f59-b457459-4e000-198cc0e22d64b5':
        '24eab7a4-6f5b-4178-9491-52284ba48819',
      '$device:198caf2aec82da-0a123095154cf38-b457459-43da0-198caf2aec82da':
        '41e8c717-682a-4907-8fc9-e0cdc155f23c',
      '$device:198caf2aec82da-0a123095154cf38-b457459-43da0-198caf2aec82da':
        '9b3b5d7b-536d-4ce2-8366-9440a968fdf7',
      '$device:198cad91e2b548-02aaf7d9f93efc8-b457459-3cd4d-198cad91e2b548':
        '63502d26-be94-4084-88e7-99094df86311',
      '$device:198c9caa1c93b8-0c079ffa67fc308-27604a30-3d10d-198c9caa1c93b8':
        '96544a7a-939c-4026-80e6-6497c4e0b3d2',
      '$device:198c8d2801db71-080c872051a63e8-5303436e-505c8-198c8d2801db71':
        '883237c9-8a04-4c56-8956-214b7ddae77f',
      '$device:198c926e7bd10f1-0097b10723debf8-27604a30-3d10d-198c926e7bd10f1':
        '2c65280b-46b0-493c-8093-f9b4853a19fd',
      '$device:198c8fe4b0b421a-0b503df894f3748-7f793560-3d10d-198c8fe4b0b421a':
        '84baaec9-7be1-40ed-88b1-2dfb0f676fe4',
      '$device:198c875d2fb3a0-0b426b6f2a70c8-b457459-5c3cc-198c875d2fb3a0':
        '73bf50d8-7a0a-44c9-96b4-f97fcf6921a3',
      '$device:198c84218d3222-06694f8bcd1991-27604a30-2c600-198c84218d3222':
        'e352229a-2b41-4d01-acc0-1d69161ec205',
      '$device:198c7dc136fb05-08ea6100b927038-b457459-4e000-198c7dc136fb05':
        '291cadf1-5862-4428-b556-a5cadfca6c97',
      '$device:198c7364ca8274-046b5781b416228-7079356f-3d10d-198c7364ca8274':
        '4426f2fb-976d-40c4-940d-61b30f7394f4',
      '$device:198c6dfdbcc4cf-01d6dcdec4355f8-b457459-65400-198c6dfdbcc4cf':
        'ddc8750d-15c7-49ff-beea-34d500b03d01',
      '$device:198c68fe0a051f-01352199134873-b457459-431e0-198c68fe0a051f':
        'a89d99a5-de2c-4fe2-b2d7-6480baf49ee4',
      '$device:198c642e51f226-072a33580d77c98-27604a30-5a900-198c642e51f226':
        '0875b7f9-02bd-494c-8c4b-2384574c0dfc',
      '$device:198c61dc6bae4c-09ab437d363839-b457459-5c094-198c61dc6bbe4c':
        'f88e6c55-e4ba-4cf1-8933-4bf2f94dadab',
      '$device:198c607963e718-0964d781a03a1f-27604a30-505c8-198c607963e718':
        'f8da552e-0e13-4b94-be9d-23fabacaf01b',

      '$device:1989563b2ca7f6-08473435a21e298-7d643058-4a574-1989563b2ca7f6':
        '0809313b-c8f4-47e8-833a-ef3344885dc7',
      '$device:198c319b4227ec-02014d5aab03d88-28757140-7f684-198c319b4227ec':
        'e7a3cd96-0382-4218-9fa4-1d9e3d80822e',
      '$device:198aeacb9e030a-017c86b43d0bb68-27604933-60c28-198aeacb9e030a':
        'd929f6c1-9c5d-4817-9136-0dd86cd22ada',
      '$device:198c159c39e383-0b0dd37d41bb21-b457459-37a00-198c159c39e384':
        'ff72414b-a5d9-4cf3-acad-c7bdd32c0062',

      '$device:198bfe0a9383fb-03169bd04fe0768-b457459-36380-198bfe0a9383fb':
        '553032a2-3193-4c98-8318-4e9f28caed81',
      '$device:198bef9e09f158-02ebe286354fe58-27604a30-3d10d-198bef9e09f158':
        'fa20f86f-0c8b-4550-9afb-a4849afefce3',
      '$device:198bea021d6431-08594f520b5bd28-27604933-505c8-198bea021d6431':
        'd929f6c1-9c5d-4817-9136-0dd86cd22ada',
      '$device:198be7c90bc4c7-0b5180bd1c4b058-b457459-65400-198be7c90bd4c7':
        '1e586870-0cc2-4188-9aff-f83ab3cc98ee',
      '$device:198bdef80b83ee-0b5a39bedcb426-69157d6c-4e000-198bdef80b93ee':
        '84b51980-23dc-4978-85a1-90ba50d86978',
      '$device:198bda005d732b-02f6a0656b570a-b457459-3a5c0-198bda005d732b':
        'a36dc889-d439-4f4f-85e8-6cc72247c7e9',
      '$device:198bbb637b9459-02ba56d20dd1a18-b457459-65400-198bbb637b9459':
        'e14c61c7-9b49-4b8c-bff7-2cc1472455ce',
      '$device:198bbe678e49a7-04f9947e705dd4-b457459-5c094-198bbe678e59a8':
        'fe392c41-a302-412e-84da-cd73d0746cac',

      '$device:198bb521d2e2fc-0778fb796a82158-7c643058-505c8-198bb521d2e2fc':
        'd9fa1209-225b-4234-ab9c-679f5df1669e',
      '$device:198bb42a10b234e-06eac2c4891ac9-483d7a1d-518f4-198bb42a10c234f':
        '4df3d5ba-28ff-49fc-ad67-b1d8d3da1140',
      '$device:198bb244582409-093e0e321b91b58-27604a30-5a900-198bb244582409':
        '6549d396-b26a-404c-9a00-8d8ba3ffe397',
      '$device:198baf7ec3560b-0a5cae9fa7f453-b457451-4e000-198baf7ec3560c':
        'a040439b-60f5-47ed-b4d9-1fd0295d634d',
      '$device:198baee9db4288-0f7eac154178fd-27604933-505c8-198baee9db4288':
        'a8253c1b-1ef1-41f8-963f-f23d0fad4f4a',
      '$device:198bab32a765a4-0b18d1a6a71d8-27604933-5a900-198bab32a765a5':
        '32fc1399-997c-4ec9-995e-f249d7c61c9a',
      '$device:198b94b17656a5-0e6b47e59b1e278-7079356f-505c8-198b94b17656a5':
        'ce8e8738-7436-4f69-8f20-e75c959270e1',
      '$device:198b8fb82a9512-028badadfb0383-b457459-5cbd8-198b8fb82a9512':
        '0e0d1a03-c737-4a7e-9702-e6d04a7470a4',

      '$device:198b55f5d4a529-0386952e30e3058-27604933-505c8-198b55f5d4a52a':
        '45df44b8-1b49-4b75-b892-cc82801acc46',
      '$device:198b47b339d3cf-05a6da57566dd88-27604a30-5a900-198b47b339d3cf':
        '1a2b5b5f-82e7-44b8-8ab1-96395c551feb',
      '$device:198b3a7f60c304-092ff4e92ecbe6-27604933-2c600-198b3a7f60d304':
        '99f5e5bd-fc78-4884-95a9-94ad14cf02da',
      '$device:198b3997a5524d-03b2c81f80b063-27604933-61d78-198b3997a5524d':
        '65c6d3e1-15cc-44b9-b5ba-f3796190defc',
      '$device:198b2e45864328-0dbd799d079588-27604933-2c600-198b2e45864329':
        '0b4a215c-e674-4a9e-abb5-c4422d330517',
      '$device:198b2cff6f710c9-0ff2396461d063-b457458-5c094-198b2cff6f910cb':
        '98f7b525-6a14-4050-ab72-eb380f36c08f',
      '$device:198b185ec7350e-052c19e6125ab08-27604a30-505c8-198b185ec7350e':
        'b016ef70-42df-44be-b7d6-114b334d25b4',
      '$device:198b13f5405303-04ee1a41d2d50b-b457459-5c094-198b13f5405303':
        'bd15634f-ec0c-438e-9c69-ef3abd83cfec',
      '$device:198b12508671a76-0a7a8acffa9ded8-b457459-4e000-198b12508671a76':
        '8390f1cc-6a76-4724-b9d7-72997f24e9d0',
      '$device:198b11ab0d5408-0f8610f526bcfc-69157d6c-4e000-198b11ab0d5408':
        '5cdb3861-6c7d-4500-afe3-1d47fe23f3cd',
      '$device:198b1115b60400-0f5eaf3c81b54c8-b457459-38f40-198b1115b60401':
        '212a9c35-0aea-4cba-af59-66a1e4c37c70',

      '$device:198b086a11acdc-090d1c308a60f98-b457458-38400-198b086a11acdd':
        '33dffcb3-22fa-4ca0-a410-9cba954a4f50',
      '$device:198b086a11acdc-090d1c308a60f98-b457458-38400-198b086a11acdd':
        '0a4e1a86-2fb9-4e44-a915-2e5c65ebf3fb',
      '$device:198afa02f2f2cb-043701110ef1228-b457459-518f4-198afa02f2f2cb':
        '9a35d9dc-8a91-47f9-b5da-9d3acfd56a09',
      '$device:198ae2bd79b1f7-0a8a1cdc7cda228-27604933-5a900-198ae2bd79b1f8':
        '1797a4c8-6cb7-4d1a-aa32-90a7520c1e6c',
      '$device:198ac755a6744f-04c8c91333d61c8-b457459-46938-198ac755a6744f':
        '3ed0c316-e8c1-4be1-a6d6-24c0c936d798',
      '$device:198a986928cabc-05568da3556e87-b457554-48481-198a986928dabd':
        'e96ecafb-3b74-40f9-bcde-f9fc99769d05',

      '$device:198a618d6ad58c-0a55d5f14a98bc-b457458-4e000-198a618d6ad58c':
        '774cbdd1-ce13-434b-9396-83b565b6b526',
      '$device:198a57d14e2704-09ebebd80ad2af8-530e3746-37a00-198a57d14e3704':
        '609f81a7-e9a7-4019-884c-9d5cffe95c31',
      '$device:198a602dd9f1a0-079df15abb3b6c8-7d643058-36240-198a602dd9f1a0':
        '2ba5b43a-b406-412a-9626-88ba7b44b16b',
      '$device:198a564c22e534-0fb1520ef49ded8-b457459-4e000-198a564c22e534':
        'e1aff822-b3f0-4c05-9fa6-f42db7c25d8a',
      '$device:198a51c7d1096c-075d7a878bc505-b457550-46500-198a51c7d1196d':
        'dcf5c088-f6fc-47ae-bd7c-a7f28e63adb9',
      '$device:198a2108992464-00cb14e4f411cc-b457459-4ca68-198a2108992464':
        'c2d78de5-0af3-4396-8172-9d5918bf152c',

      '$device:198a1266f847cf-02601329885f87-b457458-46500-198a1266f847cf':
        '363f52e6-e1ec-454d-8f30-11213d4de6ac',
      '$device:1989ffe00e51c1-04d6d27cae0106-b457459-4e000-1989ffe00e51c1':
        '7f13f576-57e9-405d-b36d-ce81fdd0b3ed',
      '$device:1989fd65982b57-00869e3b33576c-69157d6c-59b90-1989fd65982b57':
        'e7d30cce-214f-459c-b8bf-204a5dd66e41',
      '$device:1989fbb119b8bb-0fe6a6c8c7df108-b457458-4e000-1989fbb119c8bb':
        '930dd1f8-a035-4f01-bd91-9d2d20bbce51',
      '$device:1989ec0f311418-0ddcd5e103846e-b457459-4e000-1989ec0f311418':
        '930e8944-ab2a-43ce-b61d-76a33aae18a5',
      '$device:1989d8fdbe4260-004a2190ccc6ce8-27604933-66b20-1989d8fdbe4260':
        'f490458c-9bb2-46e4-8394-989283a0d55a',

      '$device:1989a6dda40742-0149aad1118597-b457458-5c094-1989a6dda40743':
        'df048506-74b5-4caf-b1b2-a40f27c7d53e',
      '$device:19899c8b323f9b-0d13dcf8d73423-69157d6c-5c094-19899c8b324f9c':
        '9929e90b-8341-4e4a-ad06-ff384e35b512',
      '$device:198992f4c88daf-0996f1d2c5e21d8-6b423055-3fa22-198992f4c89db0':
        '09028f95-1df6-4aa3-ae5a-ac9cd90c388d',

      '$device:19893eb69125bf-0a031fa0d31efc8-27604a30-505c8-19893eb69125bf':
        '9b3d3c3c-f856-4b4b-9864-e1347984ef20',
      '$device:19896d947fe10d-0061f67ec23e97-7d643358-61d78-19896d947fe10d':
        '93687d74-22d3-4fb9-8ea4-54cddfcf1104',
      '$device:198952ef6fb4de-03e6b6ac9001ab8-7d643058-61d78-198952ef6fb4de':
        'c7b467bf-2621-4098-a3f6-ef7ae5a9b379',
      '$device:1989444b35d3f4-0ff85f22eadf62-b457458-48120-1989444b35d3f4':
        'f6269379-772e-431b-a588-25f673083e33',

      '$device:19891254c91ee1-01764c75d79e378-b457459-4e000-19891254c91ee1':
        'e17bb8dd-c1ab-4b2f-8cd6-613aac962882',
      '$device:19890f68763879-01d4b52657592b8-b457459-48000-19890f6876487a':
        'f064ab41-d437-46ad-ad07-26de5cc686ca',
      '$device:1989125ac9137a-07f6b6826fe22e8-b457458-37a00-1989125ac9137b':
        '1f5aade2-a0cb-4178-92c3-38ab3aab27ba',

      '$device:1988263e500da3-09dcdc83d7fb0b-26011151-100200-1988263e500da3':
        '00d74646-c608-45c6-904c-fe1f1e689830',
      '$device:19881ab9b5e1350-0c2e97d81ea0da8-26011151-100200-19881ab9b5e1350':
        'bb8939c1-431a-4b8d-a986-5983311d36dd',
      '$device:198823da6cc1085-0f7a2e87125509-b457458-5c094-198823da6cc1085':
        '70c3f6e4-7e51-457d-a8e7-c82d0d42f6e4',
      '$device:1988232d1ae1044-00428bd916d8c9-b457458-5c094-1988232d1af1045':
        '17fee04d-0349-437e-aa1f-f671d92d6f75',
      '$device:19880d9df38dcd-0b551c948d84248-b457458-5c094-19880d9df38dcd':
        'be83ca5a-847a-4e66-a09b-a33488d7f99e',
      '$device:19880bad61aea8-07c4fa824e4bf-b457458-5c094-19880bad61aea8':
        '377c7523-e763-42b9-a67e-0b6ef95e956b',
      '$device:198809f704c127d-0331c39d3d9b69-b457458-5c094-198809f704c127d':
        'c10566a1-a765-4ef0-820f-06c4f6a358e6',
      '$device:19880a988fb1285-03276993b89194-b457458-5c094-19880a988fc1285':
        '5ef650d6-5fc0-4cfa-9e06-93dfaa5320c8',
      '$device:1988094bea71c58-0d8a476b5fef058-b457458-5c094-1988094bea81c58':
        'ab87fc8b-f18a-48c5-84d5-12a63ad703c3',
      '$device:1987fb3736b1137-03b2b9c84de98a8-b457458-4e4c1-1987fb3736b1137':
        '8634bbff-3006-419b-b878-57aa3bff3ff1',
      '$device:1987f2ff6b951a-0dc3181f4e732c8-b457458-5cbd8-1987f2ff6ba51b':
        '81bed0f1-b9a3-47f1-8789-1fb4294f9ec9',
      '$device:1987e72e6b2303-09ea5d26e500058-301a563d-51bf4-1987e72e6b2303':
        '8f45b4c0-af90-49f9-906f-324aeb1946ca',
      '$device:1987df683abd13-0214efcb6903258-26011f51-144000-1987df683abd13':
        '0978c62f-4eb9-4a27-adb1-0fdd485b22c2',
      '$device:1987d9374ee2895-0410af4245832d-b457458-46500-1987d9374ef2896':
        'cef30575-512e-4412-baf0-487622d7bb12',

      '$device:1987d3424061121-0bb67a7aa80b45-26011151-100200-1987d3424061121':
        '9eb2f233-103a-46dd-8176-bb7287a55b93',
      '$device:1987d24291913a7-072edec49b5ae-26011151-100200-1987d24291913a7':
        '7bc68ee0-825e-4e4f-9c1b-7e50a24be86f',
      '$device:1987c811cfb134a-0b04d6d90ffb3c8-b457458-5c094-1987c811cfb134a':
        'f1c44871-6e79-494d-8f6f-363724d0e28f',
      '$device:1987c03408910d3-06c3263a5965548-26011151-100200-1987c03408910d3':
        'ab589a83-cae5-4325-ba7d-8048a0c055ba',
      '$device:1987bfa1ccd1306-03278bf6d72bc88-b457458-5c094-1987bfa1ccd1306':
        'b375b013-71fc-456a-9ad7-3c0c6324cc17',
      '$device:1987bb98df6377b-0cd5837d682922-b457458-5c094-1987bb98df7377c':
        '31314f30-0e39-41da-a0d8-151be1e829f3',
      '$device:1987ba2e09b19fc-0a427a5bd73f3f8-b457458-5c094-1987ba2e09c19fc':
        'aabfb500-0b5b-4730-b2c0-5079acd2e714',
      '$device:1987b9d7bb48b2-0f21b0974a37f5-b457458-5cbd8-1987b9d7bb58b2':
        'c6af58c5-25fc-48a8-9169-6dad645ae337',
      '$device:1987b86c90a142b-0263e24164e4d98-b457458-5c094-1987b86c90a142b':
        'f5415378-edd8-4cf3-945e-07ff3f6d8c5c',
      '$device:1987b76ada837f5-0e3b705107a25f8-b457458-5c094-1987b76ada937f5':
        'dd042df9-d697-427f-820d-b244878f10a9',
      '$device:1987a02381924aa-0b9bbe19d52105-26011151-144000-1987a02381a24aa':
        '0ab6d819-b4ca-49ed-ab55-76df9062ecd3',
      '$device:19878ef5259486-0b4f9133f1789-b457458-448e0-19878ef5259486':
        '3acd0b33-f07b-40a3-9ea6-d053c6ce1402',
      '$device:19878cb7f428ec-0889d4212575e08-b457458-50580-19878cb7f438ed':
        '44cd3952-3255-4cb7-8eb7-071b91c97906',

      '$device:19831febc7a12cf-08ba043eafcf008-26011f51-144000-19831febc7a12cf':
        'dd01d068-7f21-4ed9-a196-b6af76b02630',
      '$device:19875924e761fa3-08ab42c2ea3a6-26011d51-e1000-19875924e761fa4':
        '1caa6072-ae0f-4d07-bbe5-3520b53d887d',
      '$device:198758cee2e2f1a-0a919f6000cccd-26011d51-e1000-198758cee2e2f1a':
        '83abb5db-a2a0-46f1-af21-93fcafb4564e',

      '$device:19872b8feb72211-065934e2736924-26011151-1fa400-19872b8feb82211':
        'e14e4980-ffa5-4fb5-be81-102a9c47df97',
      '$device:1987240429a67ed-0c3f4de4542b41-7d08236e-46500-1987240429a67ee':
        '5f640df1-6404-4b71-99d4-b56ec248e43d',
      '$device:1983d3061192b6-0aa03f3469713e-27604a30-60c28-1983d3061192b6':
        '7e3d2cad-3800-42b1-8741-0241cdbd3511',
      '$device:19830e4dc5f403b-0ef53fb3b320f5-26011e51-144000-19830e4dc5f403b':
        'ba017d5b-7b25-4e0f-b236-ef211d9efda8',
      '$device:19834212dca2d2-02ed40db77d4428-3862654b-ec3b0-19834212dca2d2':
        'a393ecba-b98a-42f8-b2b5-e6b7cc7a4a22',
      '$device:19834b782ca110e-0f9d9e47cdd3788-26011e51-1fa400-19834b782ca110e':
        'e3da3357-70cf-4720-9627-21f9a591c5d3',
      '$device:198657d847a2cd9-0a344d0239aac58-26011151-e1000-198657d847a2cda':
        'f1e7cdc3-29e4-4851-abee-4f57bb8a929a',

      '$device:198309648022e2b-0b4e3a58fe72de-26011e51-1fa400-198309648022e2b':
        'aa39d953-7a0b-427b-bc9f-febb08397d21',
      '$device:1983b9c7165dc4-091c89394334f48-26011e51-e1000-1983b9c7165dc4':
        '174645e9-6a4d-4adf-aadb-d2433ebfd5da',
      '$device:1983b9c78201a80-09f70226ddc9e1-26011e51-e1000-1983b9c78201a80':
        '4bf638f7-4e00-4614-a69a-02a49a95e0fd',
      '$device:1983a8fe7962a07-0937c41d835d63-26011151-e1000-1983a8fe7962a07':
        '28838802-3496-4e92-85ad-bcc90e9671f6',
      '$device:1983b9c66281a28-0896e4fbb332ff-26011e51-e1000-1983b9c66291a28':
        '14c4f98b-4b2f-4bb8-80a8-df7e5cd1cd5f',

      '$device:19861d96bfb18a-05695df2648d47-69157d6c-4e000-19861d96bfb18a':
        '4355f99f-3141-4bfa-89d1-7ab055522818',
      '$device:19863be604c1a9-0d5a0a14bb3e18-2e43092d-505c8-19863be604c1a9':
        '869b9e7a-d25d-4fe1-9b3a-92a4fe0697ca',
      '$device:19862f932302e86-0ca89b09ea6a42-26011d51-e1000-19862f932312e86':
        'd114bd4f-f7db-44dc-af4e-63a8d21e0d30',
      '$device:198627ed49c11f7-069ba663836e79-26011151-100200-198627ed49c11f7':
        'd41b8d6d-784e-4e06-a0ec-2cefb1b8694b',
      '$device:1986225bde71929-08d6ef924b69c78-b457457-50456-1986225bde7192a':
        '034fb4d4-668e-4e64-83bd-17f249e76de8',
      '$device:19862068057729-027fd02f87d97a8-b457458-50580-1986206805872a':
        '36ad17bf-1391-41a1-a585-1943c5c6500f',
      '$device:19861edbe9448d-03b215f5b922818-b457458-46500-19861edbe9548d':
        '93a04e99-ffae-482d-88b6-5f737dc4a03a',
      '$device:19861ed04f33b5-029f712f606c4f8-27604933-66b20-19861ed04f33b5':
        '5a461834-b46b-4d18-8dd5-5293b3bd1c38',
      '$device:19854e322292e11-002a387ada874-26011e51-140000-19854e322292e11':
        '3063e0ff-413d-45fd-9c1f-b8197bfc8675',
      '$device:198495f396f254-0384b5b7ccd4a8-27604a30-505c8-198495f396f254':
        'ea06a04a-494e-495c-8c62-f6a7ac540a8f',
      '$device:198608219e5668-05b98814e634678-4c657b58-144000-198608219e6669':
        '31bc13cc-6d45-4e80-8d06-73523a202455',
      '$device:19858647aac1d9-0eb12770c2898a8-2a6d4a30-3d10d-19858647aac1da':
        'eea093c2-7e9e-4e7f-ba2c-c036777241bc',

      '$device:19857f28fad56e-0234ad6f0379ed8-75115149-4a640-19857f28fae56e':
        'fbbd8bed-6633-4be4-9b97-c982c13bbaf4',
      '$device:198575dbd6320f-04c363cb1f0f0c8-27604a30-61d78-198575dbd6320f':
        '1929892c-32d2-439c-9ebe-0c68770c7fce',
      '$device:198533c21cb233-0f8617afdfcaa8-27604a30-5a900-198533c21cb233':
        'f3dd158c-2208-4a22-97c1-6cc4ccc46095',
      '$device:198519d38b828b-0d617e6f787e338-27604a30-5a900-198519d38b828b':
        '4c691694-7e0b-4f62-86c6-d62c0dcf34cf',

      '$device:1984efc57f63a8-0fa4568afe4528-b457458-4e000-1984efc57f73a8':
        '67b7b470-204f-4f00-9d0a-56e2416b5b80',
      '$device:1984e86c0d6dfd-09603bce9b8af18-26011151-100200-1984e86c0d6dfe':
        'e9dc77f1-8751-414c-bfec-914cde09c269',
      '$device:1984ea2b56214d4-0dbaf2b782d33b-26011f51-168000-1984ea2b56214d4':
        '2a4d822c-ce48-4b67-91fb-4e3802b44c37',
      '$device:1984eb67c5b1153-0f74e63d55917f-26011f51-168000-1984eb67c5b1153':
        'a8cfd018-4ef4-4109-88ef-4102e703a077',
      '$device:1984ea61fe1498d-0269e5337a28df8-26011e51-168000-1984ea61fe1498d':
        'be7ef641-9f24-473d-90a8-5234c6e223cc',
      '$device:1984e9091351082-05921494c538318-26011e51-168000-1984e9091351082':
        '79dc4b53-ccd9-47eb-a510-3ce2bd0d5742',
      '$device:1984c38927e1a8f-036b6de71d636b8-26011151-1fa400-1984c38927e1a8f':
        '509b6faa-6382-450e-9ef3-78dc5ede820a',
      '$device:1984c2aa72ac55-08086be829744e-26011e51-1fa400-1984c2aa72bc55':
        'fb128d61-a8ab-4e2d-bac0-f8d028e45a49',
      '$device:1984c1c5c66dae-01ba4e83777738-26011e51-1fa400-1984c1c5c66dae':
        '98006e49-59ce-4f2c-87bf-cbdc52c0ec7c',
      '$device:1984c04d4bbd57-056f0eba6515a98-26011f51-1fa400-1984c04d4bbd57':
        '0a62c39d-bd66-4dba-9a24-3e7f2bed91f3',
      '$device:1984bd6681e18fa-069a9e37ee657d-26011151-1fa400-1984bd6681f18fb':
        'cb10a069-fc0c-4b85-bbc4-d40b708e7430',
      '$device:1984bde7a4dda8-0f9a2f449741a38-26011f51-1fa400-1984bde7a4dda8':
        '4f537ae8-bb2d-42fa-b229-b0f729a48649',
      '$device:1984b9ca7e414ef-048ff03ae8936d-26011e51-1fa400-1984b9ca7e414ef':
        '6f2e672a-fb62-4a8e-a7a4-4125373fb9c9',

      '$device:198499f5915279-03b459c8ad0397-27604a30-505c8-198499f5915279':
        '9a7a7453-a4b9-4671-9422-bac432941c50',
      '$device:198495f396f254-0384b5b7ccd4a8-27604a30-505c8-198495f396f254':
        'ea06a04a-494e-495c-8c62-f6a7ac540a8f',
      '$device:198486a3626537-08a92c00476b828-27604a30-505c8-198486a3626537':
        'ee2f4ddb-2917-4ab1-95bd-900d002b2296',
      '$device:19847bb5fe6c15-050ec3af6e3c278-27604a30-61d78-19847bb5fe6c15':
        'bf9666aa-ca48-4034-802c-d3430c3c8fd3',
      '$device:198468ae86c2a3-0beedd4559fd5c8-b457458-5c094-198468ae86c2a3':
        '6c993036-a076-430a-8468-4f6493ef2f04',

      '$device:198404f664010a4-0548084df1a686-b457457-46500-198404f664110a5':
        'c479bae2-18e0-4627-ba56-8d185326f41e',
      '$device:1983b9ca1c42906-0ff8e9aacdd5c-26011e51-e1000-1983b9ca1c42906':
        'c777d0b8-1df4-4683-bddb-6f3e9e88fe64',
      '$device:1983b9c92791f41-0dcf000653eb808-26011f51-e1000-1983b9c92791f41':
        'c40e50ce-d2af-4bf3-82de-f1842af83db4',
      '$device:1983b9ca49a368b-052811f1c88558-26011f51-e1000-1983b9ca49a368b':
        'a1b19991-3c0d-4214-aaee-976444e9a86d',
      '$device:1983b9c850c1c43-05cb11c397c7758-26011f51-e1000-1983b9c850c1c43':
        'bdb9148c-798b-4e7a-95f8-aca06fb2a1d1',
      '$device:1983b9c7165dc4-091c89394334f48-26011e51-e1000-1983b9c7165dc4':
        '174645e9-6a4d-4adf-aadb-d2433ebfd5da',
      '$device:1983b9c78201a80-09f70226ddc9e1-26011e51-e1000-1983b9c78201a80':
        '4bf638f7-4e00-4614-a69a-02a49a95e0fd',
      '$device:1983b9c70cf19e2-0d60f539787ff08-26011f51-e1000-1983b9c70cf19e2':
        '6ba6c784-1615-4b96-be9f-a10fb5ceb076',
      '$device:1983b9c66281a28-0896e4fbb332ff-26011e51-e1000-1983b9c66291a28':
        '14c4f98b-4b2f-4bb8-80a8-df7e5cd1cd5f',
      '$device:1983a8fe7962a07-0937c41d835d63-26011151-e1000-1983a8fe7962a07':
        '28838802-3496-4e92-85ad-bcc90e9671f6',
      '$device:19839dec681e19-00ac2d3d9e3506-69157d6c-40b00-19839dec682e19':
        'fbd734f2-2cd0-48a0-9a3d-3757c1acdf5a',
      '$device:198394a737f3a5f-0b0b9735d1bf9f-b457458-38040-198394a737f3a5f':
        '69afee1e-aa48-43af-834b-81950fef3c8f',
      '$device:19838949477109c-03d6d3528dfe868-b457458-46500-19838949478109c':
        'fbb77586-a147-44d5-af64-0e8efe1c8873',
      '$device:198380edda25a9-098e855f5f53a58-b457458-50580-198380edda25a9':
        '156d3493-8075-4f91-9f38-1cf69443e702',

      '$device:198363d31e06de-0276881df2a1028-2e43092d-51bf4-198363d31e06de':
        'c2cc0d85-3de3-404a-b5d2-ed76365c39d2',

      '$device:198350172aa9fa-0902aff71cae7d8-26011f51-384000-198350172aa9fa':
        '753d3ad0-0bb6-4644-b84a-9ccd3faa0dc9',
      '$device:1983499daf518b8-0855bce06a62548-26011f51-1fa400-1983499daf518b8':
        '57181e67-33bb-49fc-b10e-37d573f7e46c',
      '$device:198336ec9c41af1-021872cfc97cca8-26011151-1fa400-198336ec9c41af1':
        '04d4a2f2-fa43-4b04-857b-5c253b2a42e5',
      '$device:198328c7dba1b8b-00a4ccfe564874-26011f51-144000-198328c7dba1b8b':
        'f5598186-177a-44c4-a8b7-0fe90e573197',
      '$device:19830e6aa36395e-006323da1da18d-26011f51-15f900-19830e6aa36395e':
        '13e1eaf0-c80b-435e-9259-f0bf84e4a0a6',
      '$device:19831dbac3217b6-052460f89843e18-26011151-1aeaa0-19831dbac3217b7':
        'fbbd9c62-f5c0-408a-91b4-433d62fc98f8',
      '$device:19831b02b921b58-07432be25d6342-4c657b58-1fa400-19831b02b921b58':
        '2a54fdf4-6786-4c14-8094-046bd73f584b',

      '$device:19831031281fda-060c16f3575577-26011151-1fa400-19831031282fda':
        '5a15b0cc-6e14-4979-b00b-f50819951204',
      '$device:19831032778302b-0581f606bfc4578-26011f51-1fa400-19831032778302b':
        '95d209b9-c872-4bce-b5f0-c2791b8c3c53',
      '$device:19830b33431d1b-04ee83f7ae8043-26011151-1fa400-19830b33431d1b':
        'a6a9270c-edcc-4a9b-b669-fb37bae0da05',
      '$device:19830c23d773cd3-07d388582f643a8-26011e51-e1000-19830c23d773cd3':
        'c4973e62-a637-44b8-8db9-a0c82e18be9e',
      '$device:19830c207a6da1-05b3b009bb867b8-26011f51-e1000-19830c207a6da1':
        'a89743ab-feb3-42e4-8bd6-a0e27a13dedb',
      '$device:19830c208a315e9-0f21eb42e02d15-26011151-e1000-19830c208a315e9':
        '7cb37b61-dd9d-4416-b465-bf970fb9d664',
      '$device:19830c1fce510e1-082433ec869a1b-26011151-e1000-19830c1fce510e1':
        'c36bf42e-2ab1-4224-85ec-463fe86ca9a2',
      '$device:19830c1fe401836-029c469973b3f18-26011e51-e1000-19830c1fe401836':
        'd5e7005c-dfdd-4edf-9612-cfb6c7a86abf',
      '$device:198309bc23fff0-0b6477350f268f-26011e51-e1000-198309bc23fff0':
        'f97c937c-8ede-4a6e-a750-6230677117fd',
      '$device:198309bbba110ab-019729b0d9e4db8-26011e51-e1000-198309bbba210ab':
        'c4d3a07b-2e20-4983-a589-ae0290157e7e',
      '$device:198309bb7f614d7-02401d67cbfa478-26011f51-e1000-198309bb7f614d7':
        'c67d4671-e1e3-4c54-8cdd-cbaf554379ac',
      '$device:198309baa55de1-0166b84db418578-26011f51-e1000-198309baa55de1':
        'c46ba2d4-34b9-4dd8-952f-4fb8380b0331',
      '$device:198309b6e5dc70-0003b42180ba67-26011f51-e1000-198309b6e5dc70':
        '6e60d0cd-69d8-4e71-ae8f-089befc38307',
      '$device:198309648022e2b-0b4e3a58fe72de-26011e51-1fa400-198309648022e2b':
        'aa39d953-7a0b-427b-bc9f-febb08397d21',
      '$device:198306805a3131e-06024f040db5c38-26011e51-e1000-198306805a3131f':
        '2b92050e-9cd6-4f2f-bf57-32d20e3d54a2',
      '$device:19830636c51127e-077f1f68eeb7f6-26011151-e1000-19830636c52127e':
        'ae5c0f0f-d75f-4b86-b85d-7feb763861c1',
      '$device:1983061e50514b3-0bcd8b9ebffae5-26011e51-e1000-1983061e50614b3':
        'f1e7cdc3-29e4-4851-abee-4f57bb8a929a',
      '$device:198306220ff3fd4-0b6c715e8f12ea8-26011f51-e1000-198306220ff3fd4':
        '8bcaa5a6-b630-4c57-889d-20348b4916ff',
      '$device:19830621d2e436d-08917b7bdc0b94-26011e51-e1000-19830621d2e436d':
        '67298e81-3ad3-4a60-99dd-95db2d7e2f29',

      '$device:198303cb4ff258f-095ba3289b6f928-26011151-e1000-198303cb4ff258f':
        '33b6ab8c-6a4d-4afe-b0ee-6b1d736e3992',
      '$device:19830395aad1c36-0322fbd8b1c27-26011e51-e1000-19830395aad1c36':
        'c8f3985b-9b64-4aa5-8d02-92db2c56a958',
      '$device:1983038850d27c8-01c0f3b6b095108-26011151-e1000-1983038850d27c8':
        '90bae0af-cd80-4e1e-968d-dc2bcc8e02e5',
      '$device:19830339c94fbd-00620eb0343ed98-26011e51-e1000-19830339c95fbe':
        '01a243a5-0067-461d-81ce-c30b267e1209',
      '$device:198302e7fa82d5c-06f18d740ba2218-26011f51-1bcab9-198302e7fa82d5c':
        'b992c189-e607-4977-b37f-d13f573ecacd',
      '$device:19830013d544510-05872002836c32-26011151-e1000-19830013d544510':
        'ddf14282-5e58-4c00-9a50-4d17403d8a64',
      '$device:1982fecc04486c-0b3c099a9a1908-26011151-4b9600-1982fecc04486c':
        'f8d83820-1274-493a-8252-ab4ebd102469',
      '$device:1982fe48fa9e37-0c47f8e34ec6358-26011151-144000-1982fe48fa9e37':
        '13705c41-3543-4ca3-9dd2-190f65af599b',
      '$device:1982fe423d645ca-02e45a2f23cec2-26011f51-144000-1982fe423d645ca':
        '4e10c1c7-7f0b-482b-921e-e8b3baa35cb5',
      '$device:1982fe3aa8fe22-0152d7183fb90f-26011f51-144000-1982fe3aa8fe22':
        '9e907cb4-e597-4daf-a6bf-f4e15aebdee7',
      '$device:1982fe3a2a0ca3-0555697549334b-26011e51-144000-1982fe3a2a0ca3':
        'f2dea7ef-6bc4-432e-8187-a0fc0069c468',
      '$device:1982fbacbe9f4e-06a41ec533ce8e8-26011151-144000-1982fbacbe9f4e':
        '910a5df5-a8bf-4670-9fb6-bf300164b606',
      '$device:1982fb902a5e6c-046bfc0091ae6d8-26011e51-144000-1982fb902a5e6c':
        '9e907cb4-e597-4daf-a6bf-f4e15aebdee7',
      '$device:1982fb61b3d3699-05f07f29c90d83-26011151-144000-1982fb61b3d3699':
        '01450ac8-5e59-4e45-8cf7-d5e90f917bbc',
      '$device:1982f3cb5eaabc-0eec998860ee17-b457458-53c31-1982f3cb5eaabd':
        '957aeb57-de95-4483-9b05-1812ede59ded',
      '$device:196f4a2fe9f301-004183cdd3db88-27604a30-61d78-196f4a2fe9f301':
        '14fcc6ca-eb9e-4c44-a225-71ca50881816',
      '$device:1982ee16cab7e4-0937c5c300442e8-b457458-46500-1982ee16cab7e5':
        'dbfc1105-e0f9-444e-bcf0-935ef4da4ff7',
      '$device:19833f8b9121e9-0c28963deb5e67-b457458-4e000-19833f8b9121e9':
        '4d36c919-a425-4b8b-bee5-d995dcec49f7',
      '$device:198304b20a7143e-07e5c89459ac58-26011151-144000-198304b20a7143e':
        'c1c6c3e7-7bee-4953-86ee-b562801eb198',
      '$device:198306ffb0ece6-0dca1c770fbce9-26011f51-144000-198306ffb0ece':
        '0aadd8ad-e453-4c74-8bc3-b5a938d00647',
      '$device:198306405e3736-03d90ec9d73499-6915716d-50456-198306405e4737':
        '732a1ce0-7632-4d14-84bf-20309856828b',
      '$device:19830a4c88e858a-09c82b742fbc28-26011f51-144000-19830a4c88e858a':
        'e6db0368-52ed-4110-a9e6-73ab9cfaa70f',
      '$device:198309b13ef168b-026548f0faf90e8-26011f51-1fa400-198309b13ef168b':
        'ca238cf5-daa4-4846-ba9f-9283171745fd',
      '$device:19830d8eb513b47-067a716638a7ac8-26011f51-1fa400-19830d8eb513b47':
        '4db643a9-7a16-480e-a332-356059854578',
      '$device:19830e48f7c4ca-096e42e3f0e85b-7f7d3160-505c8-19830e48f7c4ca':
        '0640581b-7e14-43aa-918a-b0af0554209c',
      '$device:19830e66b80d36-056db2377958d98-26011e51-1fa400-19830e66b80d36':
        '30da3aa8-021b-4e62-a4dd-20dd90bdadfd',
      '$device:19830f0985e4b2-0210d45a8b4207-b457458-46500-19830f0985e4b3':
        'f5028262-037e-43ec-b20b-b70bb9b642c0',
      '$device:198313d12d02ad9-0474196714062d8-26011f51-144000-198313d12d02ad9':
        '834c3828-ff8c-4504-ba64-d96e3cf744e4',
      '$device:19831e153c41357-0d07672765f511-26011e51-1fa400-19831e153c41357':
        'bfa7a48f-9247-4882-9361-894e3c29f09d',
      '$device:198320f0c719df-03ee6f2ef66a7d-26011e51-1fa400-198320f0c719df':
        'bca377cb-2d2e-4fad-a924-61631c8d4907',
      '$device:1983214619d1497-02cc095d90f0a9-26011f51-1fa400-1983214619d1497':
        '94999a69-886f-4b0e-bc6f-be52a4189b16',
      '$device:198327907191104-0778a3b97a745b-26011e51-1fa400-198327907191104':
        'ed11eb77-a082-47bd-b9d5-baf4515dc726',
      '$device:198328e506f1ab0-0edc2bf0cd9a038-26011e51-1fa400-198328e506f1ab0':
        'fb6961f9-a308-4425-8915-752cd85f7857',
      '$device:198329038a21db03-0a6acc48ba35938-26011e51-1fa400-198329038a21db03':
        'a0cadb0c-f756-4cb1-83af-9fbbdaf7904a',
      '$device:198329d983911aa-05fa35465c9309-613d2537-4ca68-198329d983911aa':
        '9ab427cf-00a9-4e17-90ec-aab9ec3ecf4b',
      '$device:19832a50046dc2-05f3131b6ddfde8-26011151-100200-19832a50046dc2':
        '734d5243-4083-44b6-9d94-09823939c2d7',
      '$device:19833065f1e257-0744c6a3143d0c8-27604a30-61d78-19833065f1e257':
        '047e76b4-9a2b-4a69-a009-2323830fcfd2',
      '$device:1983371e4813e84-0b5c26c343c4c9-26011f51-1fa400-1983371e4823e84':
        'c2693866-6148-4869-b4a9-f8a46d972b9d',
      '$device:19833f5f2633aab-046aed41c10e68-26011d51-e1000-19833f5f2643aab':
        '8699b943-2099-40aa-9d54-ea938bab7cd9',
      '$device:198346e733671f-0ebee222c59cd58-b457458-59b90-198346e733771f':
        '7dbce5b3-15d8-4630-be44-db251d707f6a',
      '$device:19834991cd2f6a-02abfac8fb02188-26011151-1fa400-19834991cd2f6a':
        '4adcb1d0-a051-423a-80b2-d9ace585b551',
      '$device:19834b7c65e1d7a-0939bbcb556ce58-26011f51-1fa400-19834b7c65e1d7a':
        'e3da3357-70cf-4720-9627-21f9a591c5d3',
      '$device:19834b7cb88165c-0fb3c5bf3d7adb8-26011e51-1fa400-19834b7cb88165c':
        '226bcf66-54ee-4017-abd3-7f5f75e2c43b',
      '$device:19834be6368e7e-0ad6c4ba024768-26011151-1fa400-19834be6369e7e':
        'f462598d-e417-4a09-898c-2e62cedbd0ca',
      '$device:19834bf6fdd1761-06beb184b45b1a-26011e51-1fa400-19834bf6fdd1761':
        '95ec05c1-3b02-41fc-82ac-7d290f472237',
      '$device:19834bf7e931692-02432e0e0849d4-26011151-1fa400-19834bf7e931692':
        'ab4ca952-c9c6-4ed1-97e6-657e55a9cd12',
      '$device:19834bf7dcbe8f-0e61bf2829b225-26011151-1fa400-19834bf7dcbe8f':
        '0a161e55-eaa5-4821-a7db-b7f03017f852',
      '$device:19834bfe38a5b45-06284eeff115d4-26011e51-1fa400-19834bfe38a5b46':
        '9689195d-53f1-4c7a-9695-246281faf408',
      '$device:19834e8b5443a8-09ce953a508b758-7c15296e-61d78-19834e8b5443a8':
        '93687d74-22d3-4fb9-8ea4-54cddfcf1104',
      '$device:198350555d56429-016a02950a1b1f-26011e51-1fa400-198350555d56429':
        'aa744b60-7c55-4299-8e7c-3fd6718b13a1',
      '$device:1983508ac1046e-0b112a9e70ecbc8-2f43082d-4a574-1983508ac1046e':
        '2b1608fe-ca98-4134-9efb-98b8c73e4d1f',
      '$device:198350a2421c70-03df3df2086608-26011f51-1fa400-198350a2422c71':
        'a2a487ad-aca7-4ea9-bae0-6ed2fe705a87',
      '$device:198350a3269126b-02ef3643d83958-26011151-1fa400-198350a3269126b':
        '292bbd6d-bf4c-4f13-b916-27b2193e6e61',
      '$device:198350a34edd1e-043d053abce75f8-26011f51-1fa400-198350a34eed1e':
        '2730e20e-9e14-4dc6-9e34-10f89641042f',
      '$device:198350a569d116d-072ade6666ecc1-26011e51-1fa400-198350a569d116d':
        '3756ae0d-89bb-423d-bc0f-5bc1e522290d',
      '$device:198350d6c59b71-0e254a8737fdae8-26011151-1fa400-198350d6c59b71':
        'be699a72-a1d0-436c-b9bf-77c230fd4f00',
      '$device:198350d7964fb9-095cc1a7749a32-26011151-1fa400-198350d7964fb9':
        'f0ad4a98-12f6-4f34-9d6c-2a86290afed1',
      '$device:198350d83ccedc-09a319ab3b45f6-26011f51-1fa400-198350d83ccedc':
        '6a527674-09f1-43b2-b93c-3bad42662e69',
      '$device:198350d8cdb101c-0fd025125a49148-26011e51-1fa400-198350d8cdb101c':
        '0defa588-7fd3-4bc4-98c1-2b084b492379',
      '$device:198350d9163c69-06dc93af0c728f-26011151-1fa400-198350d9163c69':
        'cba684ed-48e1-4ef4-b096-8ed46f06f602',
      '$device:19835130320359-0894330edfcb5f8-4e193301-13c680-1983513032135a':
        '684226bc-34bb-437a-b30f-b5f45b99b883',
      '$device:198353bd40b72d-008e6fd8978105-2e43092d-4a574-198353bd40c72e':
        '2a601c97-4d02-4746-8114-347cac93fd54',
      '$device:19835521954fe9-0409f35b4b20cf-26011151-1fa400-19835521954fe9':
        'd299f84a-fda0-47ee-84a9-3ffa064e2bee',
      // July 23rd
      '$device:198359deed53621-0246afa33026658-26011151-1fa400-198359deed53621':
        'b08f7aba-6ff5-445b-bee7-80a306311cbc',
      '$device:19835c10acb16d5-07213c70a4f1a5-26011151-1fa400-19835c10acb16d5':
        '80e669c5-32b2-45b7-8573-bfc8f0c1b6b6',
      '$device:19835e4655a7585-0124c676afb1dc8-26011151-168000-19835e4655a7586':
        '52b52e4f-e7c8-496b-9f5b-c9f70c994b73',
      '$device:19835faeb30185a-07112a42b41283-26011e51-1fa400-19835faeb30185a':
        '6f377e0d-5f6f-42c3-846b-403ca3e607b6',
      '$device:1983510744aa88-0cb0f5d31217f6-26011e51-168000-1983510744aa88':
        '1ba489e6-156d-4437-aa39-6c0fa9ae5887',
      '$device:1983652d4b1acc-02139fec37a01d-26011f51-e1000-1983652d4b1acc':
        'aae62106-812c-4079-b6cc-87b55b8b866f',
      '$device:198367cced96348-005d183bf1949f-26011f51-fa000-198367cced96348':
        '92e4be7e-94f3-4a12-8f6c-2ac05f80d9c8',
      '$device:198369b8a8ce96-0b4a81d91dbf6e8-26011f51-168000-198369b8a8ce96':
        '1345de4a-ce9b-4155-89ab-d4d531026c40',
      '$device:198369bc0fb101af-0231a1919db7bd8-26011151-fa000-198369bc0fb101af':
        '20032463-03b5-4e44-b2af-4389717bbd0f',
      '$device:19836a89c03c24-0dd78b8a021e408-5d701201-46d70-19836a89c04c25':
        'e038b72d-01b2-4b9c-b69d-9a740577fe8a',
      '$device:19836a99df34214-01e310a067449-26011151-1fa400-19836a99df34214':
        '1242d8a0-247d-4ca0-92af-ddaa22ea51e3',
      '$device:19836f00d621dc7-0bdfc7a7b1cc9b-26011e51-1fa400-19836f00d621dc7':
        'd4631d89-4d2d-4b01-960f-0a338e84c444',
      '$device:19836fff252d5d-0b0c2654bce3cf8-26011151-168000-19836fff252d5d':
        '8b2c35bb-5ca8-4661-85b3-e7c721096c1f',
      '$device:198370511ac2d3-023060fb643f828-b457458-4e000-198370511ac2d3':
        '67d7a14e-12c6-4dd9-bf30-9bfe20eb0de6',
      '$device:198372e0c9a39c-07b9073baacb78-b457458-4d09d-198372e0c9a39c':
        '14122496-2610-445d-ae54-05af86173efc',
      '$device:198375e4690d82-0a111dc13d0f798-26011151-168000-198375e4690d82':
        'e19226ce-afd5-45d5-91cb-82440204dc8e',
      '$device:19837a4656925d0-0212eeabe935cb-26011151-fa000-19837a4656925d0':
        '8290c5e5-3153-49c3-a8c7-4276e90edaa4',
      '$device:19837a478e93091-093b2c1424ffda8-26011f51-fa000-19837a478e93091':
        '39576256-a0ac-426c-a9a4-304a7e9d478d',
      '$device:19837a47f8a3aba-0b750ee384038e8-26011151-fa000-19837a47f8a3aba':
        'f48ccbd2-2e32-4ace-95fc-0ebe16b77cb8',
      '$device:19837bfed0933a-051c04c347e9f68-b457458-46938-19837bfed0933b':
        '2da2ed8f-dde9-4bb3-b2a5-4af6665b840a',
      '$device:19839962948358-06931ec92a63ed-7f7a3660-51bf4-19839962948358':
        '66be9fff-6cf4-492e-9e3b-5f594960de03',
      '$device:1983a1b535bb02-0f49cbc2f8ccc5-27604a30-61d78-1983a1b535bb02':
        '445130b2-d768-44b5-98e1-3f3bde65d787',
      '$device:1983a437e423d3-0921ca1487aa66-27604a30-5a900-1983a437e423d3':
        'cd7f8dfc-9dec-4a2d-b4f7-6a8350837c7e',
      '$device:19831168d70d83-0b547a9a3c8256-26011151-1fa400-19831168d71d83':
        '49c20343-b8db-49af-9b73-0dbf2a2a6967',
      // July 24th
      '$device:1983ab78f882e9-0ef31ce6155f3c-27604a30-66b20-1983ab78f882e9':
        'a0a25846-f996-4ac3-940e-1ba23073b3ac',
      '$device:1983b5119fc3fd-0d6ece26b42e6c-27604a30-51bf4-1983b5119fc3fd':
        'b652955e-3ba3-4916-a503-c7e715f381a3',
      '$device:1983c94e10929c-0bb06110eb93a4-27604a30-51bf4-1983c94e10929c':
        'd0f586b4-1070-459a-932e-8fc3ad74af14',
      '$device:1983ca9a76634a-0989b8e20e0b0b-27604a30-61d78-1983ca9a76634a':
        '957eef4f-766f-4995-8cbc-5d6bd0099ec7',
      // July 25th
      '$device:1984056a711bfd-0d4f16858cfa99-b457458-5c094-1984056a711bfd':
        'a8b81363-d3ed-4df0-af1e-f5b4a11cccc7',
      '$device:1984066901a410-0188ef4f8dd8c78-707b376f-505c8-1984066901a410':
        '7277f98b-bf20-4b73-be9f-24ea28c28c07',
      '$device:198406976d812f73-0a8c1db5e46799-b457457-46500-198406976d912f74':
        'c578d730-e5ee-46d6-bac9-a9cb4224f0e3',
      '$device:19840d10448719-0627a9da0be2b58-b457458-50456-19840d10449719':
        '7af781b1-4887-4215-83dd-5bdb641c91ed',
      '$device:19841384199f2c-07c3752e4426ec-b457458-50456-1984138419bf2d':
        'da320f18-5efb-4847-8a65-3cde923c2370',
      '$device:1984155d74943a-030a3368cd977f8-b457458-50456-1984155d74943b':
        '18669c08-ee62-48fd-b4f5-fbbd9d1eb45a',
      '$device:1984178d3d7432-06e64c617acc68-b457458-50456-1984178d3d7433':
        '4f37da62-79d4-4344-8d8a-26632537fbaf',
      '$device:198418eff013f2-09cc5d0048e44d-b457458-50456-198418eff023f3':
        'bc635e3b-c75a-42ed-9765-22b339d98c2a',
      '$device:19841f496bd1dc-0b8b4111944379-27604a30-60c28-19841f496bd1dc':
        '56be2c12-cfe2-44c5-9bfa-01cd86c7ce32',
      // July 26th
      '$device:19845ca788f51a-08b79b85d484588-26011151-100200-19845ca788f51a':
        '37aa4c41-eeba-4788-80c9-e452161010f8',
      '$device:19845ccb82856d-060890331572e48-26011151-100200-19845ccb82956d':
        '78c8a792-ae75-47e7-bd33-fd05b3b50e64',
      '$device:19845cd82dc51f-0be27f5aebb889-26011151-100200-19845cd82dc51f':
        'bd137561-7e57-43a7-bf5a-dcc936de888c',
      '$device:19845d041f1a5c-0294489bd5abed-26011151-100200-19845d041f2a5d':
        '80dff2a8-980e-4351-9f3b-a73b8c9b05ca',
      '$device:19845d1fb97cd0-0be427570ab4738-26011151-100200-19845d1fb98cd1':
        'aae9a931-5c7e-43c9-8c6b-1ff029823de0',
      '$device:19845d4bb9869b-05ce9c5277c1c9-26011151-100200-19845d4bb9869c':
        'e6cab955-2f33-431b-ada3-b482b9369042',
      '$device:19845d58fd611c4-07190d0c71916b8-26011151-100200-19845d58fd611c4':
        '17d377d2-678a-4d79-a486-e29568f2c96e',
      // July 27th
      '$device:1984e5e5b6eba4-0a087e34b0b0c28-26011151-168000-1984e5e5b6fba4':
        '07bd31a7-2e51-4f04-949e-7a71febce926',
      '$device:1984e86c0d6dfd-09603bce9b8af18-26011151-100200-1984e86c0d6dfe':
        '1fcb849d-2afa-4230-b532-9a74fcddfcb5',
      // July 30 to August 3rd
      '$device:19864360162b45-09ef4db2c3c0968-b457458-5c094-19864360163b46':
        '95adc2ca-176a-4375-94ea-5d9820a30506',
      // August 4th to August 10th
      '$device:19864b3feac11a3-0a7d6b8d97a81-26011f51-1fa400-19864b3feac11a3':
        '0fb02155-72a2-4cef-8d33-2dc6f3dc8106',
      '$device:1987c03408910d3-06c3263a5965548-26011151-100200-1987c03408910d3':
        'ae9a0e9f-c3a6-4f5f-999c-c71814e67f06',
      '$device:1982fb60bb01305-0fd8ab7fb400f9-b457458-5c094-1982fb60bb11306':
        '8aa897cb-63b3-4b6f-b041-ac5d900113b9',
      // July 21st
      '$device:1982edc702be44-08d4930fbc90af-26011951-1fa400-1982edc702be45':
        '62121e61-65b3-423b-a4b0-d2fba3bc9e81',
      '$device:1982f30c7ab5ce6-0d9a38e7a2d2a1-26031d51-144000-1982f30c7ab5ce6':
        '9f6a2491-e6cc-4af4-bce5-4a142a215cd4',
      '$device:19834b7c65e1d7a-0939bbcb556ce58-26011f51-1fa400-19834b7c65e1d7a':
        'd76a2131-98e9-4dde-92cf-ae3725a1aac6',
      '$device:1982ff6c13ed2a-0ca7ccf08f99298-26011151-144000-1982ff6c13ed2a':
        '805a224a-d02a-4d06-aac3-2721c134ba05',
      '$device:1984229c911453-0be9a2c48bf03b-b457458-50456-1984229c912453':
        '1b9f6885-f0db-4589-aaae-838865497b56',
      '$device:1982f463c34e63-097a490cc5d3dd-26031d51-144000-1982f463c34e63':
        'd4361f86-7953-4b9a-8946-f0e51d6b45c4',
      '$device:1982eeebbeadcd-00f262228eb673-b457458-48120-1982eeebbeadcd':
        '8c8a92a0-17dc-4250-9a1c-24f88a9de4d4',
      '$device:1982f1a20111dfc-09e109b186bc15-26031b51-144000-1982f1a20111dfc':
        'afe1c215-5254-4b2d-b65f-6eb700a784a5',
      '$device:1982ed5ac62ac8-0b50aa4d8e68d78-b457458-88422-1982ed5ac63ac9':
        '5127de39-8aad-4112-bf91-a4543a7ebbbf',
      '$device:1982eec8d228ba-0f4d426e59c6fd8-b457458-46d70-1982eec8d238bb':
        'cd4ab906-b25d-4cf3-921c-3675a748469c',
      '$device:1982fe6bb5766dc-0f93d8f7443dee-26031b51-144000-1982fe6bb5766dd':
        '5100a82d-cee6-4396-af27-4b68d39252ce',
      '$device:198351738d61ef-00ed5e850a8ba98-2e43092d-61d78-198351738d61ef':
        '93687d74-22d3-4fb9-8ea4-54cddfcf1104',
      '$device:1982ed59dbf3ebc-09bcb51195125f8-26011c51-1fa400-1982ed59dbf3ebc':
        'b27fef3f-053d-4949-83ad-cfe084d71a2d',
      '$device:199ef5dd9c0394-06cf29056641a98-5306456d-2c600-199ef5dd9c0394':
        '477c2829-3d9d-4dc9-9d00-bdaa703fe4ba',
      // Google Auth / Facebook Auth Users
      // BUSP ALI
      '$device:198303cb4ff258f-095ba3289b6f928-26011151-e1000-198303cb4ff258f':
        '33b6ab8c-6a4d-4afe-b0ee-6b1d736e3992',
      '$device:19830395aad1c36-0322fbd8b1c27-26011e51-e1000-19830395aad1c36':
        'c8f3985b-9b64-4aa5-8d02-92db2c56a958',
      '$device:1983038850d27c8-01c0f3b6b095108-26011151-e1000-1983038850d27c8':
        '90bae0af-cd80-4e1e-968d-dc2bcc8e02e5',
      '$device:19830339c94fbd-00620eb0343ed98-26011e51-e1000-19830339c95fbe':
        '01a243a5-0067-461d-81ce-c30b267e1209',
      '$device:19830013d544510-05872002836c32-26011151-e1000-19830013d544510':
        'ddf14282-5e58-4c00-9a50-4d17403d8a64',
      '$device:19830c23d773cd3-07d388582f643a8-26011e51-e1000-19830c23d773cd3':
        'c4973e62-a637-44b8-8db9-a0c82e18be9e',
      '$device:19830c207a6da1-05b3b009bb867b8-26011f51-e1000-19830c207a6da1':
        'a89743ab-feb3-42e4-8bd6-a0e27a13dedb',
      '$device:19830c208a315e9-0f21eb42e02d15-26011151-e1000-19830c208a315e9':
        '7cb37b61-dd9d-4416-b465-bf970fb9d664',
      '$device:19830c1fce510e1-082433ec869a1b-26011151-e1000-19830c1fce510e1':
        'c36bf42e-2ab1-4224-85ec-463fe86ca9a2',
      '$device:19830c1fe401836-029c469973b3f18-26011e51-e1000-19830c1fe401836':
        'd5e7005c-dfdd-4edf-9612-cfb6c7a86abf',
      '$device:198309bc23fff0-0b6477350f268f-26011e51-e1000-198309bc23fff0':
        'f97c937c-8ede-4a6e-a750-6230677117fd',
      '$device:198309bbba110ab-019729b0d9e4db8-26011e51-e1000-198309bbba210ab':
        'c4d3a07b-2e20-4983-a589-ae0290157e7e',
      '$device:198309bb7f614d7-02401d67cbfa478-26011f51-e1000-198309bb7f614d7':
        'c67d4671-e1e3-4c54-8cdd-cbaf554379ac',
      '$device:198309baa55de1-0166b84db418578-26011f51-e1000-198309baa55de1':
        'c46ba2d4-34b9-4dd8-952f-4fb8380b0331',
      '$device:198309b6e5dc70-0003b42180ba67-26011f51-e1000-198309b6e5dc70':
        '6e60d0cd-69d8-4e71-ae8f-089befc38307',
      '$device:198306805a3131e-06024f040db5c38-26011e51-e1000-198306805a3131f':
        '2b92050e-9cd6-4f2f-bf57-32d20e3d54a2',
      '$device:19830636c51127e-077f1f68eeb7f6-26011151-e1000-19830636c52127e':
        'ae5c0f0f-d75f-4b86-b85d-7feb763861c1',
      '$device:1983061e50514b3-0bcd8b9ebffae5-26011e51-e1000-1983061e50614b3':
        'f1e7cdc3-29e4-4851-abee-4f57bb8a929a',
      '$device:198306220ff3fd4-0b6c715e8f12ea8-26011f51-e1000-198306220ff3fd4':
        '8bcaa5a6-b630-4c57-889d-20348b4916ff',
      '$device:19830621d2e436d-08917b7bdc0b94-26011e51-e1000-19830621d2e436d':
        '67298e81-3ad3-4a60-99dd-95db2d7e2f29',

      '$device:198302e7fa82d5c-06f18d740ba2218-26011f51-1bcab9-198302e7fa82d5c':
        'b992c189-e607-4977-b37f-d13f573ecacd',
      '$device:1982fe423d645ca-02e45a2f23cec2-26011f51-144000-1982fe423d645ca':
        '4e10c1c7-7f0b-482b-921e-e8b3baa35cb5',
      '$device:1982fe48fa9e37-0c47f8e34ec6358-26011151-144000-1982fe48fa9e37':
        '13705c41-3543-4ca3-9dd2-190f65af599b',
      '$device:1982fecc04486c-0b3c099a9a1908-26011151-4b9600-1982fecc04486c':
        'f8d83820-1274-493a-8252-ab4ebd102469',
      '$device:1982fe3aa8fe22-0152d7183fb90f-26011f51-144000-1982fe3aa8fe22':
        '9e907cb4-e597-4daf-a6bf-f4e15aebdee7',
      '$device:1982fe3a2a0ca3-0555697549334b-26011e51-144000-1982fe3a2a0ca3':
        'f2dea7ef-6bc4-432e-8187-a0fc0069c468',
      '$device:1982fe39e8aea0-0fc3bea331940f8-26011e51-144000-1982fe39e8aea0':
        '82e0f3cb-b667-4062-9772-e946b01ccb7b',
      '$device:1982fc12c5cf3d-078599c63dcfba8-26011151-144000-1982fc12c5cf3d':
        '84037fc2-0bf8-4b92-b39c-ea1ad9f93a12',
      '$device:1982fb902a5e6c-046bfc0091ae6d8-26011e51-144000-1982fb902a5e6c':
        '9e907cb4-e597-4daf-a6bf-f4e15aebdee7',
      '$device:1982fbacbe9f4e-06a41ec533ce8e8-26011151-144000-1982fbacbe9f4e':
        '910a5df5-a8bf-4670-9fb6-bf300164b606',
      '$device:1982fb61b3d3699-05f07f29c90d83-26011151-144000-1982fb61b3d3699':
        '01450ac8-5e59-4e45-8cf7-d5e90f917bbc',
      '$device:1982fb5d5a91436-079d8bc9957247-26011151-144000-1982fb5d5a91436':
        '8ffcecff-ba2a-4ad8-8eca-c7b2826ad75b',
      '$device:196f4a2fe9f301-004183cdd3db88-27604a30-61d78-196f4a2fe9f301':
        '14fcc6ca-eb9e-4c44-a225-71ca50881816',
      '$device:1982ee1cf1bbd0-023a2e8f3fbb8e8-b457457-46500-1982ee1cf1cbd0':
        '5f640df1-6404-4b71-99d4-b56ec248e43d',
      '$device:1982ee16cab7e4-0937c5c300442e8-b457458-46500-1982ee16cab7e5':
        'dbfc1105-e0f9-444e-bcf0-935ef4da4ff7',
      '$device:1982edc3c23e19-0a6e03121204e2-b457458-46d70-1982edc3c24e19':
        '83c20771-f7eb-40fe-84f2-c52921187fc2',
      '$device:1982d6301ddf87-075c21c57f21678-26011151-15f900-1982d6301ddf88':
        '1ad334f4-8657-40e0-9c1f-9658b096e79b',
      '$device:198350172aa9fa-0902aff71cae7d8-26011f51-384000-198350172aa9fa':
        '753d3ad0-0bb6-4644-b84a-9ccd3faa0dc9',
      '$device:1983499daf518b8-0855bce06a62548-26011f51-1fa400-1983499daf518b8':
        '57181e67-33bb-49fc-b10e-37d573f7e46c',
      '$device:19834212dca2d2-02ed40db77d4428-3862654b-ec3b0-19834212dca2d2':
        'a393ecba-b98a-42f8-b2b5-e6b7cc7a4a22',
      '$device:198336ec9c41af1-021872cfc97cca8-26011151-1fa400-198336ec9c41af1':
        '04d4a2f2-fa43-4b04-857b-5c253b2a42e5',
      '$device:19832e188db500-052ef8549cae308-27604a30-5a900-19832e188db500':
        '0dde1c28-a559-466d-b305-6650e60fe1fc',
      '$device:198328c7dba1b8b-00a4ccfe564874-26011f51-144000-198328c7dba1b8b':
        'f5598186-177a-44c4-a8b7-0fe90e573197',
      '$device:19830e6aa36395e-006323da1da18d-26011f51-15f900-19830e6aa36395e':
        '13e1eaf0-c80b-435e-9259-f0bf84e4a0a6',
      '$device:19831febc7a12cf-08ba043eafcf008-26011f51-144000-19831febc7a12cf':
        'dd01d068-7f21-4ed9-a196-b6af76b02630',
      '$device:19831dab2d81792-0123d3835ea1eb8-26011151-144000-19831dab2d81792':
        '782e2dac-bff3-455f-a2a3-51aef4b28195',
      '$device:19831dbac3217b6-052460f89843e18-26011151-1aeaa0-19831dbac3217b7':
        'fbbd9c62-f5c0-408a-91b4-433d62fc98f8',
      '$device:198318eb447d37-0eb96421a18bc08-26011151-1aeaa0-198318eb447d38':
        'b77f65d7-d2e5-4e3f-bf8e-771515779585',
      '$device:19831b02b921b58-07432be25d6342-4c657b58-1fa400-19831b02b921b58':
        '2a54fdf4-6786-4c14-8094-046bd73f584b',
      '$device:19831031281fda-060c16f3575577-26011151-1fa400-19831031282fda':
        '5a15b0cc-6e14-4979-b00b-f50819951204',
      '$device:19830e4dc5f403b-0ef53fb3b320f5-26011e51-144000-19830e4dc5f403b':
        'ba017d5b-7b25-4e0f-b236-ef211d9efda8',
      '$device:19831032778302b-0581f606bfc4578-26011f51-1fa400-19831032778302b':
        '95d209b9-c872-4bce-b5f0-c2791b8c3c53',
      '$device:19830b33431d1b-04ee83f7ae8043-26011151-1fa400-19830b33431d1b':
        'a6a9270c-edcc-4a9b-b669-fb37bae0da05',
      '$device:19830d11c19cc6-06d79da5b456068-26011f51-1fa400-19830d11c19cc6':
        '275cf943-8c51-4181-a707-c81cbfe2198e',
      '$device:19830717efb1b7e-09c6f5dd5edb27-26011f51-144000-19830717efb1b7e':
        '0ab6d819-b4ca-49ed-ab55-76df9062ecd3',
      '$device:198309648022e2b-0b4e3a58fe72de-26011e51-1fa400-198309648022e2b':
        'aa39d953-7a0b-427b-bc9f-febb08397d21',
      '$device:1983a8fe7962a07-0937c41d835d63-26011151-e1000-1983a8fe7962a07':
        '28838802-3496-4e92-85ad-bcc90e9671f6',
      '$device:19839dec681e19-00ac2d3d9e3506-69157d6c-40b00-19839dec682e19':
        'fbd734f2-2cd0-48a0-9a3d-3757c1acdf5a',
      '$device:198394a737f3a5f-0b0b9735d1bf9f-b457458-38040-198394a737f3a5f':
        '69afee1e-aa48-43af-834b-81950fef3c8f',
      '$device:19838949477109c-03d6d3528dfe868-b457458-46500-19838949478109c':
        'fbb77586-a147-44d5-af64-0e8efe1c8873',
      '$device:198380edda25a9-098e855f5f53a58-b457458-50580-198380edda25a9':
        '156d3493-8075-4f91-9f38-1cf69443e702',
      '$device:197ef447353131-0e8261de61c44a8-27604a30-55c74-197ef447353131':
        '5b6f35e4-55b2-4f8c-b674-7c1da974cac6',
      '$device:19837834099eda-067e8c3f0e9a11-26021f51-144000-19837834099eda':
        '08608fa8-65c7-48a9-bd86-c14c445843a4',
      '$device:198363d31e06de-0276881df2a1028-2e43092d-51bf4-198363d31e06de':
        'c2cc0d85-3de3-404a-b5d2-ed76365c39d2',
      '$device:1983b9ca1c42906-0ff8e9aacdd5c-26011e51-e1000-1983b9ca1c42906':
        'c777d0b8-1df4-4683-bddb-6f3e9e88fe64',
      '$device:1983b9c92791f41-0dcf000653eb808-26011f51-e1000-1983b9c92791f41':
        'c40e50ce-d2af-4bf3-82de-f1842af83db4',
      '$device:1983b9ca49a368b-052811f1c88558-26011f51-e1000-1983b9ca49a368b':
        'a1b19991-3c0d-4214-aaee-976444e9a86d',
      '$device:1983b9c850c1c43-05cb11c397c7758-26011f51-e1000-1983b9c850c1c43':
        'bdb9148c-798b-4e7a-95f8-aca06fb2a1d1',
      '$device:1983b9c7165dc4-091c89394334f48-26011e51-e1000-1983b9c7165dc4':
        '174645e9-6a4d-4adf-aadb-d2433ebfd5da',
      '$device:1983b9c78201a80-09f70226ddc9e1-26011e51-e1000-1983b9c78201a80':
        '4bf638f7-4e00-4614-a69a-02a49a95e0fd',
      '$device:1983b9c70cf19e2-0d60f539787ff08-26011f51-e1000-1983b9c70cf19e2':
        '6ba6c784-1615-4b96-be9f-a10fb5ceb076',
      '$device:1983b9c66281a28-0896e4fbb332ff-26011e51-e1000-1983b9c66291a28':
        '14c4f98b-4b2f-4bb8-80a8-df7e5cd1cd5f',
      '$device:1983b9b861334be-04928fe20137e98-26011151-e1000-1983b9b861334be':
        '59dc1ccb-7133-4a7b-9c7f-53e0d28526cb',
      '$device:1983b30493e5d1b-06f04a69e04c48-26011151-1fa400-1983b30493e5d1b':
        'bc3f1816-a058-41fe-8989-65df32e4fe22',
      '$device:198433d384e1a7-0a0ecac5d60962-7d7f3361-505c8-198433d384e1a7':
        '6be3f810-2672-4888-9df4-b113e745841c',
      '$device:198404f664010a4-0548084df1a686-b457457-46500-198404f664110a5':
        'c479bae2-18e0-4627-ba56-8d185326f41e',
      '$device:198499f5915279-03b459c8ad0397-27604a30-505c8-198499f5915279':
        '9a7a7453-a4b9-4671-9422-bac432941c50',
      '$device:198495f396f254-0384b5b7ccd4a8-27604a30-505c8-198495f396f254':
        'ea06a04a-494e-495c-8c62-f6a7ac540a8f',
      '$device:198468ae86c2a3-0beedd4559fd5c8-b457458-5c094-198468ae86c2a3':
        '6c993036-a076-430a-8468-4f6493ef2f04',
      '$device:19857f28fad56e-0234ad6f0379ed8-75115149-4a640-19857f28fae56e':
        'fbbd8bed-6633-4be4-9b97-c982c13bbaf4',
      '$device:19854e322292e11-002a387ada874-26011e51-140000-19854e322292e11':
        '3063e0ff-413d-45fd-9c1f-b8197bfc8675',
      '$device:19862068057729-027fd02f87d97a8-b457458-50580-1986206805872a':
        '36ad17bf-1391-41a1-a585-1943c5c6500f',
      '$device:198613591ab1be2-085129874a6bdf-b457458-46d70-198613591ac1be2':
        '83c20771-f7eb-40fe-84f2-c52921187fc2', // Rachael - came back on another device
      '$device:198608219e5668-05b98814e634678-4c657b58-144000-198608219e6669':
        '31bc13cc-6d45-4e80-8d06-73523a202455',
      '$device:1987240429a67ed-0c3f4de4542b41-7d08236e-46500-1987240429a67ee':
        '5f640df1-6404-4b71-99d4-b56ec248e43d',
      '$device:1987a02381924aa-0b9bbe19d52105-26011151-144000-1987a02381a24aa':
        '0ab6d819-b4ca-49ed-ab55-76df9062ecd3',
      '$device:19878ef5259486-0b4f9133f1789-b457458-448e0-19878ef5259486':
        '3acd0b33-f07b-40a3-9ea6-d053c6ce1402',
      '$device:1987fb3736b1137-03b2b9c84de98a8-b457458-4e4c1-1987fb3736b1137':
        '8634bbff-3006-419b-b878-57aa3bff3ff1',
      '$device:1989125ac9137a-07f6b6826fe22e8-b457458-37a00-1989125ac9137b':
        '1f5aade2-a0cb-4178-92c3-38ab3aab27ba',
      '$device:19890f68763879-01d4b52657592b8-b457459-48000-19890f6876487a':
        'f064ab41-d437-46ad-ad07-26de5cc686ca',
      '$device:198952ef6fb4de-03e6b6ac9001ab8-7d643058-61d78-198952ef6fb4de':
        'c7b467bf-2621-4098-a3f6-ef7ae5a9b379',
      '$device:19893fcbd0d3a0-0490d3842bbd04-57004768-60c28-19893fcbd0d3a0':
        '330d6ac9-7f6c-4170-8031-3fd8d6675d7a',
      '$device:1989d8fdbe4260-004a2190ccc6ce8-27604933-66b20-1989d8fdbe4260':
        'e6aafe72-481b-4c3a-b399-b8c044df2ecb',
      '$device:198a602dd9f1a0-079df15abb3b6c8-7d643058-36240-198a602dd9f1a0':
        '2ba5b43a-b406-412a-9626-88ba7b44b16b',
      '$device:198ac755a6744f-04c8c91333d61c8-b457459-46938-198ac755a6744f':
        '3ed0c316-e8c1-4be1-a6d6-24c0c936d798',
      '$device:198b3997a5524d-03b2c81f80b063-27604933-61d78-198b3997a5524d':
        '65c6d3e1-15cc-44b9-b5ba-f3796190defc',
      '$device:198b2e45864328-0dbd799d079588-27604933-2c600-198b2e45864329':
        '0b4a215c-e674-4a9e-abb5-c4422d330517',
      '$device:198b1115b60400-0f5eaf3c81b54c8-b457459-38f40-198b1115b60401':
        '212a9c35-0aea-4cba-af59-66a1e4c37c70',
      '$device:198bb521d2e2fc-0778fb796a82158-7c643058-505c8-198bb521d2e2fc':
        'd9fa1209-225b-4234-ab9c-679f5df1669e',
      '$device:198bea021d6431-08594f520b5bd28-27604933-505c8-198bea021d6431':
        'faf5c1d8-a3c2-44a0-8167-37003d90fadb',
      '$device:1989563b2ca7f6-08473435a21e298-7d643058-4a574-1989563b2ca7f6':
        '0809313b-c8f4-47e8-833a-ef3344885dc7',
      '$device:198aeacb9e030a-017c86b43d0bb68-27604933-60c28-198aeacb9e030a':
        'd929f6c1-9c5d-4817-9136-0dd86cd22ada',
      '$device:198c9e423b626b-0b3f91ccd99c6a-7d643058-61d78-198c9e423b626b':
        '85c5c2a8-4973-4e29-bb8c-b96a7acd8375',
      '$device:198c8b295e9297-00ae9345fd30d38-27604933-61d78-198c8b295e9297':
        '49ece2ec-48c3-49b5-bb18-c208f369baf2',
      '$device:198c7dc136fb05-08ea6100b927038-b457459-4e000-198c7dc136fb05':
        '291cadf1-5862-4428-b556-a5cadfca6c97',
      '$device:198c6dfdbcc4cf-01d6dcdec4355f8-b457459-65400-198c6dfdbcc4cf':
        'ddc8750d-15c7-49ff-beea-34d500b03d01',
      '$device:198c68fe0a051f-01352199134873-b457459-431e0-198c68fe0a051f':
        '46bb9e4c-2141-4566-8c17-718966b2c087',
      '$device:198cd422c4c24d-03501da7e879ee-5d03406e-61d78-198cd422c4c24d':
        'edcde300-c9e1-453f-8c0e-88a7191a37ab',
      '$device:198d441f579261-083f14fb57e7f38-27604a30-60c28-198d441f579261':
        '338e135a-b5b1-4d80-9036-bbbf25373552',
      '$device:198d424a09f150d-0c34c8e516eed7-4457373-4a640-198d424a0a0150e':
        'dfcef249-79d9-4a29-b5c5-ea1a6a3c7cfe',
      '$device:198d380d8b0272-0c210d5716d7f1-7f773460-5a900-198d380d8b0272':
        '0d968bce-8a75-4b07-a6b8-f9c12e938c02',
      '$device:198d2c47414401-0bb034d04f59c5-b457459-55140-198d2c47415401':
        '3a0a01d5-e965-4e9e-8cad-f6c719b925e8',
      '$device:198d92a0ae57bf-0616541da6f2348-b457459-5cbd8-198d92a0ae57c0':
        '358d2fba-9694-4d46-ba47-fac0c5d1f2de',
      '$device:198d8dfc1e1503-02281ef1908d0e-b457459-7fc33-198d8dfc1e1503':
        'c2161de5-0731-4f2d-970d-cf891c1e4c28',
      '$device:198d88ded836b7-042f9325cdade78-27604a30-55c74-198d88ded836b7':
        'badbfe89-5fba-4ebd-98e9-36ddff38ad9e',
      '$device:198d819bc6a5e5-0775b500066756-b457459-6ac5c-198d819bc6a5e6':
        '20ef5f4b-28dc-4e44-adfc-2d0817a55124',
      '$device:198d81593984a0-0bc879150fe4a58-b457459-5c094-198d81593994a0':
        'ade765d2-809c-48e0-b180-16ccaa4a4c67',
      '$device:198d7b927514b4-09be1ec378ac198-27604a30-505c8-198d7b927514b4':
        '54a77ea1-e50b-498a-90ae-ca71f35a4d01',
      '$device:198d70db18f4c1-04cdc9f7b895ee8-7c643058-5a900-198d70db18f4c1':
        'ee65f46d-d4dc-4bb1-af0d-3a3a9a31f3a3',
      '$device:198d6536569447-0eaeb34257da94-7379356f-505c8-198d6536569447':
        '2c03bd09-ef0b-4d42-b6c8-75441155ee7e',
      '$device:198d5ce842a17d3-0b059d82f2441-26011151-1fa400-198d5ce842a17d3':
        '7277d68c-323c-41d0-b99b-a5ef9bd5fcd4',
      '$device:198defe3bf22be-01ae70e301a635-7364365b-61d78-198defe3bf22be':
        '89958f52-b0af-4115-9475-6cfc18bdc836',
      '$device:198dd0ae16d482-05404c4630c73c8-7379356f-505c8-198dd0ae16d482':
        '08c9ae22-02b6-487b-83e7-10a83c172443',
      '$device:198da7c4150428-0c571694d40ab7-b457459-67c80-198da7c4150428':
        'ce4b9243-3c13-4fca-bd7d-97ad30a4ae88',
      '$device:198da4c705948a-05a56ec916cc13-b457459-4e000-198da4c705948b':
        '9f9c668c-aa58-403c-b002-a8c6f6b8fec5',
      '$device:198e3513cf335d-0a4ef4e87f4cc78-27604a30-66b20-198e3513cf335d':
        '772134d2-e7f2-47d0-b3a4-1ef608854ced',
      '$device:198e2c165f7a4c-05b2498ee78172-16201105-36240-198e2c165f8a4c':
        'd295b490-1a60-491e-9ba8-92197ff381cf',
      '$device:198e222e8b34bc-09259bb93004428-b457459-67c80-198e222e8b64be':
        'ce4b9243-3c13-4fca-bd7d-97ad30a4ae88',
      '$device:198e05a1766208-042f04d0a1af158-7079356f-51bf4-198e05a1766208':
        '7b14bb04-7a1d-4a5c-81c3-fe700a54ceee',
      '$device:198e7f400256d5-08ead24b491fcc8-7c643258-5a900-198e7f400266d5':
        '537423f6-fccd-4152-b2a6-f35ada2c94f7',
      '$device:198e4ea73f5591-0aeb0d1bea44c88-27604a30-505c8-198e4ea73f5591':
        '8740de5e-384f-4b7b-9f50-6814ffc530d6',
      '$device:198ee799112393-03c7c2f8e942c78-b457459-37a00-198ee799112394':
        'c21079ed-d1e3-4524-ba2e-300d076a211a',
      '$device:198eda0ee552b2-06ed38f16585598-7379356f-4a574-198eda0ee552b2':
        '4596ad60-69da-4e3e-8553-c1621d12404e',
      '$device:198ed5a8f043aa-0b65b92d5657218-7379356f-5a900-198ed5a8f043aa':
        'bdd87dcd-bb60-4654-bc8e-d6b9dac04588',
      '$device:198ec9d50be4c5-0f98b4307cf686-27604a30-505c8-198ec9d50be4c5':
        '03324b7b-1d5d-49aa-ad9b-154b233f9896',
      '$device:198ebdcad8c3e7-02058d6c7d27cb-b457459-97560-198ebdcad8c3e7':
        'be2a1d6d-05aa-4190-95fb-7dd4f4486b8d',
      '$device:198eadd7cf7360-0a80e881d48fe7-b457459-4d400-198eadd7cf7361':
        'cb034a27-4d32-4030-81bb-f163378ed781',
      '$device:198f351d06e24c-087aa286144c78-27604933-505c8-198f351d06f24c':
        '9306a270-c3fd-48ed-9613-b96f10e12b59',
      '$device:198f3258f1f4d7-089d6be3bf8ad-b457458-4e000-198f3258f1f4d7':
        'f8f91c15-ed67-41aa-bfb2-2618b18ade13',
      '$device:198f2911da232b-017a3a5ec86fe6-7379356f-55c74-198f2911da232b':
        'd6a3ee09-3164-4f92-b50b-822c5277eed0',
      '$device:198f8a793ed516-07f266c2cea48a8-7379356f-505c8-198f8a793ed516':
        '84b07bb4-129c-4290-93a1-942691d9c567',
      '$device:198f8932f6df42-071c7b0abd969f8-b457459-46938-198f8932f6df43':
        '0616da12-f929-4ec1-8db9-2ad77ff70e11',
      '$device:198f871216a869-0a67821452728e8-b457459-59b90-198f871216b869':
        '904c3472-24a4-42ff-98ea-0174f0d3ca87',
      '$device:198f82f8d42d02-0e72dfc6a3d7988-7379356f-61d78-198f82f8d42d02':
        'b80a7997-9287-4eb8-83e8-ede80fb73ee2',
      '$device:198f7de549fa69-02cbdfce4d25c48-b457459-7c35d-198f7de54a0a6a':
        '3c56b0c7-f8b4-494b-891e-d9f13138b060',
      '$device:198f71398ed34e-018f72a36c153b-7a632e15-36240-198f71398ed34e':
        '5fd5808f-b8fa-446e-b957-c5c5105cf267',
      '$device:198f5ea716eb10-0150c19530ed868-b457459-4d580-198f5ea716eb10':
        '7647e0a5-b233-4776-8c9d-a709adf9aa6e',
      '$device:198f58fd2f96ff-0fb4af39ec81118-b457459-46500-198f58fd2f9700':
        'c859e8cb-53e6-49f6-9986-647840e45b2c',
      '$device:198f46e9a6f487-00af52c4809eaf-b457459-5c094-198f46e9a6f487':
        'd2cd1058-2c9d-43d3-bcc4-2abc72461b0c',
      '$device:198f401897f139-02ad115842066a8-7379356f-505c8-198f401897f139':
        'e43cb73c-d36f-4089-938c-1b8ae70d5094',
      '$device:198fbb651bf2a9-072043aa75e3068-7379356f-5a900-198fbb651bf2a9':
        '93e79fda-6b9a-4327-ab1c-00ebd6f4ff03',
      '$device:198fb4eb7a4265-0cd98eeaa514218-7379356f-505c8-198fb4eb7a4265':
        '383b0086-a5bf-4230-8488-2e5721ac1a58',
      '$device:198fadbed6c330-03958adc3e3da5-b457459-40e00-198fadbed6c330':
        '1a45a842-1362-4649-8a01-6b676d0eac5c',
      '$device:198fabcc5fb4a2-074bf0351740ef8-b457459-448e0-198fabcc5fb4a2':
        'b9c599d9-1110-4fe0-9847-3e0a8d943365',
      '$device:198f951b0d835c-0244a4f8f91404-27604a30-5a900-198f951b0d835c':
        '5d523cbe-e6e9-4eee-ba86-b12a7eeb6172',
      '$device:198f94871f121da-0c8d251c25785f-53054967-3d10d-198f94871f221da':
        '2d7fdde8-127e-4f2c-b7fd-5724f864cfe5',
      '$device:199030953d9346-0c2717d1024b408-51054a67-5a900-199030953d9347':
        '9412c1e3-9a09-4240-b503-3adef5f81de8',
      '$device:19902b222b1363-0784b6168ffd1c8-27604933-5a900-19902b222b1363':
        '31d10fdd-fe78-4101-9651-b55ad89473a1',
      '$device:19901e293c6438-0b45628026d08d8-b457459-4d400-19901e293c6438':
        'e8740cab-ce77-4341-bf91-0d0093d6197c',
      '$device:198a564c22e534-0fb1520ef49ded8-b457459-4e000-198a564c22e534':
        'df774b0a-3f25-42ec-b764-4a84adabcb92',
      '$device:198fff54bac477-0f7a4fb47ca09e8-b457459-6d280-198fff54bad478':
        '76281113-703d-4608-8f3c-4bf565c69f5c',
      '$device:198ffa90b814bc-093699d1df0df48-b457459-4d09d-198ffa90b814bd':
        'a7460e2b-457e-4c50-a53c-92c535330180',
      '$device:198ff4613328b6-0f33f37f5ce55e8-b457456-50456-198ff4613328b7':
        'a7199f07-eb61-4b44-ae53-fadb7719a3d6',
      '$device:198feb1449c4b3-01fa7407d66cca-7379356f-505c8-198feb1449c4b3':
        '36093d44-00d5-468d-894f-beb35a2118e1',
      '$device:198fe872bd548e-0c2e4bfb5fd3cc-b457459-5cf10-198fe872bd548e':
        '36fe24be-32d8-42c1-a221-ec07383d8cc3',
      '$device:19907520d9a875-0923b9658d0c05-b457459-59b90-19907520d9b876':
        '63c085b8-170f-4670-a63d-b89f9517b0d0',
      '$device:19906f257f7194-0b0feae5bce7038-b457459-448e0-19906f257f7194':
        '2264b239-44a0-4aba-9d7f-c39e69ae3da7',
      '$device:199063dc82495a-0c3cc949512f7f-7379356f-66b20-199063dc82495a':
        '19bb0a4f-c9c4-40c3-ae5d-cf887ece2c71',
      '$device:1990518f573898-07584dcc03ad15-b457459-50456-1990518f575899':
        'aedde733-1789-4bef-a5e5-52d916c55f7d',
      '$device:19904c85a25262-0308551225aba-b457459-52265-19904c85a25262':
        'a6194a21-35d8-452d-adbd-c80029304012',
      '$device:1990c717ce42e6a-09a25c97b199258-7e58071c-431e0-1990c717ce42e6a':
        '60201cb6-fa18-40a7-86da-d04a2d29b0b9',
      '$device:1990c6d7fde348-0476cb9107d57a-51054a67-61d78-1990c6d7fde348':
        'a5f689d5-48ed-4eff-9c60-5d43a969c88c',
      '$device:1990af81672445-0888904847b5c9-b457459-4e000-1990af81673445':
        'f1b54059-faa9-42df-81c3-6684acfe86ef',
      '$device:1990a3aa9434a3-0472d948e99bd9-7379356f-55c74-1990a3aa9434a3':
        'd27abe2a-fa63-4f0a-b71b-9dab3bb560d7',
      '$device:1990909ca481bd-0af936e70b8b0b8-7379356f-61d78-1990909ca481bd':
        'e07fe675-866f-462c-9f3a-847f8dbe86be',
      '$device:19912d41cea1b6-00de0cf6716bc-7379356f-60c28-19912d41cea1b6':
        '0659eeeb-8c82-4f91-8bf7-36176710015e',
      '$device:19912b6800d2f4-0e3923624c1bb98-b457459-4e4c1-19912b6800d2f4':
        '0f6d9b8d-57ed-4e79-8faa-9eee5e6dfb8d',
      '$device:199125b1ef031f-0e53de6c67b262-69157d6c-46938-199125b1ef131f':
        '4c39767b-bdba-4d1c-87b1-e33dcaa34dd7',
      '$device:199122a69d0989-092fd3150ba979-b457459-4e000-199122a69d198a':
        'f36e8cfc-8d55-4488-8bf0-b5b52dd9f144',
      '$device:19911f980283da-04e80ca528221-7379356f-2c600-19911f980283da':
        '0b4a215c-e674-4a9e-abb5-c4422d330517',
      '$device:19911b5756356d-031f82be4ea07e8-b457459-46d70-19911b5756456d':
        'a2d7619b-f363-4727-af31-18ed8572d984',
      '$device:199116a6dc54fc-062b341fab3b628-b457459-6f564-199116a6dc64fd':
        '5bec6b14-1027-46bc-9ee9-0d6693badc88',
      '$device:19911683229725-00ead7937fd885-b457459-51a6b-1991168322a726':
        'a5fa1408-a681-4214-9534-caa75bc19919',
      '$device:1991152d7f9373-06d2454038c39-b457459-4e000-1991152d7f9373':
        'fef799b4-34be-47c7-8718-88ff9a64288f',
      '$device:19916f6ddfa6acf-0ef5300086c5c48-b457459-5cbd8-19916f6ddfa6ad0':
        '0c021e40-71a8-4077-ad2b-1e833f281204',
      '$device:1991c43243b4a7-0ca7e6efca4a5f-7379356f-51bf4-1991c43243b4a7':
        'be259b5f-74e2-4b5a-bcea-e6b828fdb713',
      '$device:1991bbe86db307-0ca85d8f392a05-27604a30-5a900-1991bbe86db307':
        '643913f2-414c-4370-8ef5-dffc6cf609d7',
      '$device:1991a6dc0dc1e9-09a8512a4d6ce7-7379356f-36240-1991a6dc0dc1e9':
        '91f6eae0-3319-4c70-8168-ede0230b7e03',
      '$device:1991a2d75292f5-0cc9d6f9941ae58-7379356f-5a900-1991a2d75292f5':
        '732a474a-d859-4150-96c8-c57a6649a3d3',
      '$device:199183b4b5c330-0de717a1ee09d7-b457459-5cf10-199183b4b5c330':
        '9e2c3053-4f38-47a0-85a0-5d5f5c1a765d',
      '$device:19921b5d4e7273-0af270b0af4ffe-59064163-505c8-19921b5d4e7273':
        '8c7c286c-2d77-4b67-9b45-9428c6642030',
      '$device:1991c966567394-071a73e8860ec9-7379356f-36240-1991c966567395':
        '04b33929-a3c4-4532-b650-f0f082e86751',
      '$device:19921917ddf380-01ec1997379cfe-2a4e022c-5a900-19921917ddf380':
        'cd50958b-20e4-40dd-889e-89a806cc8e61',
      '$device:1991ffaedbc348-00fb9a252039d5-2a4e022c-36240-1991ffaedbc348':
        '4315f5fb-dbb3-43a5-b143-1085d197bca4',
      '$device:1991fd10a1624b-02957ddef88cca-2a5b4f61-d5930-1991fd10a1624b':
        'f58f1872-071c-49f7-9055-58958dbb9082',
      '$device:1991dad5f56672-05d21b135926998-b457459-5cbd8-1991dad5f56672':
        'ac646755-414b-46d4-91da-2247a3e9d06e',
      '$device:1991d9bbff12bc-0f9013d17c6b4b-59004468-61d78-1991d9bbff12bc':
        'a83f27f9-0c4f-4b80-ac0a-0cc704855c2b',
      '$device:19923960fff8e0-0fd4a272e1b895-b457459-7f684-19923960fff8e0':
        'a76df1de-8a95-4830-89f2-8a17894ec52c',
      '$device:1992524da513e8-0456e71c687844-b457459-50456-1992524da513e9':
        '3be0787c-f6bf-46b1-85c0-64fb23932853',
      '$device:1992527b07925f-0af62a20cfcf3e8-27604a30-505c8-1992527b07925f':
        '14ea7d0f-e6ed-43f2-b4f7-6b78db678ac6',
      '$device:199254dff3e26e-017437c03c5a5c8-27604a30-505c8-199254dff3e26f':
        '6e67058a-79c1-4ea7-b1a9-41d922b09bd9',
      '$device:19925fc38fd4f6-0a46196572565f-b457459-5c094-19925fc38fe4f6':
        '5a399852-69a9-4374-8676-d821b5ec543c',
      '$device:19926191f7c14c4-094ea66dcafbc2-b457459-6ac5c-19926191f7d14c5':
        'e499f736-343b-4321-8bc2-b180cd5fd7ba',
      '$device:199266583b62ad-08d3ee5516654d-7379356f-505c8-199266583b62ad':
        '4051d4b0-5b94-484a-93d0-3325a2a9c1c6',

      '$device:1992bf9e8de85d-00879f5af5ee498-b457459-37a00-1992bf9e8df85e':
        '79f271c4-d722-43ac-bafd-5fcabba490d2',
      '$device:1994000c6251d40-0d6c3a0cf45ae88-b457459-5cbd8-1994000c6261d41':
        '76589a27-181d-4ba1-bb19-380f789f7747',
      '$device:1993d8cd8495ba-0a55b2779c7b4f8-b457350-59b90-1993d8cd8495ba':
        '8b7597e5-7841-4712-bd97-472d9fe2eb70',
      '$device:1995bf04e961a2-074d70dc6785ee8-7379356f-505c8-1995bf04e961a2':
        'a82d1a86-f60c-4a79-a6bf-4ae9c7056022',
      '$device:1995e6680c8986-0dbcf21f5bf7f9-69157d6c-4aefc-1995e6680c8987':
        'c9f02a58-2278-44b7-ab7a-0fb4e48c4cc6',
      '$device:199690405fd95a-09a9e250311dc18-b457459-46500-199690405fe95b':
        '7c7b6a58-f894-4e28-9761-e3216a0cd7f3',
      '$device:199827413854b3-05e9661a5d258f-27604a30-4a574-199827413854b3':
        'e2b5addf-4610-4267-a5c4-b1aa2959eb5b',
      '$device:1990ce218f737c-0f87b96efd0ae38-7379356f-5a900-1990ce218f737c':
        '293aef20-413f-490c-9783-c4af3ae881b0',
      '$device:1999880f60a274-0de280480cbe43-7379356f-61d78-1999880f60a274':
        '2d4baf08-0e11-445b-9377-0d15a960d615',
      '$device:1999268ba552a3-036e9696b7cc1e-2a4d032c-36240-1999268ba552a3':
        'bc406311-3885-4bd3-8e06-8ab05f875695',
      // During deployment
      '$device:199aeab1afc513-0cdcc510f222e68-766b3b5a-61d78-199aeab1afc513':
        '598a4f1b-cc50-432b-b91d-58fe35a0e72e',
      '$device:199ae68fb2c2e1-058b99995df7888-7379356f-51bf4-199ae68fb2c2e1':
        '44b0d6a7-3d7a-48fc-b34b-bbb6540ad13f',
      '$device:199ae14c39965b-0bff9b505ab9e88-7379356f-51bf4-199ae14c39965b':
        '95ffb28c-9345-414a-a34d-92b04d6ced00',
      '$device:199add2b3ad443-074ed05f0d1ac38-b457350-663fa-199add2b3ad443':
        'e8b33fbe-a7e5-4598-9913-2c0c7c8026e1',
      '$device:199adab511feb8-00ef374cb8c23c-b457350-38040-199adab511feb9':
        '086cb1ce-2193-4b8c-9b4f-7113750e6bd9',
      '$device:199ad8ceef1960-02846888d2f867-b457350-40200-199ad8ceef1961':
        '9bec5f13-fd3e-4b79-a471-58607b63fc69',
      // On the Survey Page after the fact it did not link alias for some reason
      '$device:199683bfed78bd-038d7809c6b0cd8-7379356f-5a900-199683bfed78bd':
        '4d87deb0-df1e-43cc-a429-79d0438195f9',
      // Daphne
      '$device:19964e6c761691-095a99c08dd43c-613d2537-5cbd8-19964e6c761691':
        '6770b1ae-3017-4930-af70-b6a7e27a046f',
      // James Ballou
      '$device:199886ff3c42ab-04d11ee330117c-7379356f-505c8-199886ff3c42ab':
        '9e9848cc-bf30-4b2a-b25c-abf38d0f8506',
      // on survey - LaDonna Loveless
      '$device:1998908b966781-0939fd0e721bcb-b457350-46500-1998908b967782':
        '8fa79e46-536a-4653-9b52-2cb0ad4099e3',
      '$device:1998c2f3793253-0bf47129f887a7-5c0c4f6b-505c8-1998c2f3794253':
        '1f934e36-9bf2-4045-b00a-dcb2f84b69f6',
    },
    development: {
      '$device:199451a5496160-007bc8cf0ca09a-16525636-4b9600-199451a5496160':
        '8537ac2c-1579-4146-9757-cbe6d8d45d32',
      '$device:199451b78b4e4-0d05d977a24d1a8-16525636-1d73c0-199451b78b4e4':
        '94e9c406-5913-4bab-891e-55b04ea6b06e',
      '$device:19458c32bd219e-0a3144b19cbd36-1e525636-1fa400-19458c32bd219e':
        '2aa5c8d7-265e-4521-94d9-7c2b2c4661b9',
      '$device:199490c27d969-0064d6a43d71d78-16525636-4b9600-199490c27d969':
        '4f5c41a1-5e54-4a7e-b683-4b9a33a33dad',
    },
  },
  'staging-api': {
    production: {
      // regular users
      '$device:19955031db6126-06cbd89fa2ff8b8-26061951-1fa400-19955031db6126':
        '13269757-7db6-4732-8be0-1e5132105e17',
      '$device:19955776fed1ae-06e6085f11eb29-26061951-1fa400-19955776fed1ae':
        '2d83e3a9-d7c4-4853-9219-2ddd777abe05',
      '$device:19955a6d91616f-0a3d4a4adf077d-26061951-1fa400-19955a6d91616f':
        '4322ff28-4852-4a0d-b6d5-01d05c9c4a3d',
      '$device:19955a81d73157-0b0507dd1871e3-26061951-1fa400-19955a81d73157':
        '99910786-93f3-481f-9073-663f16ea942f',
      '$device:19955b6b04710c-05d294f0528b92-26061951-1fa400-19955b6b04710c':
        'eab74f84-00a9-4b67-bac7-9e6c0d2d03fb',
      '$device:19955b81bc0140-0d01ea547a90f9-26061951-1fa400-19955b81bc0140':
        '5602582e-d55b-43a8-b231-6307825156ce',
      '$device:19955c9e6c111e-0686d062828e588-26061951-1fa400-19955c9e6c111e':
        '885bf636-568f-4180-9f95-f3bc857e9e21',
      '$device:19955c9bf9614c-07e43b635b23bf-26061951-1fa400-19955c9bf9614c':
        'c545885e-c87f-4129-9480-a1ae8e795718',
      '$device:19955c99802116-029bb6dd38bea28-26061951-1fa400-19955c99802116':
        'b6100eed-04d9-4314-bc2d-4939d177289f',
      '$device:19955c970bd116-0f61f3784cab758-26061951-1fa400-19955c970bd116':
        '53ebc4a3-4754-4193-a6c3-32cde8a5a0a9',
      '$device:19955c94987137-03af441885820f-26061951-1fa400-19955c94987137':
        'eb526943-ad02-4854-bb6a-7a4bc6deae46',
      '$device:19955c92221115-0002da430c6893-26061951-1fa400-19955c92221115':
        'ca896681-68a7-4271-9b79-9e3f81219884',
      '$device:19955c8fad0115-050bf1f57b40aa8-26061951-1fa400-19955c8fad0115':
        'fe1b3140-4beb-4ced-8622-be2192b5491a',
      '$device:19955c8d391121-09bd7a21fd53c6-26061951-1fa400-19955c8d391121':
        'e335d468-26b3-4602-b185-3cd7471f6bec',
      '$device:19955c8ac45131-006285cf25e9a28-26061951-1fa400-19955c8ac45131':
        '56611839-336f-46f1-aec4-76d3e67b4ec1',
      '$device:19955c884e011a-0c71245e425353-26061951-1fa400-19955c884e011a':
        '2f7c8851-0a22-485b-826c-4dcb93fe89af',
      '$device:19955c85d9f124-09ea4ac5469dae8-26061951-1fa400-19955c85d9f124':
        'ef7e9a9d-b41a-49d8-a8c7-1135e3ae9267',
      '$device:19955c8363f116-0fcbf14537da758-26061951-1fa400-19955c8363f117':
        'a19bbf1a-f827-44d0-a10c-4c99a188bc87',
      '$device:19955c80eed121-0ee2a12a60afe8-26061951-1fa400-19955c80eed121':
        'fdbb4201-8329-4e1c-8772-4311631f5756',
      '$device:19955c7e78f117-03f6103b9834e68-26061951-1fa400-19955c7e78f117':
        '6f01a2ce-86fb-4183-b7be-c7df515be2ee',
      '$device:19955c7c032111-071b1d7084aaec8-26061951-1fa400-19955c7c032111':
        '763977f7-0211-4e9f-9cb5-d4fb328cc309',
      '$device:19955c79907131-0a49ce28940e2f8-26061951-1fa400-19955c79907131':
        '6a2b2ea8-ebb2-47c8-8e5a-1fb7e7d87d61',
      '$device:19955c771a6123-06c6d4addf8701-26061951-1fa400-19955c771a6123':
        '55db48f8-38b1-4191-a953-80cadacdf318',
      '$device:19955c74a5e127-07b533810d1e0b8-26061951-1fa400-19955c74a5e128':
        '8b54bfb4-5183-41fa-9a7f-8f48adf18f24',
      '$device:19955c722ff12b-00132588b948a6-26061951-1fa400-19955c722ff12b':
        '03bd98fb-9db9-4edd-9bba-ffc19d2a15e0',
      '$device:19955c6fbd9160-024f48e888f926-26061951-1fa400-19955c6fbd9160':
        'bda0da32-5d97-4151-a012-a64ea138c0db',
      '$device:19955c6d43a112-04d1ac8abfda198-26061951-1fa400-19955c6d43a112':
        'e8d1b9ce-9377-4d9c-9520-47dd271286bc',
      '$device:19955c6acd3125-013e26d6a1c7e98-26061951-1fa400-19955c6acd3126':
        'eefcbf86-fb49-4127-85c9-dc01738a5bc5',
      '$device:19955c685b3151-07faabc3f5746d8-26061951-1fa400-19955c685b3151':
        '56a183c3-f403-4838-adc9-934735afa23c',
      '$device:19955c65e3a124-04572377f57b9e-26061951-1fa400-19955c65e3a124':
        '5e7c8709-3b31-4c01-9258-72cdaf3e179d',
      '$device:19955c636d3110-02b0dc9e3dd01f8-26061951-1fa400-19955c636d3110':
        '49f715d7-6c2d-4fea-9b1f-d8b944855367',
      '$device:19955c60f82111-0a61a98a50b6098-26061951-1fa400-19955c60f82111':
        '437743fa-37f1-4927-a1c9-fdefa4e918d7',
      '$device:19955c5e831110-0784d4fd14017a-26061951-1fa400-19955c5e831110':
        'ae86f60b-97dc-4ddf-a67b-b584260f0a60',
      '$device:19955c5c0e711e-0c4778d00ca2268-26061951-1fa400-19955c5c0e711e':
        'd15ff6e8-5e6e-45ce-abb1-4bbb3814962d',
      '$device:19955c5999e119-0e6be92db41c3e-26061951-1fa400-19955c5999e119':
        'fcb47ffe-9631-4a09-986a-d4bca4e558bf',
      '$device:19955c5725d141-0bd4c3f547ab5-26061951-1fa400-19955c5725d141':
        '240b04bc-f2d0-4ec5-aad6-4c995499733e',
      '$device:19955c54afc12d-08dfe5a0f108c6-26061951-1fa400-19955c54afc12d':
        '0740c80d-862b-4e5d-85df-d6d75a8a3c74',
      '$device:19955c523da154-089a65559853b5-26061951-1fa400-19955c523da154':
        'fdf844fc-81f2-4675-a3b0-6eb82f317a94',
      '$device:19955c4fc4e123-00517a9001fcd6-26061951-1fa400-19955c4fc4e123':
        'b722247a-65cd-4365-9293-aceb872351f3',
      '$device:19955c4d4f9125-02a0cb29c0c889-26061951-1fa400-19955c4d4fa125':
        'db46046d-4cc0-4ae2-bedb-6661df0c7273',
      '$device:19955c4adba135-0e4a55b434b014-26061951-1fa400-19955c4adba135':
        '241c1b36-6b57-4c17-bdac-2f3695f37491',
      '$device:19955c48634112-04b0a1b0f918d88-26061951-1fa400-19955c48634112':
        '01ffb0e8-b1b8-40f9-937e-d89bbc6e5c7b',
      '$device:19955c45ee210f-0beabc31162d4a-26061951-1fa400-19955c45ee210f':
        'edfcf6ae-1cbc-4ff7-a8ff-bad403d89000',
      '$device:19955c437b9128-08c619494fe3c6-26061951-1fa400-19955c437b9128':
        '502b53f6-978f-4723-80d8-52a8d7dbbf62',
      '$device:19955c41055117-012b932deb20f7-26061951-1fa400-19955c41056117':
        '0aa534e4-221d-4707-8d9c-d146e0e84cdf',
      '$device:19955c3e91a12a-04424e320bd885-26061951-1fa400-19955c3e91a12a':
        'ea2f851a-2ee0-4021-a99a-c07907749a94',
      '$device:19955c3c1c0119-022de19bd101ff8-26061951-1fa400-19955c3c1c0119':
        '906a3535-ef05-4170-be6c-60636a5fec5f',
      '$device:19955c39a76127-0e25afd444741e-26061951-1fa400-19955c39a77127':
        'b05ed3d5-1aab-4a55-995b-162d6e7e2977',
      '$device:19955c37324120-0faa811d0c89548-26061951-1fa400-19955c37324120':
        '474013ef-0a74-4931-9325-ad47b8ed6f22',
      '$device:19955c34bdf123-06d2d97b3005fb-26061951-1fa400-19955c34bdf123':
        '0e215293-fd06-40da-bc5a-1f9f24bb07bf',

      // Google Auth Face Auth users
      '$device:19955c3248211d-0aab20aade0d858-26061951-1fa400-19955c3248211d':
        '91807d4d-900e-43eb-b24b-e6fcaf381599',
      '$device:19955c2fd2310f-048cb99317cfce8-26061951-1fa400-19955c2fd2310f':
        '9fe61a0b-d3ec-4c64-b427-ad0ae37ff482',
      '$device:19955c2d5ea11c-0e86e51c7684308-26061951-1fa400-19955c2d5ea11c':
        'a771df29-f783-410f-9aa8-f6123314eca5',
      '$device:19955c2aea3129-0dae0f3bf03bab-26061951-1fa400-19955c2aea3129':
        '95dddbff-41e3-47aa-a8cc-8ff889da4714',
      '$device:19955c2873911f-0ee49f1b519dc78-26061951-1fa400-19955c2873911f':
        'c23b2618-0f4c-4928-93da-74db502042e0',
      '$device:19955c26035164-0b928e08f07fc98-26061951-1fa400-19955c26035164':
        '3c8339f5-862f-41fb-9e4b-86e41a5da075',
      '$device:19955c103ce117-09ff0d97f1e36e8-26061951-1fa400-19955c103ce118':
        'f118d651-d299-40c7-b6f0-bf4d6f4fd0ff',
      '$device:19955c0dc8811b-0474bdffe3f1ca-26061951-1fa400-19955c0dc8811b':
        '35587e94-58e9-47f8-a90b-94faab8fa46c',
      '$device:19955c0b52110b-025c34924002bb-26061951-1fa400-19955c0b52110b':
        '631c5a46-4b45-401a-b030-9b920db032ba',
      '$device:19955c08ddc116-050403f5f37f3c8-26061951-1fa400-19955c08ddc116':
        'e546b9aa-4133-4ad8-a1c7-da195c699c86',
      '$device:19955c0668e124-0ccd5f8198d77d-26061951-1fa400-19955c0668e124':
        '5bc230b4-7059-4a1e-bf17-320b1e11fbe4',
      '$device:19955c03f40127-00572692a5cd798-26061951-1fa400-19955c03f41127':
        '05e0f96f-380f-41dc-bc9a-275a79ff6528',
      '$device:19955c0180312d-07c79ac438d3b9-26061951-1fa400-19955c0180312d':
        'df85bf3b-8b7b-4945-958a-36581985f02d',
      '$device:19955bff0ac12f-09159c59427e2e-26061951-1fa400-19955bff0ac12f':
        '9f153536-5f1b-4247-a4a5-4b3bb461c1c3',
      '$device:19955bfc962128-05aa3a2618b8868-26061951-1fa400-19955bfc962128':
        '18c4c161-e801-49a5-a257-fdf4f77b8e33',
      '$device:19955bfa207128-053d271cfa205c-26061951-1fa400-19955bfa207129':
        '2f9d3741-bfcc-4d1c-8061-670810fbe574',
      '$device:19955bf7aba12e-0563293b872b5c-26061951-1fa400-19955bf7aba12e':
        'b6002ae4-0892-470a-88bf-e4332450bd04',
      '$device:19955bf5355114-05cabe2015820a-26061951-1fa400-19955bf5355114':
        'ad73b813-8c7a-4bb5-ae15-244207b82cc2',
      '$device:19955bf2c0010f-08c28059f16813-26061951-1fa400-19955bf2c0010f':
        '60323e0a-4e7c-4b99-b1c7-4aa7e3b95585',
      '$device:19955bf04be123-0ed6589afd14a6-26061951-1fa400-19955bf04be123':
        '708cdf3a-9d98-4176-bdf0-e0cd23de89a8',
      '$device:19955bedd62113-07d7069f6e683a8-26061951-1fa400-19955bedd62113':
        '17c62ef0-7331-4895-9320-a29594c525e7',
      '$device:19955beb5fc114-07d6caf561cd5e8-26061951-1fa400-19955beb5fc114':
        'd60c6305-4c98-43ef-948f-66877b6bad10',
      '$device:19955be8ed0134-09612e654e4f538-26061951-1fa400-19955be8ed0134':
        'e7194842-8982-457a-a250-8761db3f6880',
      '$device:19955be6772125-071e82175156538-26061951-1fa400-19955be6773125':
        '6fe0ffb3-2c1f-4a32-a12a-387d731b339f',
      '$device:19955be401e119-0ce6c8fe8a99ba-26061951-1fa400-19955be401e119':
        'b616f45e-385f-462c-b3a1-982ff84ba879',
      '$device:19955be18c6113-0ebc4cada8bd978-26061951-1fa400-19955be18c6113':
        '90b32b01-c3d1-40b8-81af-00249834d95b',
      '$device:19955bdf198131-083f5af643946e-26061951-1fa400-19955bdf198131':
        '95f561f4-fc31-48f1-bc5b-e81258f476db',
      '$device:19955bdca2e11c-069da16d3bdef1-26061951-1fa400-19955bdca2f11d':
        'b487aef2-eb95-41ca-8ef2-0cd845e56a60',
      '$device:19955bda2ea125-0d380a0e61502b-26061951-1fa400-19955bda2ea125':
        '474c3102-8771-4df5-a807-a55b54705dea',
      '$device:19955bd7bad12a-0d26c7a4fd26ed-26061951-1fa400-19955bd7bad12a':
        'da2218aa-3fb0-4e04-80d8-913d5816946f',
      '$device:19955bd5464139-0925cce848b67c-26061951-1fa400-19955bd5464139':
        '06505159-9d8c-4b5b-9452-a5a27da00ec5',
      '$device:19955bb72ca114-02efa5e918d9b68-26061951-1fa400-19955bb72ca114':
        '88c5ab81-04b4-46f9-9bf0-b94636371543',
      '$device:19955bb4b8110e-0f180440a4f37c8-26061951-1fa400-19955bb4b8110e':
        '09ffe91e-b541-4fab-a50f-f61ffa4482e2',
      '$device:19955bb245d13a-0b8ed78328fe1a-26061951-1fa400-19955bb245d13b':
        '9ce39b9f-cbd2-4998-a06a-919a132e94d4',
      '$device:19955bafd1f14a-0b08f87f21e3808-26061951-1fa400-19955bafd2014b':
        '9110b1ca-b8c0-4a42-a657-e51afffd6a1a',
      '$device:19955bad5ba133-0d5231d1527a2b-26061951-1fa400-19955bad5bb133':
        'ae51e7ba-4ee4-44c1-9c9b-96564874c779',
      '$device:19955e37ccc118-0352ff6d89011e8-26061951-1fa400-19955e37ccc118':
        '89974009-8193-441a-867d-135a69d5a0c1',
      '$device:19955e3555f118-0d5102e233c427-26061951-1fa400-19955e3555f118':
        '991b1abf-77ef-48af-be6a-10ca128d88a3',
      '$device:19955e32de9e9-0148d6184ba55f-26061951-1fa400-19955e32deae9':
        'fe7bf7c1-71fd-4636-a3fd-970a240ac0dc',
      '$device:19955e306c610f-0c6cb94522101c8-26061951-1fa400-19955e306c610f':
        'e60423be-6136-47e0-b7a7-3c4ae36e05c6',
      '$device:19955e2df53ed-0aa43695d2957b-26061951-1fa400-19955e2df53ed':
        '85b2668a-0707-4ef4-8148-c7d29a936d0a',
      '$device:19955e2b82a11f-0f6cd47793ac4-26061951-1fa400-19955e2b82a11f':
        '8fee2f64-7068-40b0-9e19-2aae0a3bd090',
      '$device:19955e290b2f6-0936648dfa2897-26061951-1fa400-19955e290b2f6':
        '2521fa2c-0e95-46ee-b626-8ee27bad4b8e',
      '$device:19955e2696411e-008e9d2975f91f8-26061951-1fa400-19955e2696411e':
        '6be003e5-ab2d-4252-ad35-31b79dd5f2ed',
      '$device:19955e241e6f4-013294944e8e2c8-26061951-1fa400-19955e241e6f4':
        '793748ea-9c80-4241-a7e7-de00c292621a',
      '$device:19955e21abd111-00842e4eb165ec-26061951-1fa400-19955e21abd111':
        'b2345a59-7813-4182-8a00-01431c00f647',
      '$device:19955e1f34af2-0dcbd3e7f1c7d9-26061951-1fa400-19955e1f34af2':
        'bc70d16b-05b8-4639-9397-5604e79f7395',
      '$device:19955e1cc34120-09b162cfacd2b2-26061951-1fa400-19955e1cc34121':
        'd2849e0f-d5c0-47a2-babf-ccc95ec30062',
      '$device:19955e1a4abf1-04b0dd9146f2c-26061951-1fa400-19955e1a4abf1':
        'aead8e75-04d4-487b-9292-c9018ccffb7a',
      '$device:19955e1a4abf1-04b0dd9146f2c-26061951-1fa400-19955e1a4abf1':
        '0c1c3edf-aa37-44e8-ab96-7efe7eeab8fb',
      // Facebook auth users
      '$device:19955e17d7f10a-0b0fa8eed36d4b-26061951-1fa400-19955e17d7f10a':
        '9edd6256-1367-4460-9f90-5fd7eb3966ce',
      '$device:19955e15619f3-0394c289b548e28-26061951-1fa400-19955e15619f3':
        '3c880492-e12b-4da5-bb6c-be491a574789',
      '$device:19955e12f2414c-09d6975e232b148-26061951-1fa400-19955e12f2414c':
        'f77f86f8-a7e9-41ce-826f-b2539118d6e9',
      '$device:19955e1077bf6-011c86d8c7a2be8-26061951-1fa400-19955e1077bf6':
        '0420535b-0490-47f7-a0bc-6a43cd7360d3',
      '$device:19955e0e029f6-09842b71a0ea068-26061951-1fa400-19955e0e029f6':
        '9c59209e-599d-43f9-91ee-8ff3f4705998',
      '$device:19955e0b8def3-006c6f61a4c8aa-26061951-1fa400-19955e0b8dff3':
        'b6cd2ab4-72a6-4cfd-a6cf-c039068cd733',
      '$device:19955e091ab10e-0d345a71da0e34-26061951-1fa400-19955e091ab10e':
        'a60fae45-0904-4d30-bac4-c2b94948808a',
      '$device:19955e06a3cec-0564119276c226-26061951-1fa400-19955e06a3cec':
        '4f879db6-58e9-4ed1-925e-5296b25f06b5',
      '$device:19955e0432a133-06b4a27eabf073-26061951-1fa400-19955e0432a133':
        'fe27acd2-a9b5-4436-91ab-8ec83e1672a8',
      '$device:19955e01baaf5-0a8c958667e2a28-26061951-1fa400-19955e01baaf5':
        '5a912cbb-d07f-4403-a2d9-5210e623d634',
      // Expired Auth Tokens -
      '$device:19955dff48011b-06cd697d16c3f5-26061951-1fa400-19955dff48011b':
        'c14db30a-7b65-4605-852b-3a63fa33b254',
      '$device:19955dfcd0b11b-0467e1d1373ab2-26061951-1fa400-19955dfcd0b11c':
        '03c13673-58ce-4389-b11a-ad13ab511183',
      '$device:19955dfa5a9fe-09f742e1ea1294-26061951-1fa400-19955dfa5a9ff':
        '835b7912-b79f-471a-8674-90724f604659',
      '$device:19955df7e60112-048f14f3b331068-26061951-1fa400-19955df7e60112':
        '6cccb47c-5f9e-4458-b8c2-b27513e10e61',
      '$device:19955df571a119-06b7f49eba51618-26061951-1fa400-19955df571a119':
        'c4de8144-6593-4da1-bd25-7bb479ed4789',
      '$device:19955df2fa7ed-0e4430cbaa4ba28-26061951-1fa400-19955df2fa7ed':
        '4efa94f4-892f-460f-bccd-186230679f8b',
      '$device:19955df0853ee-0408a8350e39248-26061951-1fa400-19955df0853ee':
        '4417de67-795c-4261-986a-228e39d12944',
      '$device:19955dee13d11a-086c171645783f8-26061951-1fa400-19955dee13d11a':
        'd68c1697-bf6e-4171-8d19-6899e22389ea',
      '$device:19955deb9e9118-0b2f27c7b28f49-26061951-1fa400-19955deb9e9118':
        '3860ae43-0678-4069-8a8f-6ecc0e5a7f5c',
      '$device:19955de9279f4-0c1cfcb20dc95-26061951-1fa400-19955de9279f4':
        '52ab74cd-7496-4af1-9c83-1cdad14d9ef5',
      '$device:19955de6b4611e-07b20dcae9a89a-26061951-1fa400-19955de6b4611e':
        '8f6023aa-6f9e-45df-897d-1b52e05fc925',
      '$device:19955de43e911c-05c33af2c559148-26061951-1fa400-19955de43e911c':
        '98c1354d-712f-46ce-8306-8fb5dd5187b6',
      '$device:19955de1cb7145-0d9a8b35d7b7338-26061951-1fa400-19955de1cb7145':
        'b72ccf4b-b10a-4dc7-9b02-b964f5ae1da1',
      '$device:19955ddf54a124-079b49985d0259-26061951-1fa400-19955ddf54a124':
        '1bf7140f-e0df-4c7f-a07f-7d37ad39f243',
      '$device:19955ddcdda116-0bfece7f4d3629-26061951-1fa400-19955ddcddb116':
        '0c22677e-6aee-42a6-ba56-d4d536fa377e',
      '$device:19955dda684108-01d35ad87982208-26061951-1fa400-19955dda684108':
        '5a260dff-ee65-48f6-99c1-c2c5e157e733',
      '$device:19955dd7f3c110-003926ed8bd2348-26061951-1fa400-19955dd7f3c110':
        '67fd790c-54ae-438a-aa15-267c5dd09ab6',
      '$device:19955dd57d9fa-00a2e62d278e928-26061951-1fa400-19955dd57d9fa':
        'ea1ba364-1ef6-4eb8-b5ab-fb0419d118d2',
      '$device:19955dd309c113-06c7a8c188fd5f-26061951-1fa400-19955dd309c113':
        '7619c6f2-746b-418a-9f45-75d586794ef0',
      '$device:19955dd0906f5-0590199a3a7b39-26061951-1fa400-19955dd0906f5':
        'fd98ba22-8d74-43c0-8c3e-871d98d83886',
      '$device:19955dce19cea-079aaf400458a7-26061951-1fa400-19955dce19cea':
        'e345fb90-936b-4b99-8c8f-c3e826e99760',
      '$device:19955dcba5efe-0141780c11a9-26061951-1fa400-19955dcba5efe':
        '984a602e-f2d0-48cf-a2f9-f92d5be452bc',
      '$device:19955dc9353139-078d7433147a638-26061951-1fa400-19955dc9354139':
        '9ed116e8-ea9c-4b41-bba4-0759c27cbb70',
      '$device:19955dc6bb0f0-07209fe988851a-26061951-1fa400-19955dc6bb0f0':
        '47a50d04-c3e0-403f-83cd-e3ec108fe150',
      '$device:19955dc44a3130-03abd2ce7075228-26061951-1fa400-19955dc44a3130':
        'a12b924c-fc0f-489e-a2bf-d3402c2c9680',
      '$device:19955dc1d3d10e-0cd7c3891328cd-26061951-1fa400-19955dc1d3e10e':
        '687c0f89-2729-4712-8f1a-dfa664aac02d',
      '$device:19955dbf5c3ed-0718a55658dce7-26061951-1fa400-19955dbf5c3ed':
        'f6fad58f-e0ef-47c8-8e2a-974cb9057d1b',
      '$device:19955dbce7fed-07fd0b3df6eecc-26061951-1fa400-19955dbce7fed':
        'e53bed92-1013-4ba5-ab57-ec587cf34c97',
      '$device:19955dba749117-06dd8f91d557f98-26061951-1fa400-19955dba749117':
        'ae6755be-0adf-465c-88ef-7169de4007e9',
      '$device:19955db7ffd124-0c83a3118e434f-26061951-1fa400-19955db7ffd124':
        '2ff4a1e0-4b4f-462d-9882-80f43646810a',
      '$device:19955db5877f0-0a7e33096da6e9-26061951-1fa400-19955db5877f0':
        '50552303-8699-4afb-9708-415ba91c0bb3',
      '$device:19955db3133fc-00001bcc8ff005-26061951-1fa400-19955db3133fc':
        '8e48b1cf-8fbd-4578-86ea-9bf99b32c924',
      // Expired Google Auth and Facebook Auth Tokens
      '$device:19955db09d8f1-008cfca1fa653c-26061951-1fa400-19955db09d8f1':
        '472f3bd4-73cd-44da-9980-4f459144ed29',
      '$device:19955dae2a5114-09e0065e614b09-26061951-1fa400-19955dae2a5114':
        'a12e8edc-6b87-4c24-8702-e031f624eea6',
      '$device:19955dabb5a10b-07b45912625a588-26061951-1fa400-19955dabb5a10b':
        '3acceea5-c105-4a31-b59f-79d95918ef15',
      '$device:19955da93ff102-0288e3641a3cfb-26061951-1fa400-19955da93ff103':
        '7640f506-0927-4e99-885c-a4b498ccf14b',
      '$device:19955da6cc0120-015dc9952e53c78-26061951-1fa400-19955da6cc0120':
        'c1d2091c-1d3c-4c64-976f-f3879d0a9e5e',
      '$device:19955da451ff4-09296575105143-26061951-1fa400-19955da451ff4':
        'db58cd5c-dfe7-4a87-a3d5-97e74e1f2708',
      '$device:19955da1df211b-08954399adf097-26061951-1fa400-19955da1df211b':
        'f059b6dd-55fd-4d0a-89d8-c40a5a2e7248',
      '$device:19955d9f6a3115-0cbf15b955a4528-26061951-1fa400-19955d9f6a3115':
        '74a8bdc3-c929-4509-8aee-b151b2456821',
      '$device:19955d9cf5511b-080043593e040c-26061951-1fa400-19955d9cf5511b':
        '990da168-0123-4649-8b13-41478666bcc9',
      '$device:19955d9a7ea10c-0bbaaf479a0f0f8-26061951-1fa400-19955d9a7ea10c':
        'd3248f6e-f3e1-4766-9d7a-8da5074500e5',
    },
    development: {
      '$device:199451a5496160-007bc8cf0ca09a-16525636-4b9600-199451a5496160':
        '8537ac2c-1579-4146-9757-cbe6d8d45d32',
      '$device:199451b78b4e4-0d05d977a24d1a8-16525636-1d73c0-199451b78b4e4':
        '94e9c406-5913-4bab-891e-55b04ea6b06e',
      '$device:19458c32bd219e-0a3144b19cbd36-1e525636-1fa400-19458c32bd219e':
        '2aa5c8d7-265e-4521-94d9-7c2b2c4661b9',
      '$device:199490c27d969-0064d6a43d71d78-16525636-4b9600-199490c27d969':
        '4f5c41a1-5e54-4a7e-b683-4b9a33a33dad',
    },
  },
};
